//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//MUI
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, MenuItem, Popover, Radio, RadioGroup, Select, Snackbar, Tooltip, Typography, useMediaQuery } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//components
import Base64Image from '../../../components/Base64Image/Base64Image';
//scss
import "./MeterReadingCorrectionTable.scss";
import "./AuthorityVerification.scss";
import "../../../style/common.scss";
import "../../GeneralServices/Reconnection/ReconnectionWorkflowDialog.scss";
import "./MeterReadingCorrectionWorkflowDialog.scss";
import "./MeterReadingCorrectionForm.scss";
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
//Services
import { useDispatch, useSelector } from 'react-redux';
import CheckPermissions, {
    canApproveAmountByTierPermissions,
    getServiceModulePaths,
    hasServiceLevelPermission,
    hasWorkflowPermissionForModule,
} from '../../../authorization/authorization';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
import DynamicTable from '../../../components/dynamicTable/DynamicTable';
import Error from '../../../components/error/error';
import ProcessingSummaryTableForCoa from '../../../components/processingSummaryTable/processingSummaryTableForCoa';
import RcoActivityLogDialog, {
    RcoHistoryField,
} from '../../../components/RcoActivityLogDialog/RcoActivityLogDialog';
import RcoActivityLogDetailDialog, {
    ACTIVITY_LOG_TIMELINE_TYPES,
} from '../../../components/activityLog/RcoActivityLogDetailDialog';
import { buildMrcActivityLogDetailRows, normalizeMrcHistoryItem, getMrcHistoryStepName, getMrcHistoryStepProgressId, getMrcHistoryReadingTableFlags, isMrcDocumentsReuploadedHistory, didMrcSiteSurveyHappenAtHistory, findPriorMrcSiteSurveyHistory } from '../../../utils/mrcActivityLogDetail';
import {
    buildActivityLogDetailTotalRow,
} from '../../../utils/activityLogDetail';
import {
    WORKFLOW_MOBILE_MEDIA,
    workflowDialogClassName,
    workflowDialogShellProps,
} from '../../../utils/workflowDialogShell';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
    fetchPaginatedMeterReadingCorrectionNormal,
    firstPage,
    lastPage,
    nextPage,
    previousPage,
    filterProgressId as filterProgressIdNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    resetDateFilter as resetDateFilterNormal,
} from '../../../features/powerComplaints/mrcSlice';
import {
    fetchPaginatedMeterReadingCorrectionOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    filterProgressId as filterProgressIdOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    resetDateFilter as resetDateFilterOverdue,
} from '../../../features/powerComplaints/mrcOverdueSlice';
import pdfIcon from '../../../images/pdfIcon.png';
import {
    convertDatewithTime, convertToObjectArray, dBillAPI, documentValidation, getDocumentBackGroundColor, handleFileUpload, isFileNameImage, isFileNamePdf, isImage, isPdf, numberFormatting, subdivisionName
} from '../../../services/Functions';
import { openMrcBillTab } from '../../../components/ElectricityConsumerBill/openMrcBillTab';
import {
    computeMrcBillPayableAmount,
    fetchMrcBillPaymentQr,
    stashMrcBillPaymentQr,
} from '../../../components/ElectricityConsumerBill/fetchMrcBillPaymentQr';
import OpenBase64ImageInPopup from './MrcOpenBase64ImageInPopup';
import { tableStyle, tableStyleOverDue } from '../../../style/common';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import { openBase64Image } from '../../../services/OpenBase64Image';
import PrintIcon from '@mui/icons-material/Print';
import { extractDiscoCodeFromSubDivisionCode, getInitialAdminOfficeCode } from '../../../utils/adminCompany';
import { SearchIndividualApplication, getFieldStaffDesignations, getWorkforceData } from '../../../network/APIs/APIs';
import MrcDocumentsReadingTable from './MrcDocumentsReadingTable';
// import {
//     MrcSegregationMonthContext,
// } from './MrcSegregationMonthSelect';
import MrcApprovalAmountHint from './MrcApprovalAmountHint';
import MrcCp52PrepareDialog from './MrcCp52PrepareDialog';
import ActionsCell from '../../../components/actionCell/ActionCell';
import downloadCPForm52OfMRCPdf from './downloadCPForm52OfMRCPdf';
import {
    mapMrcDocumentsToReceiptReadingRows,
    printMrcApplicationReceipt,
} from './printMrcApplicationReceipt';
import { downloadMrcEFilePdf } from './downloadMrcEFilePdf';
import { buildMrcEFileExtras } from './buildMrcEFileExtras';
import {
    extractMrcOracleTrackingId,
    formatCp52BillingMonth,
    mapMrcGetCp52ToFormData,
    parseCp52ReferenceNo,
    unwrapMrcCp52Record,
} from './mrcCp52Api';
import {
    buildMrcAuthorityApprovalMeterData,
    buildMrcImageObjectionRemarks,
    buildMrcSiteSurveyMeterData,
    buildMrcVerifyMeterData,
    enrichCp52BaseDataFromDocuments,
    extractMrcHistoryMeterSnapshot,
    getMrcImageVerificationState,
    historyMeterHasSiteSurvey,
    MRC_DOCUMENT_VERIFIED_REMARK,
    // MRC_SEGREGATION_MONTH_DEFAULT,
    // normalizeMrcSegregationMonth,
    parseMrcIsDocumentReuploaded,
    // pickMrcSegregationMonth,
    // withMrcNoOfMonths,
    resolveMrcHistoryReadingDocuments,
    resolveMrcTariffDisplay,
} from './mrcReadingUtils';
// import { InfoIcon } from 'lucide-react';
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


//#endregion

const resolveMrcStepProgressId = (progressId, stepName) => {
    if (progressId != null && progressId !== '') {
        const parsed = Number(progressId);
        if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 6) return parsed;
    }
    const name = String(stepName || '');
    if (/re-?upload/i.test(name) || /submission|submitted|uploading/i.test(name)) return 0;
    if (/document/i.test(name)) return 1;
    if (/authority/i.test(name)) return 2;
    if (/site survey|field survey/i.test(name)) return 3;
    if (/forward/i.test(name)) return 4;
    if (/post/i.test(name)) return 5;
    if (/completed/i.test(name)) return 6;
    return null;
};

const getMrcStepDesignationTooltip = (progressId, stepName) => {
    const name = String(stepName || '');
    if (/re-?upload/i.test(name)) {
        return 'This step is to be performed by Customer Service Representative (CSR).';
    }
    switch (resolveMrcStepProgressId(progressId, stepName)) {
        case 0:
            return 'This step is to be performed by Customer Service Representative (CSR).';
        case 1:
            return "This step is to be performed by CSR, CSL, CSM (CFC's).";
        case 2:
            return 'This step is to be performed by SDO / XEN / SE / CEO.';
        case 3:
            return 'This step is to be performed by Meter Inspector (MI) / XEN (M&T).';
        case 4:
            return 'This step is to be performed by SDO / XEN / SE / CEO.';
        case 5:
            return 'This step is to be performed by RO / DCM / DC.';
        case 6:
            return 'This application is completed. No further action is required.';
        default:
            return '';
    }
};

const MrcStepWhoHint = ({ progressId, stepName }) => {
    const title = getMrcStepDesignationTooltip(progressId, stepName);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    if (!title) return null;
    return (
        <>
            <IconButton
                type="button"
                size="small"
                className="mrc-approval-hint-btn"
                aria-label={title}
                onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(open ? null : e.currentTarget);
                }}
            >
                <InfoOutlinedIcon fontSize="small" />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                marginThreshold={12}
                disableScrollLock
                PaperProps={{ className: "mrc-step-who-popover" }}
            >
                <p className="mrc-step-who-popup">{title}</p>
            </Popover>
        </>
    );
};

/** PDF uploads show pdf icon; images show thumbnail (magic-byte aware). */
const renderMrcDocThumbnail = (src) => {
    if (!src) return null;
    if (isPdf(src)) {
        return <Base64Image data={pdfIcon} width="40" />;
    }
    if (
        isImage(src) ||
        (typeof src === "string" && src.slice(0, 6) === "data:i")
    ) {
        return <Base64Image data={src} width="80" height="120" />;
    }
    return <Base64Image data={pdfIcon} width="40" />;
};

const MeterReadingCorrection = forwardRef((props, ref) => {
    const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);

    //#region initial values
    const initialValues = {
        iv_proceed_application: 1,
        iv_off_peak_import_new_reading: '',
        iv_off_peak_export_new_reading: '',
        iv_peak_import_new_reading: '',
        iv_peak_export_new_reading: '',
        iv_off_peak_import_new_reading_image: '',
        iv_off_peak_export_new_reading_image: '',
        iv_peak_import_new_reading_image: '',
        iv_peak_export_new_reading_image: '',

        //objection 
        iv_reason_for_objection: '',

        //single phase meter mnt report
        iv_meter_no: '',
        iv_make: '',
        iv_amp: '',
        iv_meter_cons_imp: '',
        iv_reading: '',
        iv_mdi_c: '',
        iv_mdi_p: '',
        iv_sanctioned_load: '',
        iv_connected_load: '',
        iv_remarks: '',

        //three phase meter mnt report
        iv_amr_meter_no: '',
        iv_amr_meter_make: '',
        iv_amr_meter_model: '',
        iv_amr_meter_amp: '',
        iv_amr_meter_cons_imp: '',
        iv_amr_tl_kwh_reading: '',
        iv_amr_t1_kwh_reading: '',
        iv_amr_t2_kwh_reading: '',
        iv_amr_tl_kvarh_reading: '',
        iv_amr_t1_kvarh_reading: '',
        iv_amr_t2_kvarh_reading: '',
        iv_amr_tl_mdi: '',
        iv_amr_t1_mdi: '',
        iv_amr_t2_mdi: '',
        iv_amr_tl_mdi_cum: '',
        iv_amr_t1_mdi_cum: '',
        iv_amr_t2_mdi_cum: '',
        iv_amr_reset_no: '',
        iv_amr_status: '',
        iv_tod_meter_no: '',
        iv_tod_meter_make: '',
        iv_tod_meter_model: '',
        iv_tod_meter_amp: '',
        iv_tod_meter_cons_imp: '',
        iv_tod_tl_kwh_reading: '',
        iv_tod_t1_kwh_reading: '',
        iv_tod_t2_kwh_reading: '',
        iv_tod_tl_kvarh_reading: '',
        iv_tod_t1_kvarh_reading: '',
        iv_tod_t2_kvarh_reading: '',
        iv_tod_tl_mdi: '',
        iv_tod_t1_mdi: '',
        iv_tod_t2_mdi: '',
        iv_tod_tl_mdi_cum: '',
        iv_tod_t1_mdi_cum: '',
        iv_tod_t2_mdi_cum: '',
        iv_tod_reset_no: '',
        iv_tod_status: '',
        // iv_sanctioned_load:'',
        // iv_connected_load:'',
        iv_lt_bushes: '',
        iv_capacity_of_tf: '',
        iv_amr_reading_peak: '',
        iv_amr_reading_offpeak: '',
        iv_amr_reading_date: '',
        iv_bill_reading_peak: '',
        iv_bill_reading_offpeak: '',
        // iv_remarks:''

        //field survey

        //Single Phase
        iv_singlePhaseSurveyReading: '',
        iv_singlePhaseSurveyReadingImage: '',

        // Three Phase
        iv_threePhaseSurveyOffPeakReading: '',
        iv_threePhaseSurveyOffPeakReadingImage: '',
        iv_threePhaseSurveyPeakReading: '',
        iv_threePhaseSurveyPeakReadingImage: '',

        // Net Meter
        iv_netMeterSurveyOffPeakImportReading: '',
        iv_netMeterSurveyOffPeakImportReadingImage: '',
        iv_netMeterSurveyPeakImportReading: '',
        iv_netMeterSurveyPeakImportReadingImage: '',
        iv_netMeterSurveyOffPeakExportReading: '',
        iv_netMeterSurveyOffPeakExportReadingImage: '',
        iv_netMeterSurveyPeakExportReading: '',
        iv_netMeterSurveyPeakExportReadingImage: '',

        // Three Phase MDI 
        iv_threePhaseMDISurveyOffPeakReading: '',
        iv_threePhaseMDISurveyOffPeakReadingImage: '',
        iv_threePhaseMDISurveyPeakReading: '',
        iv_threePhaseMDISurveyPeakReadingImage: '',
        iv_threePhaseMDISurveykVArhOffPeakReading: '',
        iv_threePhaseMDISurveykVArhOffPeakReadingImage: '',
        iv_threePhaseMDISurveykVArhPeakReading: '',
        iv_threePhaseMDISurveykVArhPeakReadingImage: '',

        // Three Phase MDI Net Meter
        iv_threePhaseMDINetMeterSurveyOffPeakImportReading: '',
        iv_threePhaseMDINetMeterSurveyOffPeakImportReadingImage: '',
        iv_threePhaseMDINetMeterSurveyPeakImportReading: '',
        iv_threePhaseMDINetMeterSurveyPeakImportReadingImage: '',
        iv_threePhaseMDINetMeterSurveykVArhOffPeakImportReading: '',
        iv_threePhaseMDINetMeterSurveykVArhPeakImportReading: '',

        iv_threePhaseMDINetMeterSurveyOffPeakExportReading: '',
        iv_threePhaseMDINetMeterSurveyOffPeakExportReadingImage: '',
        iv_threePhaseMDINetMeterSurveyPeakExportReading: '',
        iv_threePhaseMDINetMeterSurveyPeakExportReadingImage: '',
        iv_threePhaseMDINetMeterSurveykVArhOffPeakExportReading: '',
        iv_threePhaseMDINetMeterSurveykVArhPeakExportReading: '',
    }
    //#endregion

    //#region get item local storage 
    const { token, code: officeCode, hierarchy: officeHierarchy, userId, permissions, selectedAdminCompanyCode } = useSelector((state) => state.auth)
    const location = useLocation();
    const currentPath = location.pathname;
    const [selectedOfficeCode, setSelectedOfficeCode] = useState(
        getInitialAdminOfficeCode(officeCode, selectedAdminCompanyCode),
    );
    const [allTariffList, setAllTariffList] = useState([]);
    const apiOfficeCode = selectedOfficeCode || officeCode;

    useEffect(() => {
        if (String(officeCode) === "10" && selectedAdminCompanyCode) {
            setSelectedOfficeCode(String(selectedAdminCompanyCode));
        }
    }, [officeCode, selectedAdminCompanyCode]);

    const callTariffList = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            const response = await fetch(
                cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
                {
                    method: "POST",
                    redirect: "follow",
                    headers: myHeaders,
                },
            );
            const result = await response.json();
            if (result?.data && Array.isArray(result.data)) {
                setAllTariffList(result.data);
                return result.data;
            }
            setAllTariffList([]);
            return [];
        } catch (e) {
            setAllTariffList([]);
            return [];
        }
    };

    useEffect(() => {
        if (token) {
            callTariffList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const dispatch = useDispatch();
    const {
        currentPage,
        data,
        pageSize,
        totalPages,
        dateFrom,
        dateTo,
        totalRecords,
        applicationProgressId,
        loadFrom,
        loadTo,
        isLoading,
    } = useSelector((state) => state.mrcPaginated);
    const {
        currentPage: currentPageOverdue,
        data: dataOverdue,
        pageSize: pageSizeOverdue,
        totalPages: totalPagesOverdue,
        dateFrom: dateFromOverdue,
        dateTo: dateToOverdue,
        totalRecords: totalRecordsOverdue,
        applicationProgressId: applicationProgressIdOverdue,
        loadFrom: loadFromOverdue,
        loadTo: loadToOverdue,
        isLoading: isLoadingOverdue,
    } = useSelector((state) => state.mrcOverduePaginated);

    const handleNextPage = () => {
        dispatch(nextPage());
    };

    const handlePreviousPage = () => {
        dispatch(previousPage());
    };

    const handleFirstPage = () => {
        dispatch(firstPage());
    };

    const handleLastPage = (page) => {
      dispatch(lastPage(typeof page === 'number' ? page : totalPages));
    };

    const handleDateFromFilterNormal = (value) => {
        if (value) {
            dispatch(firstPage())
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilterNormal = (value) => {
        if (value) {
            dispatch(firstPage())
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilterNormal = () => {
        dispatch(firstPage())
        dispatch(resetDateFilterNormal())
    }

    const handleNextPageOverdue = () => {
        dispatch(nextPageOverdue());
    };

    const handlePreviousPageOverdue = () => {
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = (page) => {
        dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            dispatch(firstPageOverdue())
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            dispatch(firstPageOverdue())
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(firstPageOverdue())
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            dispatch(firstPageOverdue())
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(firstPageOverdue())
        dispatch(resetProgressIdFilterOverdue())
    }

    useEffect(() => {
        if (props.showTable && currentPath === "/meter-reading-correction-table" && token && apiOfficeCode) {
            dispatch(fetchPaginatedMeterReadingCorrectionNormal({
                page: currentPage,
                pageSize: pageSize,
                dateFrom: dateFrom,
                dateTo: dateTo,
                applicationProgressId: applicationProgressId,
                loadFrom: loadFrom,
                loadTo: loadTo,
                officeCode: apiOfficeCode,
            }));
        }
    }, [currentPage, pageSize, dateFrom, dateTo, applicationProgressId, loadFrom, loadTo, apiOfficeCode, props.showTable, currentPath, token]);

    useEffect(() => {
        if (props.showTable && currentPath === "/meter-reading-correction-table" && token && apiOfficeCode) {
            dispatch(fetchPaginatedMeterReadingCorrectionOverdue({
                page: currentPageOverdue,
                pageSize: pageSizeOverdue,
                dateFrom: dateFromOverdue,
                dateTo: dateToOverdue,
                applicationProgressId: applicationProgressIdOverdue,
                loadFrom: loadFromOverdue,
                loadTo: loadToOverdue,
                officeCode: apiOfficeCode,
            }));
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, loadFromOverdue, loadToOverdue, apiOfficeCode, props.showTable, currentPath, token]);

    useEffect(() => {
        const rows = Array.isArray(data) ? data : [];
        // setMrcComplaints(rows.map(withMrcNoOfMonths));
        setMrcComplaints(rows);
    }, [data])

    useEffect(() => {
        const rows = Array.isArray(dataOverdue) ? dataOverdue : [];
        // setMrcComplaintsOverdue(rows.map(withMrcNoOfMonths));
        setMrcComplaintsOverdue(rows);
    }, [dataOverdue])

    //#endregion

    //#region states 
    const mrcStatusBar = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMISSION',
            tooltip: getMrcStepDesignationTooltip(0),
        },
        {
            title1: 'DOCUMENT',
            title2: 'VERIFICATION',
            tooltip: getMrcStepDesignationTooltip(1),
        },
        {
            title1: 'AUTHORITY',
            title2: 'VERIFICATION',
            tooltip: getMrcStepDesignationTooltip(2),
        },
        {
            title1: 'SITE',
            title2: 'SURVEY',
            tooltip: getMrcStepDesignationTooltip(3),
        },
        {
            title1: 'FORWARD',
            title2: 'FOR BILLING',
            tooltip: getMrcStepDesignationTooltip(4),
        },
        {
            title1: 'POST FOR',
            title2: 'BILLING',
            tooltip: getMrcStepDesignationTooltip(5),
        },
        {
            title1: 'COMPLETED',
            title2: '',
            tooltip: getMrcStepDesignationTooltip(6),
        },
    ]
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [flag_offPeakImportImg, setFlag_offPeakImportImg] = useState(null);
    const [flag_offPeakExportImg, setFlag_offPeakExportImg] = useState(null);
    const [flag_peakImportImg, setFlag_peakImportImg] = useState(null);
    const [flag_peakExportImg, setFlag_peakExportImg] = useState(null);
    const [offPeakImportImgVerifyPopUp, setOffPeakImportImgVerifyPopUp] = useState(false);
    const [offPeakExpVerifyPopUp, setOffPeakExpVerifyPopUp] = useState(false);
    const [peakImportImgVerifyPopUp, setPeakImportImgVerifyPopUp] = useState(false);
    const [peakExpVerifyPopUp, setPeakExpVerifyPopUp] = useState(false);
    const [eFileData, setEFileData] = useState([]);
    const [eFileCurrentStatus, setEFileCurrentStatus] = useState({});
    const [mrcTotalDuration, setMrcTotalDuration] = useState('-');
    const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
    const [activityLogDetailOpen, setActivityLogDetailOpen] = useState(false);
    // MRC only: Activity Log collapsed by default so reading table has more width
    const [activityLogCollapsed, setActivityLogCollapsed] = useState(true);
    const [historyData, setHistoryData] = useState(null);
    const [historyDetailPopUp, setHistoryDetailPopUp] = useState(false);
    const [historyReadingDocuments, setHistoryReadingDocuments] = useState([]);
    const [historyReadingLoading, setHistoryReadingLoading] = useState(false);
    const [isBillPosted, setIsBillPosted] = useState(false)
    const [isCheckedRejectApplication, setIsCheckedRejectApplication] = useState(false);

    //#region initial readings
    const [singlePhaseInitialReadings, setSinglePhaseInitialReadings] = useState({
        applicationId: "",
        previousReadingSinglePhase: "",
        currentReadingSinglePhase: "",
        claimedReadingSinglePhase: "",
        claimedReadingSinglePhaseImage: ""
    })

    const [threePhaseInitialReadings, setThreePhaseInitialReadings] = useState({
        applicationId: "",
        previousOffPeakThreePhase: "",
        previousPeakThreePhase: "",
        currentOffPeakThreePhase: "",
        currentPeakThreePhase: "",
        claimedOffPeakThreePhase: "",
        claimedPeakThreePhase: "",
        claimedOffPeakThreePhaseImage: "",
        claimedPeakThreePhaseImage: ""
    })

    const [netMeterInitialReadings, setNetMeterInitialReadings] = useState({
        applicationId: "",
        previousOffpeakImport: "",
        previousPeakImport: "",
        previousOffpeakExport: "",
        previousPeakExport: "",
        currentOffpeakImport: "",
        currentPeakImport: "",
        currentOffpeakExport: "",
        currentPeakExport: "",
        claimedOffpeakImport: "",
        claimedPeakImport: "",
        claimedOffpeakExport: "",
        claimedPeakExport: "",
        claimedOffpeakImportImage: "",
        claimedPeakImportImage: "",
        claimedOffpeakExportImage: "",
        claimedPeakExportImage: ""
    })

    const [threePhaseMDIInitialReadings, setThreePhaseMDIInitialReadings] = useState({
        applicationId: "",
        previousOffPeakThreePhaseMdi: "",
        previousPeakThreePhaseMdi: "",
        previouskVArhOffPeakThreePhaseMdi: "",
        previouskVArhPeakThreePhaseMdi: "",
        previousMdiOffPeakThreePhaseMdi: "",
        previousMdiPeakThreePhaseMdi: "",
        currentOffPeakThreePhaseMdi: "",
        currentPeakThreePhaseMdi: "",
        currentkVArhOffPeakThreePhaseMdi: "",
        currentkVArhPeakThreePhaseMdi: "",
        currentMdiOffPeakThreePhaseMdi: "",
        currentMdiPeakThreePhaseMdi: "",
        claimedOffPeakThreePhaseMdi: "",
        claimedPeakThreePhaseMdi: "",
        claimedkVArhOffPeakThreePhaseMdi: "",
        claimedkVArhPeakThreePhaseMdi: "",
        claimedMdiOffPeakThreePhaseMdi: "",
        claimedMdiPeakThreePhaseMdi: "",
        claimedOffPeakThreePhaseMdiImage: "",
        claimedPeakThreePhaseMdiImage: "",
        claimedkVArhOffPeakThreePhaseMdiImage: "",
        claimedkVArhPeakThreePhaseMdiImage: "",
        claimedMdiOffPeakThreePhaseMdiImage: null,
        claimedMdiPeakThreePhaseMdiImage: null
    })

    const [threePhaseMDINetMeterInitialReadings, setThreePhaseMDINetMeterInitialReadings] = useState({
        applicationId: "",
        previousOffPeakThreePhaseMdiImport: "",
        previousPeakThreePhaseMdiImport: "",
        previouskVArhOffPeakThreePhaseMdiImport: "",
        previouskVArhPeakThreePhaseMdiImport: "",
        previousMdiOffPeakThreePhaseMdiImport: "",
        previousMdiPeakThreePhaseMdiImport: "",
        currentOffPeakThreePhaseMdiImport: "",
        currentPeakThreePhaseMdiImport: "",
        currentkVArhOffPeakThreePhaseMdiImport: "",
        currentkVArhPeakThreePhaseMdiImport: "",
        currentMdiOffPeakThreePhaseMdiImport: "",
        currentMdiPeakThreePhaseMdiImport: "",
        claimedOffPeakThreePhaseMdiImport: "",
        claimedPeakThreePhaseMdiImport: "",
        claimedkVArhOffPeakThreePhaseMdiImport: "",
        claimedkVArhPeakThreePhaseMdiImport: "",
        claimedMdiOffPeakThreePhaseMdiImport: "",
        claimedMdiPeakThreePhaseMdiImport: "",
        claimedOffPeakThreePhaseMdiImageImport: "",
        claimedPeakThreePhaseMdiImageImport: "",
        claimedkVArhOffPeakThreePhaseMdiImageImport: null,
        claimedkVArhPeakThreePhaseMdiImageImport: null,
        claimedMdiOffPeakThreePhaseMdiImageImport: null,
        claimedMdiPeakThreePhaseMdiImageImport: null,
        previousOffPeakThreePhaseMdiExport: "",
        previousPeakThreePhaseMdiExport: "",
        previouskVArhOffPeakThreePhaseMdiExport: "",
        previouskVArhPeakThreePhaseMdiExport: "",
        previousMdiOffPeakThreePhaseMdiExport: "",
        previousMdiPeakThreePhaseMdiExport: "",
        currentOffPeakThreePhaseMdiExport: "",
        currentPeakThreePhaseMdiExport: "",
        currentkVArhOffPeakThreePhaseMdiExport: "",
        currentkVArhPeakThreePhaseMdiExport: "",
        currentMdiOffPeakThreePhaseMdiExport: "",
        currentMdiPeakThreePhaseMdiExport: "",
        claimedOffPeakThreePhaseMdiExport: "",
        claimedPeakThreePhaseMdiExport: "",
        claimedkVArhOffPeakThreePhaseMdiExport: "",
        claimedkVArhPeakThreePhaseMdiExport: "",
        claimedMdiOffPeakThreePhaseMdiExport: "",
        claimedMdiPeakThreePhaseMdiExport: "",
        claimedOffPeakThreePhaseMdiImageExport: "",
        claimedPeakThreePhaseMdiImageExport: "",
        claimedkVArhOffPeakThreePhaseMdiImageExport: null,
        claimedkVArhPeakThreePhaseMdiImageExport: null,
        claimedMdiOffPeakThreePhaseMdiImageExport: null,
        claimedMdiPeakThreePhaseMdiImageExport: null
    })

    //#endregion

    //#region fieldsurvey readings
    const [singlePhaseFieldSurveyReadings, setSinglePhaseFieldSurveyReadings] = useState({
        applicationId: "",
        remarks: "",
        fieldSurveyReadingSinglePhase: "",
        fieldSurveyReadingSinglePhaseImage: "",
    })

    const [threePhaseFieldSurveyReadings, setThreePhaseFieldSurveyReadings] = useState({
        applicationId: "",
        remarks: "",
        fieldSurveyOffPeakThreePhase: "",
        fieldSurveyOffPeakThreePhaseImage: "",
        fieldSurveyPeakThreePhaseImage: "",
        fieldSurveyPeakThreePhase: ""
    })

    const [netMeterFieldSurveyReadings, setNetMeterFieldSurveyReadings] = useState({
        applicationId: "",
        remarks: "",
        fieldSurveyOffpeakImport: "",
        fieldSurveyOffpeakImportImage: "",
        fieldSurveyPeakImport: "",
        fieldSurveyPeakImportImage: "",
        fieldSurveyOffpeakExport: "",
        fieldSurveyOffpeakExportImage: "",
        fieldSurveyPeakExport: "",
        fieldSurveyPeakExportImage: ""
    })

    const [threePhaseMDIFieldSurveyReadings, setThreePhaseMDIFieldSurveyReadings] = useState({
        applicationId: "",
        remarks: "",
        fieldSurveyOffPeakThreePhaseMdi: "",
        fieldSurveyPeakThreePhaseMdi: "",
        fieldSurveykVArhPeakThreePhaseMdi: "",
        fieldSurveykVArhOffPeakThreePhaseMdi: "",
        fieldSurveyMdiOffPeakThreePhaseMdi: '',
        fieldSurveyMdiPeakThreePhaseMdi: '',
        fieldSurveyOffPeakThreePhaseMdiImage: "",
        fieldSurveyPeakThreePhaseMdiImage: '',
        fieldSurveykVArhPeakThreePhaseMdiImage: "",
        fieldSurveykVArhOffPeakThreePhaseMdiImage: "",
        fieldSurveyMdiOffPeakThreePhaseMdiImage: '',
        fieldSurveyMdiPeakThreePhaseMdiImage: ""
    })

    const [threePhaseMDINetMeterFieldSurveyReadings, setThreePhaseMDINetMeterFieldSurveyReadings] = useState({
        applicationId: "",
        remarks: "",
        fieldSurveyOffPeakThreePhaseMdiImport: "",
        fieldSurveyPeakThreePhaseMdiImport: "",
        fieldSurveykVArhPeakThreePhaseMdiImport: "",
        fieldSurveykVArhOffPeakThreePhaseMdiImport: "",
        fieldSurveyMdiOffPeakThreePhaseMdiImport: null,
        fieldSurveyMdiPeakThreePhaseMdiImport: null,
        fieldSurveyOffPeakThreePhaseMdiImageImport: "",
        fieldSurveyPeakThreePhaseMdiImageImport: "",
        fieldSurveykVArhPeakThreePhaseMdiImageImport: "",
        fieldSurveykVArhOffPeakThreePhaseMdiImageImport: "",
        fieldSurveyMdiOffPeakThreePhaseMdiImageImport: null,
        fieldSurveyMdiPeakThreePhaseMdiImageImport: null,
        fieldSurveyOffPeakThreePhaseMdiExport: "",
        fieldSurveyPeakThreePhaseMdiExport: "",
        fieldSurveykVArhPeakThreePhaseMdiExport: "",
        fieldSurveykVArhOffPeakThreePhaseMdiExport: "",
        fieldSurveyMdiOffPeakThreePhaseMdiExport: null,
        fieldSurveyMdiPeakThreePhaseMdiExport: null,
        fieldSurveyOffPeakThreePhaseMdiImageExport: "",
        fieldSurveyPeakThreePhaseMdiImageExport: "",
        fieldSurveykVArhPeakThreePhaseMdiImageExport: "",
        fieldSurveykVArhOffPeakThreePhaseMdiImageExport: "",
        fieldSurveyMdiOffPeakThreePhaseMdiImageExport: null,
        fieldSurveyMdiPeakThreePhaseMdiImageExport: null
    })


    //#endregion

    const [mRCStatusBarArray, setMRCStatusBarArray] = useState(mrcStatusBar);
    //const [newConnectionApplications, setNewConnectionApplications] = useState([]);
    const [mrcComplaints, setMrcComplaints] = useState([]);
    const [mrcComplaintsOverdue, setMrcComplaintsOverdue] = useState([]);
    // const [newConnectionApplicationsToDataGrid, setNewConnectionApplicationsToDataGrid] = useState([]);
    const [mrcComplaintsToDataGrid, setMrcComplaintsToDataGrid] = useState([]);
    const [mrcComplaintsOverdueToDataGrid, setMrcComplaintsOverdueToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [isReleventToUser, setIsRelevantToUser] = useState(false);
    const [mrcDocuments, setMrcDocuments] = useState([]);
    const [mrcDocumentsLoading, setMrcDocumentsLoading] = useState(false);
    const [error, setError] = useState();
    const [resultPopup, setResultPopup] = useState(null);
    const [resultPopupTrackingId, setResultPopupTrackingId] = useState('');
    const resultPopupBillContextRef = React.useRef(null);
    const [apiPopup, setApiPopup] = useState({ open: false, type: '', message: '' });

    // Authority Verification step states
    const [authorityDecision, setAuthorityDecision] = useState(''); // 'accept' or 'reject'
    const [referToSiteSurvey, setReferToSiteSurvey] = useState(''); // 'yes' or 'no'
    const [mrcWorkForceData, setMrcWorkForceData] = useState([]);
    const [mrcFieldStaffDesignations, setMrcFieldStaffDesignations] = useState([]);
    const [mrcSelectedStaffId, setMrcSelectedStaffId] = useState('');
    const [mrcWorkForceLoading, setMrcWorkForceLoading] = useState(false);
    const [billingApproveRemarks, setBillingApproveRemarks] = useState('');
    const [billingRemarksDialog, setBillingRemarksDialog] = useState({
        open: false,
        action: null, // 'approve' | 'reject'
        context: 'forwardBilling', // 'forwardBilling' | 'authority' | 'postBilling'
    });
    const [billingRemarksDialogError, setBillingRemarksDialogError] = useState('');
    const [mrcCp52Prepared, setMrcCp52Prepared] = useState(false);
    const [mrcForcePrepareCp52, setMrcForcePrepareCp52] = useState(false);
    const [mrcLocalCp52CreatedIds, setMrcLocalCp52CreatedIds] = useState({});
    const [mrcCp52Preparing, setMrcCp52Preparing] = useState(false);
    const [mrcCp52Posting, setMrcCp52Posting] = useState(false);
    const [mrcCp52PrepareDialogOpen, setMrcCp52PrepareDialogOpen] = useState(false);
    const [mrcCp52PrepareResponse, setMrcCp52PrepareResponse] = useState(null);
    const [mrcCp52FormData, setMrcCp52FormData] = useState(null);
    const [mrcCp52OracleTrackingId, setMrcCp52OracleTrackingId] = useState('');
    const authorityReadingTableRef = useRef(null);
    const siteSurveyReadingTableRef = useRef(null);
    // const [mrcSegregationMonth, setMrcSegregationMonth] = useState(
    //     MRC_SEGREGATION_MONTH_DEFAULT
    // );

    // const handleMrcSegregationMonthChange = (event) => {
    //     const next = normalizeMrcSegregationMonth(event?.target?.value ?? event);
    //     const prev = normalizeMrcSegregationMonth(mrcSegregationMonth);
    //     if (next === prev) return;
    //     setMrcSegregationMonth(next);
    //     const appId = dialogRowData?.applicationId;
    //     setDialogRowData((prevRow) => ({
    //         ...prevRow,
    //         noOfMonths: next,
    //     }));
    //     if (appId) {
    //         const patchRow = (row) =>
    //             row?.applicationId === appId ? { ...row, noOfMonths: next } : row;
    //         setMrcComplaints((prevRows) =>
    //             Array.isArray(prevRows) ? prevRows.map(patchRow) : prevRows
    //         );
    //         setMrcComplaintsOverdue((prevRows) =>
    //             Array.isArray(prevRows) ? prevRows.map(patchRow) : prevRows
    //         );
    //     }
    //     if (Number(dialogRowData?.applicationProgressId) === 5) {
    //         setMrcCp52Prepared(false);
    //         setMrcForcePrepareCp52(true);
    //         setMrcCp52PrepareDialogOpen(false);
    //         setMrcCp52Preparing(false);
    //     }
    // };

    // Workflow Permissions / Approval Authorities as assigned in Role Management:
    // Document Submission, Document Verification, Authority Verification, Site Survey,
    // Forward For Billing, Post For Billing,
    // Approval Authorities → 1 - 50000, 50001 - 300000, 300001 - 1000000, 1000001 - MAX
    const mrcApprovalAmountRanges = [
        { max: 50000, perm: '1 - 50000' },
        { max: 300000, perm: '50001 - 300000' },
        { max: 1000000, perm: '300001 - 1000000' },
        { max: Number.MAX_SAFE_INTEGER, perm: '1000001 - MAX' },
    ];

    const mrcApprovalModulePaths = [
        ['Billing and Collection', 'Meter Reading Correction', 'Workflow Permissions', 'Approval Authorities'],
        ['Billing and Collection', 'Meter Reading Correction', 'Workflow Permissions'],
        ['Billing and Collection', 'Meter Reading Correction'],
        ...getServiceModulePaths('Meter Reading Correction'),
    ];

    const getMrcPermissionLabel = (node) =>
        node?.name || node?.permissionName || node?.permission_name || node?.label || '';

    const compactMrcPermName = (value) =>
        String(value ?? '')
            .trim()
            .toLowerCase()
            .replace(/,/g, '')
            .replace(/\u00a0/g, ' ')
            .replace(/[–—−]/g, '-')
            .replace(/[^a-z0-9-]+/g, '');

    const getMrcPermissionChildren = (node) => {
        const raw = node?.children;
        if (Array.isArray(raw)) return raw;
        if (typeof raw === 'string' && raw.trim()) {
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const collectPermissionLabels = (nodes, bucket = []) => {
        (nodes || []).forEach((node) => {
            const label = getMrcPermissionLabel(node);
            if (label) bucket.push(label);
            collectPermissionLabels(getMrcPermissionChildren(node), bucket);
        });
        return bucket;
    };

    const findMrcServiceNode = (nodes = permissions) => {
        for (const node of nodes || []) {
            if (compactMrcPermName(getMrcPermissionLabel(node)) === compactMrcPermName('Meter Reading Correction')) {
                return node;
            }
            const nested = findMrcServiceNode(getMrcPermissionChildren(node));
            if (nested) return nested;
        }
        return null;
    };

    const collectAllPermissionNodes = (nodes, bucket = []) => {
        (nodes || []).forEach((node) => {
            if (!node) return;
            bucket.push(node);
            collectAllPermissionNodes(getMrcPermissionChildren(node), bucket);
        });
        return bucket;
    };

    const collectMrcPermissionLabels = () => {
        const allNodes = collectAllPermissionNodes(permissions);
        const mrcNode = findMrcServiceNode(permissions);
        const labels = new Set();

        const addNodeTree = (node) => {
            if (!node) return;
            const label = getMrcPermissionLabel(node);
            if (label) labels.add(label);
            getMrcPermissionChildren(node).forEach(addNodeTree);
        };
        addNodeTree(mrcNode);

        const byId = new Map();
        allNodes.forEach((node) => {
            if (node?.idt != null && node?.idt !== '') {
                byId.set(String(node.idt), node);
            }
        });
        const mrcId = mrcNode?.idt != null ? String(mrcNode.idt) : null;
        allNodes.forEach((leaf) => {
            const leafLabel = getMrcPermissionLabel(leaf);
            if (leafLabel) {
                const compact = compactMrcPermName(leafLabel);
                if (
                    compact === compactMrcPermName('Meter Reading Correction') ||
                    compact === compactMrcPermName('Approval Authorities') ||
                    mrcApprovalAmountRanges.some(
                        ({ perm }) => compact === compactMrcPermName(perm),
                    )
                ) {
                    labels.add(leafLabel);
                }
            }

            let current = leaf;
            const seen = new Set();
            while (
                current &&
                current.parent_idt != null &&
                current.parent_idt !== '' &&
                current.parent_idt !== 'null'
            ) {
                const parentKey = String(current.parent_idt);
                if (seen.has(parentKey)) break;
                seen.add(parentKey);
                if (mrcId && parentKey === mrcId) {
                    if (leafLabel) labels.add(leafLabel);
                    break;
                }
                const parent = byId.get(parentKey);
                if (!parent) break;
                if (
                    compactMrcPermName(getMrcPermissionLabel(parent)) ===
                    compactMrcPermName('Meter Reading Correction')
                ) {
                    if (leafLabel) labels.add(leafLabel);
                    break;
                }
                current = parent;
            }
        });

        return [...labels];
    };

    const hasMrcNamedPermission = (...names) => {
        const targets = new Set(names.map(compactMrcPermName).filter(Boolean));
        if (!targets.size) return false;

        for (const name of names) {
            if (
                CheckPermissions(
                    permissions,
                    'Billing and Collection',
                    'Meter Reading Correction',
                    'Workflow Permissions',
                    name,
                ) ||
                CheckPermissions(
                    permissions,
                    'Billing and Collection',
                    'Meter Reading Correction',
                    'Basic Permissions',
                    name,
                ) ||
                CheckPermissions(
                    permissions,
                    'Billing and Collection',
                    'Meter Reading Correction',
                    name,
                ) ||
                hasWorkflowPermissionForModule(
                    permissions,
                    getServiceModulePaths('Meter Reading Correction'),
                    'Workflow Permissions',
                    name,
                ) ||
                hasServiceLevelPermission(
                    permissions,
                    'Meter Reading Correction',
                    'Workflow Permissions',
                    name,
                ) ||
                hasServiceLevelPermission(
                    permissions,
                    'Meter Reading Correction',
                    'Basic Permissions',
                    name,
                ) ||
                hasServiceLevelPermission(
                    permissions,
                    'Meter Reading Correction',
                    name,
                )
            ) {
                return true;
            }
        }

        return collectMrcPermissionLabels().some((label) =>
            targets.has(compactMrcPermName(label)),
        );
    };

    const parseMrcAmount = (value) => {
        if (typeof value === 'number' && Number.isFinite(value)) return value;
        const text = String(value ?? '').trim();
        if (!text || text === '-' || text === 'null' || text === 'undefined') {
            return NaN;
        }
        // Amount Payable comes as 7,733 — strip every comma-like thousands
        // separator before matching MRC Approval Authorities.
        const cleaned = text
            .replace(/[,\u066C\uFF0C\u201A\u02BC']/g, '')
            .replace(/[\u00A0\u202F\u2009\s]/g, '');
        const amount = Number(cleaned);
        return Number.isFinite(amount) ? amount : NaN;
    };

    const getMrcAmountPayable = (row = {}) =>
        parseMrcAmount(
            row.payableWithinDueDate ??
                row.amountPayable ??
                row.payableAmount ??
                row.currentBillAmount ??
                row.billAmount,
        );

    const getMrcAuthorityDesignationForAmount = (rowOrAmount) => {
        const amount = Math.abs(
            typeof rowOrAmount === 'object' && rowOrAmount !== null
                ? getMrcAmountPayable(rowOrAmount)
                : parseMrcAmount(rowOrAmount),
        );
        if (!Number.isFinite(amount) || amount <= 0) {
            return 'SDO / XEN / SE / GM (C & CS)';
        }
        if (amount <= 50000) return 'SDO';
        if (amount <= 300000) return 'XEN';
        if (amount <= 1000000) return 'SE';
        return 'GM (C & CS)';
    };

    const parseMrcApprovalTierMax = (label) => {
        const compact = compactMrcPermName(label);
        if (!compact) return 0;
        if (compact.includes('max') && /\d/.test(compact)) {
            return Number.MAX_SAFE_INTEGER;
        }
        const raw = String(label ?? '').toLowerCase();
        if (!/-|to|upto|above/.test(compact) && !/-|to|upto|above/.test(raw)) {
            return 0;
        }
        const nums = compact.match(/\d+/g);
        if (!nums?.length) return 0;
        return Math.max(...nums.map(Number));
    };

    const getMrcGrantedApprovalLimit = () => {
        const labels = collectMrcPermissionLabels();
        const granted = new Set(labels.map(compactMrcPermName));

        if (
            granted.has(compactMrcPermName('1000001 - MAX')) ||
            granted.has(compactMrcPermName('1000001-MAX'))
        ) {
            return Number.MAX_SAFE_INTEGER;
        }

        let highestLimit = 0;
        mrcApprovalAmountRanges.forEach(({ max, perm }) => {
            if (compactMrcPermName(perm).includes('max')) return;
            if (granted.has(compactMrcPermName(perm))) {
                highestLimit = Math.max(highestLimit, max);
            }
        });
        labels.forEach((label) => {
            const compact = compactMrcPermName(label);
            // Parent folder "Approval Authorities" is not itself a limit.
            if (compact === compactMrcPermName('Approval Authorities')) return;
            highestLimit = Math.max(highestLimit, parseMrcApprovalTierMax(label));
        });
        return highestLimit;
    };

    const hasMrcAmountApprovalFor = (amountPayable) => {
        if (
            hasMrcNamedPermission(
                '1000001 - MAX',
                '1000001-MAX',
            )
        ) {
            return true;
        }

        const amount = parseMrcAmount(amountPayable);
        const approvalAmount = Number.isFinite(amount) ? Math.abs(amount) : 0;
        const highestLimit = getMrcGrantedApprovalLimit();

        if (
            approvalAmount > 0 &&
            canApproveAmountByTierPermissions(
                permissions,
                mrcApprovalModulePaths,
                mrcApprovalAmountRanges,
                approvalAmount,
            )
        ) {
            return true;
        }

        if (highestLimit <= 0) return false;
        return approvalAmount > 0 && approvalAmount <= highestLimit;
    };

    const hasMrcDocumentVerificationPermission = hasMrcNamedPermission(
        'Document Verification',
    );
    const hasMrcBasicUpdatePermission = hasMrcNamedPermission('Update');
    const hasMrcAuthorityVerificationPermission = hasMrcNamedPermission(
        'Authority Verification',
    );
    const hasMrcSiteSurveyPermission = hasMrcNamedPermission('Site Survey');
    const hasMrcForwardForBillingPermission = hasMrcNamedPermission(
        'Forward For Billing',
        'Forward for Billing',
    );
    const hasMrcPostForBillingPermission = hasMrcNamedPermission(
        'Post For Billing',
        'Post for Billing',
    );

    const resolveMrcStepAmount = (rowOrAmount) => {
        if (typeof rowOrAmount === 'object' && rowOrAmount !== null) {
            return getMrcAmountPayable(rowOrAmount);
        }
        if (rowOrAmount != null) return rowOrAmount;
        return getMrcAmountPayable(dialogRowData || {});
    };

    const canPerformMrcAmountGatedStep = (hasStepPermission, rowOrAmount) => {
        if (!hasStepPermission) return false;
        const limit = getMrcGrantedApprovalLimit();
        // Roles with no Approval Authorities tier (e.g. MI / RO) can still do their step.
        if (limit <= 0) return true;
        return hasMrcAmountApprovalFor(resolveMrcStepAmount(rowOrAmount));
    };

    const getMrcInProcessByAmountMessage = (stepName) =>
        `${stepName} is in process by the sanctioned authority (${getMrcAuthorityDesignationForAmount(dialogRowData)}).`;

    const canPerformMrcAuthorityVerification = (rowOrAmount) =>
        hasMrcAuthorityVerificationPermission &&
        hasMrcAmountApprovalFor(resolveMrcStepAmount(rowOrAmount));

    const canPerformMrcSiteSurvey = (rowOrAmount) =>
        canPerformMrcAmountGatedStep(hasMrcSiteSurveyPermission, rowOrAmount);

    const canPerformMrcForwardForBilling = (rowOrAmount) =>
        hasMrcForwardForBillingPermission &&
        hasMrcAmountApprovalFor(resolveMrcStepAmount(rowOrAmount));

    const canPerformMrcPostForBilling = (rowOrAmount) =>
        canPerformMrcAmountGatedStep(hasMrcPostForBillingPermission, rowOrAmount);

    const tableColumnsProcessingSummary = [
        {
            header: 'Step Name',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [unitsToCorrect, setUnitsToCorrect] = useState(null);

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([]);
    const [proceedType, setProceedType] = useState(0);

    const [offPeakImportImage, setOffPeakImportImage] = useState('');
    const [offPeakImportImageFileName, setOffPeakImportImageFileName] = useState('');
    const [offPeakImportImageThumbnail, setOffPeakImportImageThumbnail] = React.useState('');
    const [offPeakExportImage, setOffPeakExportImage] = useState('');
    const [offPeakExportImageFileName, setOffPeakExportImageFileName] = useState('');
    const [offPeakExportImageThumbnail, setOffPeakExportImageThumbnail] = React.useState('');
    const [peakImportImage, setPeakImportImage] = useState('');
    const [peakImportImageFileName, setPeakImportImageFileName] = useState('');
    const [peakImportImageThumbnail, setPeakImportImageThumbnail] = React.useState('');
    const [peakExportImage, setPeakExportImage] = useState('');
    const [peakExportImageFileName, setPeakExportImageFileName] = useState('');
    const [peakExportImageThumbnail, setPeakExportImageThumbnail] = React.useState('');

    const [offPeakImportImagePopUp, setOffPeakImportImagePopUp] = useState(false)
    const [offPeakExportImagePopUp, setOffPeakExportImagePopUp] = useState(false)
    const [peakImportImagePopUp, setPeakImportImagePopUp] = useState(false)
    const [peakExportImagePopUp, setPeakExportImagePopUp] = useState(false)

    const [meterReadingCorrectionData, setMeterReadingCorrectionData] = useState({
        applicationId: "",
        offPeakImportNewReading: "",
        offPeakExportNewReading: "",
        peakImportNewReading: "",
        peakExportNewReading: "",
        submittedBy: "",
        submittedDateTime: "",
        offPeakImportNewReadingImage: "",
        offPeakExportNewReadingImage: "",
        peakImportNewReadingImage: "",
        peakExportNewReadingImage: "",
        modifiedBy: null,
        modifiedDateTime: null
    })

    const [mntReportSinglePhase, setMntReportSinglePhase] = useState(
        {
            applicationId: "",
            refNo: "",
            creationDateTime: "",
            createtBy: "",
            modifiedDateTime: null,
            modifiedBy: null,
            approvedDateTime: null,
            approvedBy: null,
            consumerName: "",
            premisesAddress: "",
            subDivisionCode: "",
            subDivisionName: "",
            tariff: "",
            sanctionedLoad: "",
            connectedLoad: "",
            meterNo: "",
            make: "",
            AMP: "",
            meterConsOrImp: "",
            reading: "",
            mdiC: "",
            mdiP: "",
            remarks: "",
            billMonth1: "",
            billUnits1: "",
            billMonth2: "",
            billUnits2: "",
            billMonth3: "",
            billUnits3: "",
            billMonth4: "",
            billUnits4: "",
            billMonth5: "",
            billUnits5: "",
            billMonth6: "",
            billUnits6: "",
            billMonth7: "",
            billUnits7: "",
            billMonth8: "",
            billUnits8: "",
            billMonth9: "",
            billUnits9: "",
            billMonth10: "",
            billUnits10: "",
            billMonth11: "",
            billUnits11: "",
            billMonth12: "",
            billUnits12: "",
            billMonth13: "",
            billUnits13: ""
        }
    )

    const [mntSiteReportThreePhase, setMntSiteReportThreePhase] = useState(
        {
            applicationId: "",
            refNo: "",
            creationDateTime: "",
            createtBy: "",
            modifiedDateTime: null,
            modifiedBy: null,
            approvedDateTime: null,
            approvedBy: null,
            consumerName: null,
            premisesAddress: "",
            subDivisionCode: "",
            subDivisionName: "",
            tariff: "",
            AMRMeterNo: "",
            AMRMake: "",
            AMRAMP: "",
            AMRMeterConsOrImp: "",
            AMRTlkwhReading: "",
            AMRTlkvarhReading: "",
            AMRTlmdi: "",
            AMRTlmdiCum: "",
            AMRT1kwhReading: "",
            AMRT1kvarhReading: "",
            AMRT1mdi: "",
            AMRT1mdiCum: "",
            AMRT2kwhReading: "",
            AMRT2kvarhReading: "",
            AMRT2mdi: "",
            AMRT2mdiCum: "",
            AMRresetNo: "",
            AMRstatus: "",
            toDMeterNo: "",
            toDMake: "",
            toDMMP: "",
            toDMeterConsOrImp: "",
            tODTlkwhReading: "",
            tODTlkvarhReading: "",
            tODTlmdi: "",
            tODTlmdiCum: "",
            tODT1kwhReading: "",
            tODT1kvarhReading: "",
            tODT1mdi: "",
            tODT1mdiCum: "",
            tODT2kwhReading: "",
            tODT2kvarhReading: "",
            tODT2mdi: "",
            tODT2mdiCum: "",
            tODresetNo: "",
            tODstatus: "",
            tODSanctionLoad: "",
            tODConnectedLoad: "",
            tODLTBushes: "",
            tODCapacityOfTandF: "",
            tODAMRPeakReading: "",
            tODAMROffPeakReading: "",
            tODBillPeakReading: "",
            tODBillOffPeakReading: "",
            tODDate: "",
            remarks: "",
            billMonth1: "",
            billMDI1: "",
            billUnits1: "",
            billMonth2: "",
            billMDI2: "",
            billUnits2: "",
            billMonth3: "",
            billMDI3: "",
            billUnits3: "",
            billMonth4: "",
            billMDI4: "",
            billUnits4: "",
            billMonth5: "",
            billMDI5: "",
            billUnits5: "",
            billMonth6: "",
            billMDI6: "",
            billUnits6: "",
            billMonth7: "",
            billMDI7: "",
            billUnits7: "",
            billMonth8: "",
            billMDI8: "",
            billUnits8: "",
            billMonth9: "",
            billMDI9: "",
            billUnits9: "",
            billMonth10: "",
            billMDI10: "",
            billUnits10: "",
            billMonth11: "",
            billMDI11: "",
            billUnits11: "",
            billMonth12: "",
            billMDI12: "",
            billUnits12: "",
            billMonth13: "",
            billMDI13: "",
            billUnits13: "",
            unitsToBeCharged: null,
            meterCost: null,
            costToBeRecoveredBy: null
        }
    )

    const [billHistInfo, setBillHistInfo] = useState([]);

    const [foundInMRC, setFoundInMRC] = useState();
    const { state } = location;
    const { foundId } = state ? state : '';
    // Single Phase Meter
    const [singlePhaseSurveyReadingImage, setSinglePhaseSurveyReadingImage] = useState();
    const [singlePhaseSurveyReadingImageError, setSinglePhaseSurveyReadingImageError] = useState();
    const [singlePhaseSurveyReadingImageThumbnail, setSinglePhaseSurveyReadingImageThumbnail] = useState('');
    // Three Phase Meter
    const [threePhaseSurveyOffPeakReadingImage, setThreePhaseSurveyOffPeakReadingImage] = useState();
    const [threePhaseSurveyOffPeakReadingImageError, setThreePhaseSurveyOffPeakReadingImageError] = useState();
    const [threePhaseSurveyOffPeakReadingImageThumbnail, setThreePhaseSurveyOffPeakReadingImageThumbnail] = useState('');
    const [threePhaseSurveyPeakReadingImage, setThreePhaseSurveyPeakReadingImage] = useState();
    const [threePhaseSurveyPeakReadingImageError, setThreePhaseSurveyPeakReadingImageError] = useState();
    const [threePhaseSurveyPeakReadingImageThumbnail, setThreePhaseSurveyPeakReadingImageThumbnail] = useState('');
    // Net Meter
    const [netMeterSurveyOffPeakImportReadingImage, setNetMeterSurveyOffPeakImportReadingImage] = useState()
    const [netMeterSurveyOffPeakImportReadingImageError, setNetMeterSurveyOffPeakImportReadingImageError] = useState()
    const [netMeterSurveyOffPeakImportReadingImageThumbnail, setNetMeterSurveyOffPeakImportReadingImageThumbnail] = useState()
    const [netMeterSurveyPeakImportReadingImage, setNetMeterSurveyPeakImportReadingImage] = useState()
    const [netMeterSurveyPeakImportReadingImageError, setNetMeterSurveyPeakImportReadingImageError] = useState()
    const [netMeterSurveyPeakImportReadingImageThumbnail, setNetMeterSurveyPeakImportReadingImageThumbnail] = useState()
    const [netMeterSurveyOffPeakExportReadingImage, setNetMeterSurveyOffPeakExportReadingImage] = useState()
    const [netMeterSurveyOffPeakExportReadingImageError, setNetMeterSurveyOffPeakExportReadingImageError] = useState()
    const [netMeterSurveyOffPeakExportReadingImageThumbnail, setNetMeterSurveyOffPeakExportReadingImageThumbnail] = useState()
    const [netMeterSurveyPeakExportReadingImage, setNetMeterSurveyPeakExportReadingImage] = useState()
    const [netMeterSurveyPeakExportReadingImageError, setNetMeterSurveyPeakExportReadingImageError] = useState()
    const [netMeterSurveyPeakExportReadingImageThumbnail, setNetMeterSurveyPeakExportReadingImageThumbnail] = useState()
    // ThreePhase MDI Meter
    const [threePhaseMDISurveyOffPeakReadingImage, setThreePhaseMDISurveyOffPeakReadingImage] = useState();
    const [threePhaseMDISurveyOffPeakReadingImageError, setThreePhaseMDISurveyOffPeakReadingImageError] = useState();
    const [threePhaseMDISurveyOffPeakReadingImageThumbnail, setThreePhaseMDISurveyOffPeakReadingImageThumbnail] = useState('');
    const [threePhaseMDISurveyPeakReadingImage, setThreePhaseMDISurveyPeakReadingImage] = useState();
    const [threePhaseMDISurveyPeakReadingImageError, setThreePhaseMDISurveyPeakReadingImageError] = useState();
    const [threePhaseMDISurveyPeakReadingImageThumbnail, setThreePhaseMDISurveyPeakReadingImageThumbnail] = useState('');
    const [threePhaseMDISurveykVArhOffPeakReadingImage, setThreePhaseMDISurveykVArhOffPeakReadingImage] = useState();
    const [threePhaseMDISurveykVArhOffPeakReadingImageError, setThreePhaseMDISurveykVArhOffPeakReadingImageError] = useState();
    const [threePhaseMDISurveykVArhOffPeakReadingImageThumbnail, setThreePhaseMDISurveykVArhOffPeakReadingImageThumbnail] = useState('');
    const [threePhaseMDISurveykVArhPeakReadingImage, setThreePhaseMDISurveykVArhPeakReadingImage] = useState();
    const [threePhaseMDISurveykVArhPeakReadingImageError, setThreePhaseMDISurveykVArhPeakReadingImageError] = useState();
    const [threePhaseMDISurveykVArhPeakReadingImageThumbnail, setThreePhaseMDISurveykVArhPeakReadingImageThumbnail] = useState('');
    // Three Phase MDI Net Meter
    const [threePhaseMDINetMeterSurveyOffPeakImportReadingImage, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImage] = useState();
    const [threePhaseMDINetMeterSurveyOffPeakImportReadingImageError, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImageError] = useState();
    const [threePhaseMDINetMeterSurveyOffPeakImportReadingImageThumbnail, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImageThumbnail] = useState('');
    const [threePhaseMDINetMeterSurveyPeakImportReadingImage, setThreePhaseMDINetMeterSurveyPeakImportReadingImage] = useState();
    const [threePhaseMDINetMeterSurveyPeakImportReadingImageError, setThreePhaseMDINetMeterSurveyPeakImportReadingImageError] = useState();
    const [threePhaseMDINetMeterSurveyPeakImportReadingImageThumbnail, setThreePhaseMDINetMeterSurveyPeakImportReadingImageThumbnail] = useState('');
    const [threePhaseMDINetMeterSurveyOffPeakExportReadingImage, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImage] = useState();
    const [threePhaseMDINetMeterSurveyOffPeakExportReadingImageError, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImageError] = useState();
    const [threePhaseMDINetMeterSurveyOffPeakExportReadingImageThumbnail, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImageThumbnail] = useState('');
    const [threePhaseMDINetMeterSurveyPeakExportReadingImage, setThreePhaseMDINetMeterSurveyPeakExportReadingImage] = useState();
    const [threePhaseMDINetMeterSurveyPeakExportReadingImageError, setThreePhaseMDINetMeterSurveyPeakExportReadingImageError] = useState();
    const [threePhaseMDINetMeterSurveyPeakExportReadingImageThumbnail, setThreePhaseMDINetMeterSurveyPeakExportReadingImageThumbnail] = useState('');

    //#endregion

    //#region constants / variables 

    const navigate = useNavigate();

    const objectionList = [
        "Invalid claimed reading.",
        "Images are not clear.",
        "Wrong meter images.",
        "Invalid images."
    ]

    const BillingHistColumns = [{
        header: 'Month',
        accessorKey: 'gbHistMM',
    },
    {
        header: 'Units',
        accessorKey: 'gbHistUnits',
    },
    ]

    const BillingHistColumnsThreePhase = [
        {
            header: 'Month',
            accessorKey: 'gbHistMM',
        },
        {
            header: 'MDI',
            accessorKey: 'gbHistMDI',
        },
        {
            header: 'Units',
            accessorKey: 'gbHistUnits',
        },
    ]

    //#endregion

    //#region api function

    const callChangeProgressIdAPI = async (applicationProgressId, remarks, remarksDetails = '-', id = dialogRowData.applicationId, successKey = 'completed') => {
        var formdata = new FormData();
        formdata.append("applicationId", id);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("modifiedBy", userId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "comman/changeComplaintsProgressId", requestOptions);
            const result = await response.json();
            if (result.status === '200' || result.status === 200) {
                showMrcSuccessPopup(successKey);
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to update application progress.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to update application progress.");
        } finally {
            setViewBackdrop(false);
        }
    }

    const callAuthorityApproval = async ({
        applicationProgressId,
        objectionStatus,
        remarks,
        isAccepted,
        isReferToFieldSurvey,
        assignedTo,
        meterData,
        successKey = 'authorityApproved',
    }) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const payload = {
            applicationId: dialogRowData.applicationId,
            applicationProgressId,
            objectionStatus,
            remarks: remarks ?? "",
            // noOfMonths: normalizeMrcSegregationMonth(
            //     mrcSegregationMonth ?? dialogRowData?.noOfMonths
            // ),
        };
        if (isReferToFieldSurvey !== undefined) {
            payload.isReferToFieldSurvey = isReferToFieldSurvey;
        }
        if (assignedTo !== undefined && assignedTo !== null && assignedTo !== "") {
            payload.assignedTo = assignedTo;
        }
        if (isAccepted !== undefined) {
            payload.isAccepted = isAccepted;
        }
        if (meterData !== undefined) {
            payload.meterData = meterData;
        }

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(payload),
            redirect: "follow",
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "mrc/authorityApproval", requestOptions);
            const result = await response.json();
            if (result.status == "200" || result.status === 200) {
                showMrcSuccessPopup(successKey);
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to submit authority approval.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to submit authority approval.");
        } finally {
            setViewBackdrop(false);
        }
    };

    const submitAuthorityReject = async (remarksOverride) => {
        const remarks = String(remarksOverride ?? "").trim();
        if (!remarks) return;

        await callAuthorityApproval({
            applicationProgressId: dialogRowData.applicationProgressId || 2,
            objectionStatus: 1,
            remarks,
            isAccepted: false,
            isReferToFieldSurvey: false,
            meterData: [],
            successKey: 'authorityRejected',
        });
    };

    const fetchMrcFieldStaff = async () => {
        const office = dialogRowData?.subDivisionCode || apiOfficeCode;
        if (!token || !office) return;
        setMrcWorkForceLoading(true);
        try {
            const [wfData, designations] = await Promise.all([
                getWorkforceData(token, office),
                getFieldStaffDesignations(token),
            ]);
            const staff = (Array.isArray(wfData) ? wfData : []).filter((item) => {
                const roleId = Number(item.roleId ?? item.designation);
                return roleId === 114;
            });
            setMrcWorkForceData(staff);
            setMrcFieldStaffDesignations(Array.isArray(designations) ? designations : []);
        } catch (e) {
            setMrcWorkForceData([]);
        } finally {
            setMrcWorkForceLoading(false);
        }
    };

    const submitAuthorityReferToSiteSurvey = async () => {
        if (!mrcSelectedStaffId) {
            setError("Please select a field staff member before referring to Site Survey.");
            return;
        }
        await callAuthorityApproval({
            applicationProgressId: 3,
            objectionStatus: 0,
            remarks: "Refer to Site Survey.",
            isAccepted: true,
            isReferToFieldSurvey: true,
            assignedTo: mrcSelectedStaffId,
            meterData: [],
            successKey: 'referredToSiteSurvey',
        });
    };

    const submitAuthorityApproveWithoutSurvey = async () => {
        const isValid = authorityReadingTableRef.current?.validateAuthorityClaimed?.() ?? true;
        if (!isValid) {
            setError("Please correct Authority Approved Reading errors before submitting.");
            return;
        }

        const authorityReadings =
            authorityReadingTableRef.current?.getAuthorityReadings?.() ?? {};
        const documents = mrcDocuments.length
            ? mrcDocuments
            : await callAsyncGetMRCDocuments(dialogRowData.applicationId);

        await callAuthorityApproval({
            applicationProgressId: 4,
            objectionStatus: 0,
            remarks: "Approved by Authority",
            isAccepted: true,
            isReferToFieldSurvey: false,
            meterData: buildMrcAuthorityApprovalMeterData(
                documents,
                authorityReadings
            ),
            successKey: 'authorityApproved',
        });
    };

    const callForwardForBilling = async ({
        applicationProgressId,
        objectionStatus,
        remarks,
        isReferToFieldSurvey = false,
        meterData,
        successKey = 'forwardedToBilling',
    }) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const payload = {
            applicationId: dialogRowData.applicationId,
            applicationProgressId,
            objectionStatus,
            remarks: remarks ?? "",
            isReferToFieldSurvey,
            meterData: meterData ?? [],
            // noOfMonths: normalizeMrcSegregationMonth(
            //     mrcSegregationMonth ?? dialogRowData?.noOfMonths
            // ),
        };

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(payload),
            redirect: "follow",
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "mrc/forwardForBilling", requestOptions);
            const result = await response.json();
            if (result.status == "200" || result.status === 200) {
                showMrcSuccessPopup(successKey);
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to forward for billing.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to forward for billing.");
        } finally {
            setViewBackdrop(false);
        }
    };

    const getBillingApproveRemarksOrError = () => {
        const remarks = String(billingApproveRemarks ?? "").trim();
        if (!remarks) {
            setBillingRemarksDialogError("Remarks are required.");
            return null;
        }
        if (remarks.length < 10) {
            setBillingRemarksDialogError("Remarks must be at least 10 characters.");
            return null;
        }
        return remarks;
    };

    const closeForwardBillingRemarksDialog = () => {
        setBillingRemarksDialog({
            open: false,
            action: null,
            context: 'forwardBilling',
        });
        setBillingRemarksDialogError('');
        setBillingApproveRemarks('');
    };

    const openForwardBillingRemarksDialog = (action) => {
        if (action === 'approve' && didMrcSiteSurveyHappen(dialogRowData)) {
            const isValid = authorityReadingTableRef.current?.validateAuthorityClaimed?.() ?? true;
            if (!isValid) {
                setError("Please correct Authority Approved Reading errors before approving.");
                return;
            }
        }
        setError('');
        setBillingApproveRemarks('');
        setBillingRemarksDialogError('');
        setBillingRemarksDialog({
            open: true,
            action,
            context: 'forwardBilling',
        });
    };

    const openAuthorityRejectRemarksDialog = () => {
        setError('');
        setBillingApproveRemarks('');
        setBillingRemarksDialogError('');
        setBillingRemarksDialog({
            open: true,
            action: 'reject',
            context: 'authority',
        });
    };

    const submitForwardToBillingApprove = async (remarksOverride) => {
        const remarks =
            remarksOverride != null
                ? String(remarksOverride).trim()
                : getBillingApproveRemarksOrError();
        if (!remarks) return;

        const fieldSurveyDone = didMrcSiteSurveyHappen(dialogRowData);

        if (fieldSurveyDone) {
            const isValid = authorityReadingTableRef.current?.validateAuthorityClaimed?.() ?? true;
            if (!isValid) {
                setError("Please correct Authority Approved Reading errors before approving.");
                return;
            }
        }

        const authorityReadings =
            authorityReadingTableRef.current?.getAuthorityReadings?.() ?? {};
        const documents = mrcDocuments.length
            ? mrcDocuments
            : await callAsyncGetMRCDocuments(dialogRowData.applicationId);

        // mrc/forwardForBilling → Post for Billing (progressId 5)
        await callForwardForBilling({
            applicationProgressId: 5,
            objectionStatus: 0,
            remarks,
            isReferToFieldSurvey: false,
            meterData: buildMrcAuthorityApprovalMeterData(
                documents,
                authorityReadings
            ),
        });
    };

    const submitForwardToBillingReject = async (remarksOverride) => {
        // Reject only when site survey was referred; send back to Site Survey (progress 3)
        if (!didMrcSiteSurveyHappen(dialogRowData)) return;

        const remarks =
            remarksOverride != null
                ? String(remarksOverride).trim()
                : getBillingApproveRemarksOrError();
        if (!remarks) return;

        const documents = mrcDocuments.length
            ? mrcDocuments
            : await callAsyncGetMRCDocuments(dialogRowData.applicationId);

        await callForwardForBilling({
            applicationProgressId: 3,
            objectionStatus: 0,
            remarks,
            isReferToFieldSurvey: true,
            meterData: buildMrcAuthorityApprovalMeterData(documents, {}),
            successKey: 'returnedToSiteSurvey',
        });
    };

    const confirmForwardBillingRemarksDialog = async () => {
        const remarks = getBillingApproveRemarksOrError();
        if (!remarks) return;

        const action = billingRemarksDialog.action;
        const context = billingRemarksDialog.context || 'forwardBilling';
        closeForwardBillingRemarksDialog();

        if (context === 'authority' && action === 'reject') {
            await submitAuthorityReject(remarks);
            return;
        }

        if (context === 'postBilling' && action === 'reject') {
            await submitPostToBillingReject(remarks);
            return;
        }

        if (context === 'postBilling' && action === 'approve') {
            await prepareCp52DataForPostBilling();
            return;
        }

        if (action === 'reject') {
            await submitForwardToBillingReject(remarks);
            return;
        }
        await submitForwardToBillingApprove(remarks);
    };

    const openPostBillingRejectRemarksDialog = () => {
        setError('');
        setBillingApproveRemarks('');
        setBillingRemarksDialogError('');
        setBillingRemarksDialog({
            open: true,
            action: 'reject',
            context: 'postBilling',
        });
    };

    const openPostBillingApproveRemarksDialog = () => {
        setError('');
        setBillingApproveRemarks('');
        setBillingRemarksDialogError('');
        setBillingRemarksDialog({
            open: true,
            action: 'approve',
            context: 'postBilling',
        });
    };

    const submitPostToBillingReject = async (remarksOverride) => {
        const remarks =
            remarksOverride != null
                ? String(remarksOverride).trim()
                : getBillingApproveRemarksOrError();
        if (!remarks) return;

        // Field survey referred → back to Forward for Billing (4)
        // Survey not referred → back to Authority Verification (2)
        const fieldSurveyReferred = didMrcSiteSurveyHappen(dialogRowData);
        const targetProgressId = fieldSurveyReferred ? 4 : 2;
        const successKey = fieldSurveyReferred
            ? 'returnedToForwardForBilling'
            : 'returnedToAuthorityVerification';
        const failMessage = fieldSurveyReferred
            ? "Unable to revert to Forward for Billing."
            : "Unable to revert to Authority Verification.";

        const oracleTrackingId = extractMrcOracleTrackingId(
            dialogRowData,
            dialogRowData?.oracleTrackingId,
            dialogRowData?.OracleTrackingId,
            dialogRowData?.billAdjTrackingId,
            dialogRowData?.billADJTrackingId,
            mrcCp52OracleTrackingId
        );

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
                applicationId: dialogRowData.applicationId || "",
                referenceNo: String(dialogRowData.referenceNo || "").replace(/\s/g, ""),
                oracleTrackingId: oracleTrackingId || "",
                applicationProgressId: targetProgressId,
                objectionStatus: 0,
                remarks,
            }),
            redirect: "follow",
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(
                cfpBaseUrl + "mrc/revertToForwardForBilling",
                requestOptions
            );
            const result = await response.json();
            if (result.status == "200" || result.status === 200) {
                showMrcSuccessPopup(successKey);
            } else {
                showMrcFailedPopup(
                    result.message ||
                        result.error ||
                        failMessage
                );
            }
        } catch (e) {
            showMrcFailedPopup(failMessage);
        } finally {
            setViewBackdrop(false);
        }
    };

    const getMrcCp52PdfOptions = (applicationId = dialogRowData.applicationId) => {
        const subDivision =
            mrcCp52FormData?.subDivision ||
            dialogRowData.subDivisionCode ||
            dialogRowData.subdivisionCode ||
            '';
        const companyFromSubDiv = extractDiscoCodeFromSubDivisionCode(subDivision);

        return {
            companyCode:
                companyFromSubDiv ||
                String(selectedAdminCompanyCode || officeCode || '10').slice(0, 2),
            officerName: '',
            designation: '',
            documents: mrcDocuments || [],
            data: {
                ...(mrcCp52FormData || {}),
                subDivision,
                accountNo:
                    mrcCp52FormData?.accountNo ||
                    dialogRowData.consumerId ||
                    dialogRowData.customerId ||
                    '',
                consumerName:
                    mrcCp52FormData?.consumerName ||
                    dialogRowData.consumerName ||
                    dialogRowData.applicantName ||
                    '',
                consumerAddress:
                    mrcCp52FormData?.consumerAddress ||
                    dialogRowData.consumerAddress ||
                    '',
                tariffCode:
                    mrcCp52FormData?.tariffCode ||
                    dialogRowData.tariffCode ||
                    dialogRowData.tariff ||
                    '',
                tariffDisplay:
                    mrcCp52FormData?.tariffDisplay ||
                    resolveMrcTariffDisplay(
                        mrcCp52FormData?.tariffCode ||
                            dialogRowData.tariffCode ||
                            dialogRowData.tariff ||
                            '',
                        allTariffList,
                    ),
                tariffs: allTariffList,
                billingMonth: formatCp52BillingMonth(
                    mrcCp52FormData?.billingMonth ||
                    dialogRowData.billingMonth ||
                    ''
                ),
                dueDate:
                    mrcCp52FormData?.dueDate || dialogRowData.dueDate || '',
                readingDate:
                    mrcCp52FormData?.readingDate ||
                    dialogRowData.readingDate ||
                    '',
                adjDate:
                    mrcCp52FormData?.adjDate || dialogRowData.dueDate || '',
                enqNo:
                    mrcCp52FormData?.enqNo ||
                    applicationId ||
                    dialogRowData.applicationId ||
                    '',
                adjNumber:
                    mrcCp52FormData?.adjNumber ||
                    mrcCp52OracleTrackingId ||
                    '',
            },
        };
    };

    const downloadCp52OfMrcPdf = async (applicationId = dialogRowData.applicationId) => {
        try {
            downloadCPForm52OfMRCPdf(getMrcCp52PdfOptions(applicationId));
            return true;
        } catch (e) {
            setError("Unable to open CP52 PDF.");
            return false;
        }
    };

    const getMrcCp52PreparePayload = (row = dialogRowData) => {
        const source = row || {};
        const refParts = parseCp52ReferenceNo(
            source.referenceNo || source.refNo || source.REFERENCE_NO || ""
        );
        const subDiv = String(
            source.subDivisionCode ||
            source.subdivisionCode ||
            source.subDivCode ||
            refParts.subDivision ||
            ""
        ).trim();
        const hierarchyList = Array.isArray(officeHierarchy)
            ? officeHierarchy
            : Array.isArray(subDivisions)
                ? subDivisions
                : [];
        const match = hierarchyList.find(
            (item) => String(item?.subDivisionCode) === subDiv
        );
        const pDivCode = String(
            match?.divisionCode ||
            source.divisionCode ||
            source.divCode ||
            (subDiv ? subDiv.slice(0, 4) : "") ||
            ""
        ).trim();
        const P_CC_CODE = String(
            source.ccCode ||
            source.circleCode ||
            source.CC_CODE ||
            match?.circleCode ||
            match?.ccCode ||
            (subDiv ? subDiv.slice(0, 2) : "") ||
            ""
        ).trim();
        // getAllApplication: customerId → i_application_no
        const i_application_no = String(
            source.customerId ||
            source.consumerId ||
            source.accountNo ||
            source.AccountNo ||
            refParts.accountNo ||
            ""
        ).trim();
        // getAllApplication: oracleTrackingId → i_tracking_id
        const i_tracking_id = String(
            extractMrcOracleTrackingId(
                source.oracleTrackingId,
                source.OracleTrackingId,
                source.billAdjTrackingId,
                source.billADJTrackingId,
                source.trackingId,
                source.TRACKING_ID
            ) || ""
        ).trim();

        return {
            pDivCode,
            P_CC_CODE,
            i_application_no,
            i_tracking_id,
            applicationId: String(source.applicationId || "").trim(),
            // noOfMonths: normalizeMrcSegregationMonth(
            //     source.noOfMonths ?? mrcSegregationMonth
            // ),
        };
    };

    const callGetCp52 = async ({
        applicationId = dialogRowData.applicationId,
        oracleTrackingId,
        isPostedToIPS = false,
    } = {}) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        // Same source as prepare: oracleTrackingId from getAllApplication row
        const resolvedOracleTrackingId = String(
            oracleTrackingId ||
            dialogRowData.oracleTrackingId ||
            dialogRowData.OracleTrackingId ||
            dialogRowData.billAdjTrackingId ||
            dialogRowData.billADJTrackingId ||
            ""
        ).trim();

        const payload = {
            applicationId,
            oracleTrackingId: resolvedOracleTrackingId,
            isPostedToIPS: Boolean(isPostedToIPS),
        };

        const response = await fetch(cfpBaseUrl + "mrc/getCP52", {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(payload),
            redirect: "follow",
        });
        return response.json();
    };

    const callPostCp52 = async (row = dialogRowData) => {
        const payload = getMrcCp52PreparePayload(row);
        const missing = [];
        if (!payload.pDivCode) missing.push("Division Code (pDivCode)");
        if (!payload.P_CC_CODE) missing.push("Circle Code (P_CC_CODE)");
        if (!payload.i_application_no) missing.push("Customer ID");
        if (!payload.i_tracking_id) missing.push("oracleTrackingId");
        if (missing.length) {
            const appId = String(payload.applicationId || row?.applicationId || "").trim();
            const onlyTrackingMissing =
                missing.length === 1 && missing[0] === "oracleTrackingId";
            return {
                ok: false,
                message: onlyTrackingMissing
                    ? `${appId ? `${appId} ` : ""}oracleTrackingId is missing`
                    : `${appId ? `${appId} ` : ""}These fields are missing for Post for Billing: ${missing.join(", ")}.`,
            };
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const response = await fetch(cfpBaseUrl + "mrc/postCP52", {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
                pDivCode: payload.pDivCode,
                P_CC_CODE: payload.P_CC_CODE,
                i_application_no: payload.i_application_no,
                i_tracking_id: payload.i_tracking_id,
            }),
            redirect: "follow",
        });
        const result = await response.json().catch(() => ({}));
        const ok = result.status == "200" || result.status === 200;
        return {
            ok,
            result,
            payload,
            message: result.message || result.error,
        };
    };

    const postCp52ForBilling = async (rowOverride = null) => {
        const row = rowOverride || dialogRowData || {};
        setMrcCp52Posting(true);
        setViewBackdrop(true);
        try {
            const posted = await callPostCp52(row);
            if (!posted.ok) {
                showMrcFailedPopup(
                    posted.message || "Unable to post CP52 for billing."
                );
                return null;
            }
            return posted;
        } catch (e) {
            showMrcFailedPopup("Unable to post CP52 for billing.");
            return null;
        } finally {
            setMrcCp52Posting(false);
            setViewBackdrop(false);
        }
    };

    const callUpdateAppForCP52 = async (row = dialogRowData, monthsOverride) => {
        const applicationId = String(row?.applicationId || "").trim();
        const oracleTrackingId = String(
            extractMrcOracleTrackingId(
                row?.oracleTrackingId,
                row?.OracleTrackingId,
                row?.billAdjTrackingId,
                row?.billADJTrackingId,
                row?.trackingId,
                mrcCp52OracleTrackingId
            ) || ""
        ).trim();
        const referenceNo = String(
            row?.referenceNo || row?.refNo || row?.REFERENCE_NO || ""
        ).replace(/\s/g, "");
        // const noOfMonths = normalizeMrcSegregationMonth(
        //     monthsOverride ?? row?.noOfMonths ?? mrcSegregationMonth
        // );

        if (!applicationId || !oracleTrackingId) {
            return {
                ok: false,
                message: "Application or oracle tracking id missing for CP52 update.",
            };
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const response = await fetch(cfpBaseUrl + "mrc/updateAppForCP52", {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
                applicationId,
                oracleTrackingId,
                referenceNo,
                // noOfMonths,
            }),
            redirect: "follow",
        });
        const result = await response.json().catch(() => ({}));
        const ok = result.status == "200" || result.status === 200;
        return {
            ok,
            result,
            message: result.message || result.error,
        };
    };

    const isMrcCp52AlreadyCreated = (row = dialogRowData) => {
        const v =
            row?.isCP52Created ??
            row?.IsCP52Created ??
            row?.isCp52Created ??
            row?.cp52Created;
        return (
            v === true ||
            v === 1 ||
            v === "1" ||
            String(v).toLowerCase() === "true"
        );
    };

    const markMrcCp52Created = (applicationId) => {
        if (!applicationId) return;
        setMrcLocalCp52CreatedIds((prev) => ({
            ...prev,
            [applicationId]: true,
        }));
        const patchRows = (rows) =>
            (rows || []).map((row) =>
                row.applicationId === applicationId
                    ? { ...row, isCP52Created: true }
                    : row
            );
        setMrcComplaintsToDataGrid(patchRows);
        setMrcComplaintsOverdueToDataGrid(patchRows);
        setDialogRowData((prev) =>
            prev?.applicationId === applicationId
                ? { ...prev, isCP52Created: true }
                : prev
        );
    };

    const openCp52DialogFromGetResult = ({
        row,
        documents,
        oracleTrackingId,
        getResult,
        prepareResult = null,
    }) => {
        const baseData = enrichCp52BaseDataFromDocuments(
            {
                subDivision:
                    row.subDivisionCode ||
                    row.subdivisionCode ||
                    "",
                accountNo:
                    row.customerId ||
                    row.consumerId ||
                    "",
                consumerName:
                    row.consumerName ||
                    row.applicantName ||
                    "",
                consumerAddress: row.consumerAddress || "",
                tariffCode:
                    row.tariffCode || row.tariff || "",
                tariffDisplay: resolveMrcTariffDisplay(
                    row.tariffCode || row.tariff || "",
                    allTariffList
                ),
                tariffs: allTariffList,
                billingMonth: formatCp52BillingMonth(row.billingMonth || ""),
                dueDate: row.dueDate || "",
                readingDate: row.readingDate || "",
                adjDate: row.dueDate || "",
                enqNo: row.applicationId || "",
                adjNumber: oracleTrackingId,
            },
            documents
        );
        const formData = mapMrcGetCp52ToFormData(getResult, baseData);
        const preparedRow = { ...row, isCP52Created: true };

        setDialogRowData(preparedRow);
        setMrcDocuments(Array.isArray(documents) ? documents : []);
        setMrcForcePrepareCp52(false);
        setMrcCp52OracleTrackingId(oracleTrackingId);
        setMrcCp52FormData(formData);
        setMrcCp52PrepareResponse({
            prepare: prepareResult,
            get: getResult,
        });
        setMrcCp52PrepareDialogOpen(true);
        markMrcCp52Created(row.applicationId);
    };

    /** Already prepared on backend (isCP52Created) — only fetch getCP52. */
    const getCp52DataForPostBilling = async (rowOverride = null) => {
        setError("");
        const rowCandidate =
            rowOverride &&
            typeof rowOverride === "object" &&
            (rowOverride.applicationId ||
                rowOverride.customerId ||
                rowOverride.consumerId ||
                rowOverride.oracleTrackingId ||
                rowOverride.billAdjTrackingId ||
                rowOverride.billADJTrackingId)
                ? rowOverride
                : null;
        const row = rowCandidate || dialogRowData || {};
        let documents = Array.isArray(mrcDocuments) ? mrcDocuments : [];
        if (!documents.length && row.applicationId) {
            documents = (await callAsyncGetMRCDocuments(row.applicationId)) || [];
        }

        const oracleTrackingId = extractMrcOracleTrackingId(
            row.oracleTrackingId,
            row.OracleTrackingId,
            row.billAdjTrackingId,
            row.billADJTrackingId,
            row.trackingId
        );
        if (!oracleTrackingId) {
            const appId = String(row?.applicationId || "").trim();
            showMrcFailedPopup(
                appId
                    ? `${appId} oracleTrackingId is missing`
                    : "oracleTrackingId is missing"
            );
            return;
        }

        setMrcCp52Preparing(true);
        setViewBackdrop(true);
        try {
            const getResult = await callGetCp52({
                applicationId: row.applicationId,
                oracleTrackingId,
                isPostedToIPS: false,
            });
            if (!(getResult.status == "200" || getResult.status === 200)) {
                showMrcFailedPopup(
                    getResult.message ||
                    getResult.error ||
                    "Unable to load CP52 data."
                );
                return;
            }

            openCp52DialogFromGetResult({
                row,
                documents,
                oracleTrackingId,
                getResult,
                prepareResult: null,
            });
        } catch (e) {
            showMrcFailedPopup("Unable to load CP52 data.");
        } finally {
            setMrcCp52Preparing(false);
            setViewBackdrop(false);
        }
    };

    const prepareCp52DataForPostBilling = async (
        rowOverride = null,
        documentsOverride = null
    ) => {
        setError("");
        // Button onClick may pass a React event — ignore non-application objects.
        const rowCandidate =
            rowOverride &&
            typeof rowOverride === "object" &&
            (rowOverride.applicationId ||
                rowOverride.customerId ||
                rowOverride.consumerId ||
                rowOverride.oracleTrackingId ||
                rowOverride.billAdjTrackingId ||
                rowOverride.billADJTrackingId)
                ? rowOverride
                : null;
        const row = rowCandidate || dialogRowData || {};
        const documents =
            documentsOverride != null && Array.isArray(documentsOverride)
                ? documentsOverride
                : mrcDocuments;
        const payload = getMrcCp52PreparePayload(row);
        const missing = [];
        if (!payload.pDivCode) missing.push('Division Code (pDivCode)');
        if (!payload.P_CC_CODE) missing.push('Circle Code (P_CC_CODE)');
        if (!payload.i_application_no) missing.push('Customer ID');
        if (!payload.i_tracking_id) missing.push('oracleTrackingId');
        if (missing.length) {
            console.warn('[MRC CP52 prepare] missing fields', {
                missing,
                payload,
                rowKeys: Object.keys(row || {}),
                applicationId: row?.applicationId,
                customerId: row?.customerId,
                consumerId: row?.consumerId,
                oracleTrackingId: row?.oracleTrackingId,
                billAdjTrackingId: row?.billAdjTrackingId || row?.billADJTrackingId,
                subDivisionCode: row?.subDivisionCode || row?.subdivisionCode,
                circleCode: row?.circleCode || row?.ccCode,
                referenceNo: row?.referenceNo,
            });
            const appId = String(payload.applicationId || row?.applicationId || "").trim();
            const onlyTrackingMissing =
                missing.length === 1 && missing[0] === "oracleTrackingId";
            showMrcFailedPopup(
                onlyTrackingMissing
                    ? `${appId ? `${appId} ` : ""}oracleTrackingId is missing`
                    : `${appId ? `${appId} ` : ""}These fields are missing for CP52 prepare: ${missing.join(", ")}.`
            );
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(payload),
            redirect: "follow",
        };

        setMrcCp52Preparing(true);
        setViewBackdrop(true);
        try {
            // const noOfMonths = normalizeMrcSegregationMonth(payload.noOfMonths);
            // const alreadyCreated = isMrcCp52AlreadyCreated(row);
            // First prepare (isCP52Created false): skip update, prepare only.
            // Already created: skip update when months is 1; update when 2 or 3.
            // if (alreadyCreated && noOfMonths !== MRC_SEGREGATION_MONTH_DEFAULT) {
            //     const updateResult = await callUpdateAppForCP52(row, noOfMonths);
            //     if (!updateResult.ok) {
            //         showMrcFailedPopup(
            //             updateResult.message || "Unable to update application for CP52."
            //         );
            //         return;
            //     }
            // }

            const prepareResponse = await fetch(
                cfpBaseUrl + "mrc/prepareCP52",
                requestOptions
            );
            const prepareResult = await prepareResponse.json();
            if (!(prepareResult.status == "200" || prepareResult.status === 200)) {
                showMrcFailedPopup(
                    prepareResult.message ||
                    prepareResult.error ||
                    "Unable to prepare CP52 data."
                );
                return;
            }

            // Prefer getAllApplication oracleTrackingId (same as prepare i_tracking_id)
            const oracleTrackingId = extractMrcOracleTrackingId(
                row.oracleTrackingId,
                row.OracleTrackingId,
                payload.i_tracking_id,
                prepareResult,
                row.billAdjTrackingId,
                row.billADJTrackingId
            );
            if (!oracleTrackingId) {
                const appId = String(row?.applicationId || payload.applicationId || "").trim();
                showMrcFailedPopup(
                    appId
                        ? `${appId} oracleTrackingId is missing`
                        : "oracleTrackingId is missing"
                );
                return;
            }

            const getResult = await callGetCp52({
                applicationId: row.applicationId,
                oracleTrackingId,
                isPostedToIPS: false,
            });
            if (!(getResult.status == "200" || getResult.status === 200)) {
                showMrcFailedPopup(
                    getResult.message ||
                    getResult.error ||
                    "Unable to load CP52 data."
                );
                return;
            }

            openCp52DialogFromGetResult({
                row,
                documents,
                oracleTrackingId,
                getResult,
                prepareResult,
            });
        } catch (e) {
            showMrcFailedPopup("Unable to prepare / load CP52 data.");
        } finally {
            setMrcCp52Preparing(false);
            setViewBackdrop(false);
        }
    };

    const callSiteSurveyApproval = async ({
        applicationProgressId,
        objectionStatus,
        remarks,
        meterData,
    }) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const payload = {
            applicationId: dialogRowData.applicationId,
            applicationProgressId,
            objectionStatus,
            remarks,
            meterData: meterData ?? [],
            siteSurveySubmittedThrough: portalName,
        };

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(payload),
            redirect: "follow",
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "mrc/siteSurvey", requestOptions);
            const result = await response.json();
            if (result.status == "200" || result.status === 200) {
                showMrcSuccessPopup('siteSurveySubmitted');
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to submit site survey.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to submit site survey.");
        } finally {
            setViewBackdrop(false);
        }
    };

    const submitSiteSurvey = async () => {
        const isValid = siteSurveyReadingTableRef.current?.validateSiteSurvey?.() ?? true;
        if (!isValid) {
            return;
        }

        const siteSurveyReadings =
            siteSurveyReadingTableRef.current?.getSiteSurveyReadings?.() ?? {};
        const siteSurveyImages =
            siteSurveyReadingTableRef.current?.getSiteSurveyImages?.() ?? {};
        const documents = mrcDocuments.length
            ? mrcDocuments
            : await callAsyncGetMRCDocuments(dialogRowData.applicationId);

        await callSiteSurveyApproval({
            applicationProgressId: 4,
            objectionStatus: 0,
            remarks: "Site Surveyed.",
            meterData: buildMrcSiteSurveyMeterData(
                documents,
                siteSurveyReadings,
                siteSurveyImages
            ),
        });
    };

    const callChangeObjectionStatus = async (remarks, objectionStatus = 1, applicationId = dialogRowData.applicationId, remarksDetails = '-',) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        const raw = JSON.stringify({
            applicationId: applicationId,
            applicationProgressId: dialogRowData.applicationProgressId,
            objectionStatus: objectionStatus,
            lastModifiedBy: userId,
            remarks: remarks
        });


        var requestOptions = {
            method: 'POST',
            body: raw,
            headers: myHeaders,
            redirect: 'follow',
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "MRC/raiseObjectionOnMRC", requestOptions);
            const result = await response.json();
            if (result.status === '200' || result.status === 200) {
                showMrcSuccessPopup('docsRejected');
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to raise objection.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to raise objection.");
        } finally {
            setViewBackdrop(false);
        }
    }

    const callAsyncInsertApprovedReadings = async (
        applicationId = dialogRowData.applicationId,
        meterPhaseType,
        remarks,
        approvedReadingSinglePhase,
        approvedOffPeakThreePhase,
        approvedPeakThreePhase,
        approvedOffPeakImport,
        approvedPeakImport,
        approvedOffPeakExport,
        approvedPeakExport,
        approvedOffPeakThreePhaseMdi,
        approvedPeakThreePhaseMdi,
        approvedkVArhOffPeakThreePhaseMdi,
        approvedkVArhPeakThreePhaseMdi,
        approvedOffPeakThreePhaseMdiImport,
        approvedPeakThreePhaseMdiImport,
        approvedkVArhOffPeakThreePhaseMdiImport,
        approvedkVArhPeakThreePhaseMdiImport,
        approvedOffPeakThreePhaseMdiExport,
        approvedPeakThreePhaseMdiExport,
        approvedkVArhOffPeakThreePhaseMdiExport,
        approvedkVArhPeakThreePhaseMdiExport
    ) => {
        try {

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                applicationId: applicationId,
                meterPhaseType: meterPhaseType,
                applicationProgressId: 4,
                objectionStatus: 0,
                lastModifiedBy: userId,
                remarks: remarks,

                // Single Phase
                approvedReadingSinglePhase: meterPhaseType == '1 phase meter' ? approvedReadingSinglePhase : '',

                //Three Phase Meter
                approvedOffPeakThreePhase: meterPhaseType == '3 phase meter' ? approvedOffPeakThreePhase : '',
                approvedPeakThreePhase: meterPhaseType == '3 phase meter' ? approvedPeakThreePhase : '',

                // Net Meter
                approvedOffPeakImport: meterPhaseType == 'net meter' ? approvedOffPeakImport : '',
                approvedPeakImport: meterPhaseType == 'net meter' ? approvedPeakImport : '',
                approvedOffPeakExport: meterPhaseType == 'net meter' ? approvedOffPeakExport : '',
                approvedPeakExport: meterPhaseType == 'net meter' ? approvedPeakExport : '',

                // Three Phase MDI Meter
                approvedOffPeakThreePhaseMdi: meterPhaseType == '3 phase mdi meter' ? approvedOffPeakThreePhaseMdi : '',
                approvedPeakThreePhaseMdi: meterPhaseType == '3 phase mdi meter' ? approvedPeakThreePhaseMdi : '',
                approvedkVArhOffPeakThreePhaseMdi: meterPhaseType == '3 phase mdi meter' ? approvedkVArhOffPeakThreePhaseMdi : '',
                approvedkVArhPeakThreePhaseMdi: meterPhaseType == '3 phase mdi meter' ? approvedkVArhPeakThreePhaseMdi : '',

                // Three Phase MDI Net meter
                approvedOffPeakThreePhaseMdiImport: meterPhaseType == '3 phase mdi net meter' ? approvedOffPeakThreePhaseMdiImport : '',
                approvedPeakThreePhaseMdiImport: meterPhaseType == '3 phase mdi net meter' ? approvedPeakThreePhaseMdiImport : '',
                approvedkVArhOffPeakThreePhaseMdiImport: meterPhaseType == '3 phase mdi net meter' ? approvedkVArhOffPeakThreePhaseMdiImport : '',
                approvedkVArhPeakThreePhaseMdiImport: meterPhaseType == '3 phase mdi net meter' ? approvedkVArhPeakThreePhaseMdiImport : '',
                approvedOffPeakThreePhaseMdiExport: meterPhaseType == '3 phase mdi net meter' ? approvedOffPeakThreePhaseMdiExport : '',
                approvedPeakThreePhaseMdiExport: meterPhaseType == '3 phase mdi net meter' ? approvedPeakThreePhaseMdiExport : '',
                approvedkVArhOffPeakThreePhaseMdiExport: meterPhaseType == '3 phase mdi net meter' ? approvedkVArhOffPeakThreePhaseMdiExport : '',
                approvedkVArhPeakThreePhaseMdiExport: meterPhaseType == '3 phase mdi net meter' ? approvedkVArhPeakThreePhaseMdiExport : '',
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "MRC/insertApprovedReadings", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status == "200" || result.status === 200) {
                        showMrcSuccessPopup('authorityApproved');
                    } else {
                        showMrcFailedPopup(result.message || result.error || "Unable to insert approved readings.");
                    }
                })
                .catch(() => {
                    showMrcFailedPopup("Unable to insert approved readings.");
                });
        }
        catch (e) {
            showMrcFailedPopup("Unable to insert approved readings.");
        }
    }

    const callUpdateMntFlag = async (applicationId, flag) => {
        try {
            var formdata = new FormData();
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;
            formdata.append("applicationId", applicationId);
            formdata.append("mntVerificationFlag", flag);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "powerComplaints/updateMNTVerificationFlag", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {

                    } else {
                    }
                })
                .catch(() => { });
        }
        catch (e) {
        }
    }

    const callAsyncDeleteMNTReport = async (applicationId = dialogRowData.applicationId) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("applicationId", applicationId);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "MandTReport/deleteMandTReport", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "200") {

                }
            })
            .catch(() => { });
    }

    const callAsyncGetSInitialReading = async (applicationId = dialogRowData.applicationId, meterPhaseType = dialogRowData.meterPhaseType) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const raw = JSON.stringify({
                "applicationId": applicationId,
                "meterPhaseType": meterPhaseType
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "MRC/getInitialMeterReadings", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status == "200") {
                        if (meterPhaseType == "1 phase meter") {
                            setSinglePhaseInitialReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase meter") {
                            setThreePhaseInitialReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase mdi meter") {
                            setThreePhaseMDIInitialReadings(result.data[0])
                        } else if (meterPhaseType == "net meter") {
                            setNetMeterInitialReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase mdi net meter") {
                            setThreePhaseMDINetMeterInitialReadings(result.data[0])
                        }
                    }
                })
                .catch(() => { });
        } catch (e) {
        }
    }

    const callAsyncGetMRCDocuments = async (
        applicationId = dialogRowData.applicationId,
        { historyId, updateState = true } = {}
    ) => {
        if (!applicationId) {
            if (updateState) setMrcDocuments([]);
            return [];
        }
        if (updateState) {
            setMrcDocumentsLoading(true);
            setMrcDocuments([]);
        }
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const body = { applicationId };
            if (historyId != null && historyId !== "") {
                body.historyId = historyId;
            }

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(body),
                redirect: "follow",
            };

            const response = await fetch(cfpBaseUrl + "mrc/getMRCDocuments", requestOptions);
            const result = await response.json();
            if (result.status == "200" && Array.isArray(result.data)) {
                if (updateState) setMrcDocuments(result.data);
                return result.data;
            }
            if (updateState) setMrcDocuments([]);
            return [];
        } catch (e) {
            if (updateState) setMrcDocuments([]);
            return [];
        } finally {
            if (updateState) setMrcDocumentsLoading(false);
        }
    }

    const fetchMrcHistoryDetail = async (applicationId, historyId) => {
        if (!applicationId || historyId == null) return { detail: null, data: [] };
        const response = await fetch(cfpBaseUrl + "mrc/getDetailByHistoryId", {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ applicationId, historyId }),
            redirect: "follow",
        });
        const result = await response.json();
        if (result.status === "200" && Array.isArray(result.data) && result.data[0]) {
            return { detail: result.data[0], data: result.data, result };
        }
        return { detail: null, data: [], result };
    }

    const callAsyncGetSFieldSurveyReading = async (applicationId = dialogRowData.applicationId, meterPhaseType = dialogRowData.meterPhaseType) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const raw = JSON.stringify({
                applicationId: applicationId,
                meterPhaseType: meterPhaseType
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "MRC/getFieldSurveyMeterReadings", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status == "200") {
                        if (meterPhaseType == "1 phase meter") {
                            setSinglePhaseFieldSurveyReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase meter") {
                            setThreePhaseFieldSurveyReadings(result.data[0])
                        } else if (meterPhaseType == "net meter") {
                            setNetMeterFieldSurveyReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase mdi meter") {
                            setThreePhaseMDIFieldSurveyReadings(result.data[0])
                        } else if (meterPhaseType == "3 phase mdi net meter") {
                            setThreePhaseMDINetMeterFieldSurveyReadings(result.data[0])
                        }
                    }
                })
                .catch(() => { });
        } catch (e) {
        }
    }

    const isMrcBillPostedOnRow = (item = {}) => {
        const posted = item.isBillPosted ?? item.IsBillPosted;
        const generated = item.isBillGenerated ?? item.IsBillGenerated;
        return (
            posted === true ||
            posted === 1 ||
            String(posted).toLowerCase() === "true" ||
            generated === true ||
            generated === 1 ||
            String(generated).toLowerCase() === "true"
        );
    };

    //#endregion

    //#region functions
    const updateDocFlag = (documentName, value) => {
        switch (documentName) {
            case 'offPeakImport':
                setFlag_offPeakImportImg(value);
                break;
            case 'offPeakExport':
                setFlag_offPeakExportImg(value);
                break
            case 'peakImport':
                // setFlag_peakImportImg(value);
                break
            case 'peakExport':
                // setFlag_peakExportImg(value);
                break
            default:
                break

        }
    }

    const updateMrcDocumentImageFlag = (documentId, value, remarks = '') => {
        setMrcDocuments((prev) =>
            (prev || []).map((doc, index) => {
                const id = String(doc.Id ?? doc.id ?? `${doc.setNo}-${doc.meterId}-${index}`);
                if (id !== String(documentId)) return doc;
                const nextRemarks =
                    value === 1
                        ? MRC_DOCUMENT_VERIFIED_REMARK
                        : remarks || doc.consumerClaimedImageRemarks || doc.consumerDialVerificationRemarks || '';
                return {
                    ...doc,
                    consumerClaimedImageFlag: value,
                    imageFlag: value,
                    documentFlag: value,
                    consumerDialVerificationFlag: value === 1,
                    consumerDialVerificationRemarks: nextRemarks,
                    consumerClaimedImageRemarks: nextRemarks,
                    imageRemarks: nextRemarks,
                };
            })
        );
        setError('');
    }

    const callVerifyMRCDocuments = async ({
        applicationProgressId,
        objectionStatus,
        remarks,
        meterData,
        successKey = 'verified',
    }) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
                applicationId: dialogRowData.applicationId,
                applicationProgressId,
                objectionStatus,
                remarks,
                meterData,
            }),
            redirect: "follow",
        };

        setViewBackdrop(true);
        setError('');
        try {
            const response = await fetch(cfpBaseUrl + "mrc/verifyMRCDocuments", requestOptions);
            const result = await response.json();
            if (result.status == "200" || result.status === 200) {
                showMrcSuccessPopup(successKey);
            } else {
                showMrcFailedPopup(result.message || result.error || "Unable to verify MRC documents.");
            }
        } catch (e) {
            showMrcFailedPopup("Unable to verify MRC documents.");
        } finally {
            setViewBackdrop(false);
        }
    }

    const updateMrcDocumentVerificationStatus = async () => {
        const { allActed, hasReject, allAccepted, pending } =
            getMrcImageVerificationState(mrcDocuments);

        if (!allActed || pending.length > 0) {
            setError('Check all the attached reading images before submitting!');
            return;
        }

        const meterData = buildMrcVerifyMeterData(mrcDocuments);
        if (!meterData.length) {
            setError('No meter reading images found to verify.');
            return;
        }

        if (hasReject) {
            await callVerifyMRCDocuments({
                applicationProgressId: 1,
                objectionStatus: 1,
                remarks: buildMrcImageObjectionRemarks(mrcDocuments),
                meterData,
                successKey: 'docsRejected',
            });
            return;
        }

        if (allAccepted) {
            await callVerifyMRCDocuments({
                applicationProgressId: 2,
                objectionStatus: 0,
                remarks: MRC_DOCUMENT_VERIFIED_REMARK,
                meterData,
                successKey: 'verified',
            });
        }
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = () => {
        applicationVerificationWithNewReadingsFormik.resetForm()
        setProceedType(0)
        meterReaderFieldSurveyFormik.resetForm()
        setAuthorityDecision('')
        setReferToSiteSurvey('')
        setMrcWorkForceData([])
        setMrcSelectedStaffId('')
        setBillingApproveRemarks('')
        setMrcCp52Prepared(false)
        setMrcForcePrepareCp52(false)
        setMrcCp52Preparing(false)
        setMrcCp52PrepareDialogOpen(false)
        setMrcCp52PrepareResponse(null)
        setMrcCp52FormData(null)
        setMrcCp52OracleTrackingId('')
        objectionFormik.resetForm()
        setFoundInMRC()
        setSinglePhaseSurveyReadingImage();
        setSinglePhaseSurveyReadingImageError();
        setSinglePhaseSurveyReadingImageThumbnail('');
        setThreePhaseSurveyOffPeakReadingImage();
        setThreePhaseSurveyOffPeakReadingImageError();
        setThreePhaseSurveyOffPeakReadingImageThumbnail('');
        setThreePhaseSurveyPeakReadingImage();
        setThreePhaseSurveyPeakReadingImageError();
        setThreePhaseSurveyPeakReadingImageThumbnail('');
        setThreePhaseMDISurveyOffPeakReadingImage();
        setThreePhaseMDISurveyOffPeakReadingImageError();
        setThreePhaseMDISurveyOffPeakReadingImageThumbnail('');
        setThreePhaseMDISurveyPeakReadingImage();
        setThreePhaseMDISurveyPeakReadingImageError();
        setThreePhaseMDISurveyPeakReadingImageThumbnail('');
        setThreePhaseMDISurveykVArhOffPeakReadingImage();
        setThreePhaseMDISurveykVArhOffPeakReadingImageError();
        setThreePhaseMDISurveykVArhOffPeakReadingImageThumbnail('');
        setThreePhaseMDISurveykVArhPeakReadingImage();
        setThreePhaseMDISurveykVArhPeakReadingImageError();
        setThreePhaseMDISurveykVArhPeakReadingImageThumbnail('');
        setNetMeterSurveyOffPeakImportReadingImage()
        setNetMeterSurveyOffPeakImportReadingImageError()
        setNetMeterSurveyOffPeakImportReadingImageThumbnail()
        setNetMeterSurveyPeakImportReadingImage()
        setNetMeterSurveyPeakImportReadingImageError()
        setNetMeterSurveyPeakImportReadingImageThumbnail()
        setNetMeterSurveyOffPeakExportReadingImage()
        setNetMeterSurveyOffPeakExportReadingImageError()
        setNetMeterSurveyOffPeakExportReadingImageThumbnail()
        setNetMeterSurveyPeakExportReadingImage()
        setNetMeterSurveyPeakExportReadingImageError()
        setNetMeterSurveyPeakExportReadingImageThumbnail()
        setUnitsToCorrect(null);
        setSinglePhaseInitialReadings({
            applicationId: "",
            previousReadingSinglePhase: "",
            currentReadingSinglePhase: "",
            claimedReadingSinglePhase: "",
            claimedReadingSinglePhaseImage: ""
        })
        setThreePhaseInitialReadings({
            applicationId: "",
            previousOffPeakThreePhase: "",
            previousPeakThreePhase: "",
            currentOffPeakThreePhase: "",
            currentPeakThreePhase: "",
            claimedOffPeakThreePhase: "",
            claimedPeakThreePhase: "",
            claimedOffPeakThreePhaseImage: "",
            claimedPeakThreePhaseImage: ""
        })
        setThreePhaseMDIInitialReadings({
            applicationId: "",
            previousOffPeakThreePhaseMdi: "",
            previousPeakThreePhaseMdi: "",
            previouskVArhOffPeakThreePhaseMdi: "",
            previouskVArhPeakThreePhaseMdi: "",
            currentOffPeakThreePhaseMdi: "",
            currentPeakThreePhaseMdi: "",
            currentMdiOffPeakThreePhaseMdi: "",
            currentMdiPeakThreePhaseMdi: "",
            claimedOffPeakThreePhaseMdi: "",
            claimedPeakThreePhaseMdi: "",
            claimedMdiOffPeakThreePhaseMdi: "",
            claimedMdiPeakThreePhaseMdi: "",
            claimedOffPeakThreePhaseMdiImage: "",
            claimedPeakThreePhaseMdiImage: "",
            claimedkVArhOffPeakThreePhaseMdiImage: "",
            claimedkVArhPeakThreePhaseMdiImage: ""
        })
        setNetMeterInitialReadings({
            applicationId: "",
            previousOffpeakImport: "",
            previousPeakImport: "",
            previousOffpeakExport: "",
            previousPeakExport: "",
            currentOffpeakImport: "",
            currentPeakImport: "",
            currentOffpeakExport: "",
            currentPeakExport: "",
            claimedOffpeakImport: "",
            claimedPeakImport: "",
            claimedOffpeakExport: "",
            claimedPeakExport: "",
            claimedOffpeakImportImage: "",
            claimedPeakImportImage: "",
            claimedOffpeakExportImage: "",
            claimedPeakExportImage: ""
        });
        setThreePhaseMDINetMeterInitialReadings({
            applicationId: "",
            previousOffPeakThreePhaseMdiImport: "",
            previousPeakThreePhaseMdiImport: "",
            previouskVArhOffPeakThreePhaseMdiImport: "",
            previouskVArhPeakThreePhaseMdiImport: "",
            previousMdiOffPeakThreePhaseMdiImport: "",
            previousMdiPeakThreePhaseMdiImport: "",
            currentOffPeakThreePhaseMdiImport: "",
            currentPeakThreePhaseMdiImport: "",
            currentkVArhOffPeakThreePhaseMdiImport: "",
            currentkVArhPeakThreePhaseMdiImport: "",
            currentMdiOffPeakThreePhaseMdiImport: "",
            currentMdiPeakThreePhaseMdiImport: "",
            claimedOffPeakThreePhaseMdiImport: "",
            claimedPeakThreePhaseMdiImport: "",
            claimedkVArhOffPeakThreePhaseMdiImport: "",
            claimedkVArhPeakThreePhaseMdiImport: "",
            claimedMdiOffPeakThreePhaseMdiImport: "",
            claimedMdiPeakThreePhaseMdiImport: "",
            claimedOffPeakThreePhaseMdiImageImport: "",
            claimedPeakThreePhaseMdiImageImport: "",
            claimedkVArhOffPeakThreePhaseMdiImageImport: null,
            claimedkVArhPeakThreePhaseMdiImageImport: null,
            claimedMdiOffPeakThreePhaseMdiImageImport: null,
            claimedMdiPeakThreePhaseMdiImageImport: null,
            previousOffPeakThreePhaseMdiExport: "",
            previousPeakThreePhaseMdiExport: "",
            previouskVArhOffPeakThreePhaseMdiExport: "",
            previouskVArhPeakThreePhaseMdiExport: "",
            previousMdiOffPeakThreePhaseMdiExport: "",
            previousMdiPeakThreePhaseMdiExport: "",
            currentOffPeakThreePhaseMdiExport: "",
            currentPeakThreePhaseMdiExport: "",
            currentkVArhOffPeakThreePhaseMdiExport: "",
            currentkVArhPeakThreePhaseMdiExport: "",
            currentMdiOffPeakThreePhaseMdiExport: "",
            currentMdiPeakThreePhaseMdiExport: "",
            claimedOffPeakThreePhaseMdiExport: "",
            claimedPeakThreePhaseMdiExport: "",
            claimedkVArhOffPeakThreePhaseMdiExport: "",
            claimedkVArhPeakThreePhaseMdiExport: "",
            claimedMdiOffPeakThreePhaseMdiExport: "",
            claimedMdiPeakThreePhaseMdiExport: "",
            claimedOffPeakThreePhaseMdiImageExport: "",
            claimedPeakThreePhaseMdiImageExport: "",
            claimedkVArhOffPeakThreePhaseMdiImageExport: null,
            claimedkVArhPeakThreePhaseMdiImageExport: null,
            claimedMdiOffPeakThreePhaseMdiImageExport: null,
            claimedMdiPeakThreePhaseMdiImageExport: null
        });
        setOpen(false);
        // setMrcSegregationMonth(MRC_SEGREGATION_MONTH_DEFAULT);
        setMrcDocuments([]);
        setMrcDocumentsLoading(false);
        setTableDataProcessingSummary([]);
        setEFileData([]);
        setEFileCurrentStatus({});
        setMrcTotalDuration('-');
        setActivityLogCollapsed(true);
        setActivityLogDetailOpen(false);
        setHistoryData(null);
        setHistoryDetailPopUp(false);
        setHistoryReadingDocuments([]);
        setHistoryReadingLoading(false);
        setViewDropBackForEfile(false);
        setViewBackdrop(false)
        if (apiOfficeCode) {
            dispatch(fetchPaginatedMeterReadingCorrectionNormal({
                page: currentPage,
                pageSize: pageSize,
                dateFrom: dateFrom,
                dateTo: dateTo,
                applicationProgressId: applicationProgressId,
                loadFrom: loadFrom,
                loadTo: loadTo,
                officeCode: apiOfficeCode,
            }));
            dispatch(fetchPaginatedMeterReadingCorrectionOverdue({
                page: currentPageOverdue,
                pageSize: pageSizeOverdue,
                dateFrom: dateFromOverdue,
                dateTo: dateToOverdue,
                applicationProgressId: applicationProgressIdOverdue,
                loadFrom: loadFromOverdue,
                loadTo: loadToOverdue,
                officeCode: apiOfficeCode,
            }));
        }
    };

    const showMrcSuccessPopup = (key) => {
        const trackingId =
            dialogRowData?.applicationId ||
            dialogRowData?.trackingId ||
            '';
        if (key === 'postedForBilling') {
            resultPopupBillContextRef.current = {
                row: { ...(dialogRowData || {}) },
                cp52FormData: mrcCp52FormData,
                oracleTrackingId: extractMrcOracleTrackingId(
                    dialogRowData,
                    dialogRowData?.oracleTrackingId,
                    dialogRowData?.OracleTrackingId,
                    dialogRowData?.billAdjTrackingId,
                    dialogRowData?.billADJTrackingId,
                    mrcCp52OracleTrackingId
                ),
            };
        }
        handleClose();
        setResultPopupTrackingId(trackingId);
        setResultPopup(key);
    };

    const showMrcFailedPopup = (message) => {
        setApiPopup({
            open: true,
            type: 'error',
            message: message || 'Request failed. Please try again.',
        });
    };

    const filterNCApp = async (applicationId) => {
        let itemFound =
            mrcComplaints.find(item => item.applicationId === applicationId) ||
            mrcComplaintsOverdue.find(item => item.applicationId === applicationId);

        if (itemFound) {
            // Own office queue → always relevant (same as New Connection)
            setIsRelevantToUser(true);
        } else {
            itemFound = await SearchIndividualApplication(token, applicationId, '11');
            setIsRelevantToUser(!!itemFound?.isReleventToUser);
        }
        return itemFound;
        // return withMrcNoOfMonths(itemFound);
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
    const progFunc = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1) {
            return 'Document Verification'
        }
        else if (x === 2) {
            return 'Authority Verification'
        }
        else if (x === 3) {
            return 'Site Survey'
        }
        else if (x === 4) {
            return 'Forward for Billing'
        }
        else if (x === 5) {
            return 'Post for Billing'
        }
        else if (x === 6) {
            return 'Completed'
        }
    };

    const getMrcReferToFieldSurveyFlag = (row = dialogRowData) => {
        if (!row || typeof row !== 'object') return null;
        const keys = [
            'isReferToFieldSurvey',
            'isRefereToFieldSurvey', // API typo variant
            'isReferredToFieldSurvey',
            'IsReferToFieldSurvey',
            'isReferedToFieldSurvey',
            'isReferedToFeildSurvey',
        ];
        for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(row, key) && row[key] !== undefined) {
                return row[key];
            }
        }
        return null;
    };

    // true → Site Survey hua; null/false → survey skip (direct Forward for Billing)
    const didMrcSiteSurveyHappen = (row = dialogRowData) => {
        const flag = getMrcReferToFieldSurveyFlag(row);
        if (flag === true || flag === 1 || flag === '1') return true;
        if (typeof flag === 'string' && flag.trim().toLowerCase() === 'true') return true;
        return false;
    };

    const wasMrcSiteSurveySkipped = (row = dialogRowData) => !didMrcSiteSurveyHappen(row);

    const getMrcSkippedSteps = (row = dialogRowData) => {
        const progressId = Number(row?.applicationProgressId);
        // Skip Site Survey on progress bar only when survey was not referred (false/null)
        if (progressId >= 4 && wasMrcSiteSurveySkipped(row)) {
            return [3];
        }
        return [];
    };

    const openMrcReceipt = async (item = {}) => {
        const applicationId = item.applicationId;
        if (!applicationId) {
            showMrcFailedPopup('Receipt is not available for this application yet.');
            return;
        }

        setViewBackdrop(true);
        try {
            const application = (await filterNCApp(applicationId)) || item;
            const documents = await callAsyncGetMRCDocuments(applicationId);
            const referenceNo =
                application.referenceNo ||
                application.refNo ||
                item.referenceNo ||
                '';
            const subDivisionCode =
                application.subDivisionCode ||
                application.subdivisionCode ||
                String(referenceNo || '').slice(2, 7) ||
                '';
            const meterPhaseType =
                application.meterPhaseType || item.meterPhaseType || '';
            // Application's company (from subdivision / reference / API), not login office
            const applicationCompanyCode = String(
                application.companyCode ||
                    application.discoCode ||
                    subDivisionCode ||
                    referenceNo ||
                    '',
            ).slice(0, 2);

            await printMrcApplicationReceipt({
                values: {
                    iv_sub_divison: subDivisionCode,
                    iv_circle:
                        application.circleCode ||
                        application.companyCode ||
                        applicationCompanyCode,
                    iv_applicant_name:
                        application.consumerName ||
                        application.applicantName ||
                        item.consumerName ||
                        item.applicantName ||
                        '',
                    iv_applicant_phone_no:
                        application.applicantMobile ||
                        application.applicantPhoneNo ||
                        application.applicantPhone ||
                        item.applicantMobile ||
                        item.applicantPhoneNo ||
                        '',
                },
                applicationID: applicationId,
                issuedBy: userId,
                referenceNo,
                readingRows: mapMrcDocumentsToReceiptReadingRows(documents, {
                    meterPhaseType,
                }),
                companyCode: applicationCompanyCode,
                userCompany: applicationCompanyCode,
                subDivisions: subDivisions || [],
                applicationDate: application.creationDate || item.creationDate,
            });
        } catch (e) {
            showMrcFailedPopup('Unable to open MRC receipt.');
        } finally {
            setViewBackdrop(false);
        }
    };

    /** NC/COA-style E-Document download */
    const openMrcEFile = async (item = {}) => {
        const applicationId = item.applicationId;
        if (!applicationId) {
            showMrcFailedPopup('E-File is not available for this application yet.');
            return;
        }

        setViewBackdrop(true);
        try {
            const application = (await filterNCApp(applicationId)) || item;
            const documents = await callAsyncGetMRCDocuments(applicationId);
            const historyRows = await callEfileAPI(applicationId, application);
            const statusLabel =
                progFunc(Number(application.applicationProgressId)) ||
                progFunc(Number(item.applicationProgressNumber)) ||
                '';
            const includeCp52 =
                isMrcCp52AlreadyCreated(application) ||
                isMrcCp52AlreadyCreated(item) ||
                Boolean(mrcLocalCp52CreatedIds[applicationId]);
            const progressId = Number(
                application.applicationProgressId ??
                    item.applicationProgressId ??
                    item.applicationProgressNumber
            );
            // Same as ActionsCell Bill menu: CP52 prepared + Post for Billing onward
            const includeBill =
                isMrcBillPostedOnRow(application) ||
                isMrcBillPostedOnRow(item) ||
                (includeCp52 && progressId >= 5);
            const extras = await buildMrcEFileExtras({
                application,
                documents: documents || [],
                token,
                tariffs: allTariffList,
                includeCp52,
                includeBill,
                companyCode: String(
                    selectedAdminCompanyCode || officeCode || '15'
                ).slice(0, 2),
            });

            await downloadMrcEFilePdf({
                application,
                historyRows: historyRows || [],
                documents: documents || [],
                statusLabel,
                subDivisions: subDivisions || [],
                tariffs: allTariffList,
                cp52Src: extras.cp52Src,
                billSrc: extras.billSrc,
            });
        } catch (e) {
            showMrcFailedPopup('Unable to open MRC E-File.');
        } finally {
            setViewBackdrop(false);
        }
    };

    const openMrcBill = async (item = {}, options = {}) => {
        const applicationId = item.applicationId || dialogRowData?.applicationId;
        if (!applicationId) {
            showMrcFailedPopup('Bill is not available for this application yet.');
            return;
        }

        const cp52Form =
            options.cp52FormData !== undefined
                ? options.cp52FormData
                : mrcCp52FormData;
        const oracleOverride =
            options.oracleTrackingId || mrcCp52OracleTrackingId;

        // Application payable ± getCP52 AMOUNT = bill payable
        let applicationPayable = getMrcAmountPayable(item);
        if (!Number.isFinite(applicationPayable)) {
            applicationPayable = getMrcAmountPayable(dialogRowData || {});
        }
        if (!Number.isFinite(applicationPayable)) {
            applicationPayable = '';
        }
        // Same Customer ID shown in application detail table
        let customerId =
            item.customerId ||
            item.consumerId ||
            dialogRowData?.customerId ||
            dialogRowData?.consumerId ||
            '';

        // Same oracle tracking source as CP52 (callGetCp52 / prepare).
        let oracleTrackingId = extractMrcOracleTrackingId(
            item.oracleTrackingId,
            item.OracleTrackingId,
            item.billAdjTrackingId,
            item.billADJTrackingId,
            item.trackingId,
            dialogRowData?.oracleTrackingId,
            dialogRowData?.OracleTrackingId,
            dialogRowData?.billAdjTrackingId,
            dialogRowData?.billADJTrackingId,
            dialogRowData?.trackingId,
            oracleOverride
        );

        if (
            !oracleTrackingId ||
            !Number.isFinite(Number(applicationPayable)) ||
            !customerId
        ) {
            setViewBackdrop(true);
            try {
                const application = (await filterNCApp(applicationId)) || item;
                if (!oracleTrackingId) {
                    oracleTrackingId = extractMrcOracleTrackingId(
                        application,
                        application?.oracleTrackingId,
                        application?.OracleTrackingId,
                        application?.billAdjTrackingId,
                        application?.billADJTrackingId,
                        application?.trackingId,
                        oracleOverride
                    );
                }
                if (!Number.isFinite(Number(applicationPayable))) {
                    const fromApp = getMrcAmountPayable(application);
                    if (Number.isFinite(fromApp)) applicationPayable = fromApp;
                }
                if (!customerId) {
                    customerId =
                        application?.customerId ||
                        application?.consumerId ||
                        customerId;
                }
            } catch (e) {
                // handled below
            } finally {
                setViewBackdrop(false);
            }
        }

        // Temporary fallback while testing bill UI against known CP52 record.
        if (!oracleTrackingId) {
            oracleTrackingId = '3247844';
        }

        // Call DN QR API from THIS tab (visible in Network) before opening bill.
        setViewBackdrop(true);
        const app = item.applicationId ? item : dialogRowData || {};
        let cp52Amount = cp52Form?.totalAdjustment;
        let cp52Row = null;
        try {
            const getResult = await callGetCp52({
                applicationId,
                oracleTrackingId,
                isPostedToIPS: false,
            });
            if (getResult.status == '200' || getResult.status === 200) {
                cp52Row = unwrapMrcCp52Record(getResult) || {};
                cp52Amount =
                    cp52Row.AMOUNT ??
                    cp52Row.CALCULATED_AMOUNT ??
                    cp52Amount;
            }
        } catch (cp52Err) {
            console.warn('[MRC Bill] getCP52 before QR failed', cp52Err);
        }

        const payableAmount = computeMrcBillPayableAmount(
            applicationPayable,
            cp52Amount
        );

        try {
            if (payableAmount < 0) {
                stashMrcBillPaymentQr(null);
            } else {
                const refNo = String(
                    cp52Row?.REFERENCE_NO ||
                        app.referenceNo ||
                        app.refNo ||
                        ''
                )
                    .replace(/\s/g, '')
                    .trim();
                const billNo = refNo;
                const qrPayload = await fetchMrcBillPaymentQr({
                    token,
                    billNo,
                    appNo: applicationId || 'MRC-131422608100003',
                    refNo,
                    amount: Math.abs(payableAmount),
                    dueDate:
                        cp52Row?.DUE_DT ||
                        app.dueDate ||
                        cp52Form?.dueDate ||
                        '',
                    bPeriod:
                        cp52Row?.B_PERIOD ||
                        cp52Row?.COMPLAINTS_BILLING_MONTH ||
                        app.billingMonth ||
                        cp52Form?.billingMonth ||
                        app.dueDate ||
                        '',
                });
                stashMrcBillPaymentQr(qrPayload);
            }
        } catch (qrErr) {
            console.error('[MRC Bill QR] table click failed', qrErr);
            stashMrcBillPaymentQr(null);
        } finally {
            setViewBackdrop(false);
        }

        openMrcBillTab({
            applicationId: applicationId || 'MRC-131422608100003',
            oracleTrackingId,
            isPostedToIPS: false,
            // Same CP52 form already shown in prepare dialog (meter readings etc.)
            cp52FormData: {
                ...(cp52Form || {}),
                customerId: customerId || cp52Form?.customerId || '',
                connectionType:
                    cp52Form?.connectionType ||
                    item.connectionType ||
                    item.consumerType ||
                    dialogRowData?.connectionType ||
                    dialogRowData?.consumerType ||
                    '',
                readingDate:
                    cp52Form?.readingDate ||
                    item.readingDate ||
                    dialogRowData?.readingDate ||
                    app?.readingDate ||
                    '',
                tariffDisplay: resolveMrcTariffDisplay(
                    cp52Form?.tariffCode ||
                        cp52Form?.tariff ||
                        item.tariffCode ||
                        item.tariff ||
                        dialogRowData?.tariffCode ||
                        dialogRowData?.tariff ||
                        dialogRowData?.TARIFF_ACTIVE ||
                        '',
                    allTariffList,
                ),
            },
            payableWithinDueDate: applicationPayable,
            customerId,
        });
    };

    const openBill = (item) => {
        openMrcBill(item);
    }

    const mapMrcRowsToDataGrid = (rows) => {
        const tempArray = []
        if (rows) {
            rows.forEach((item) => {
                if (item.applicationId) {
                    tempArray.push({
                        applicationId: item.applicationId,
                        applicationType: item.applicationType || 11,
                        creationDate: convertDate(item.creationDate),
                        referenceNo: item.referenceNo,
                        applicantName: item.consumerName || item.applicantName || '',
                        applicantPhone: item.applicantMobile || item.applicantPhoneNo || '',
                        applicationProgressId: progFunc(item.applicationProgressId),
                        applicationProgressNumber: item.applicationProgressId,
                        billAdjTrackingId:
                            item.billAdjTrackingId || item.billADJTrackingId || '',
                        oracleTrackingId:
                            item.oracleTrackingId ||
                            item.OracleTrackingId ||
                            item.billAdjTrackingId ||
                            item.billADJTrackingId ||
                            '',
                        isBillPosted: item.isBillPosted,
                        isBillGenerated: item.isBillGenerated,
                        isCP52Created:
                            isMrcCp52AlreadyCreated(item) ||
                            Boolean(mrcLocalCp52CreatedIds[item.applicationId]),
                        downloadReceipt: () => openMrcReceipt(item),
                        downloadEFile: () => openMrcEFile(item),
                        downloadBill: () => openMrcBill(item),
                    })
                }
            })
        }
        return tempArray;
    }

    const apiToDataGridConversion = async () => {
        setMrcComplaintsToDataGrid(mapMrcRowsToDataGrid(mrcComplaints));
    }

    const apiToDataGridConversionOverdue = async () => {
        setMrcComplaintsOverdueToDataGrid(mapMrcRowsToDataGrid(mrcComplaintsOverdue));
    }

    const hideOffPeakImportImgPopUp = (x) => {
        setOffPeakImportImgVerifyPopUp(x);
    }

    const hideOffPeakExportImgPopUp = (x) => {
        setOffPeakExpVerifyPopUp(x);
    }

    const hidePeakImportImgPopUp = (x) => {
        setPeakImportImgVerifyPopUp(x);
    }

    const hidePeakExportImgPopUp = (x) => {
        setPeakExpVerifyPopUp(x);
    }

    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        const item = await filterNCApp(applicationId);
        if (!item) {
            setViewBackdrop(false);
            return;
        }
        setTableDataProcessingSummary([]);
        setEFileData([]);
        setEFileCurrentStatus({});
        setMrcTotalDuration('-');
        setActivityLogCollapsed(true);
        setActivityLogDetailOpen(false);
        setHistoryData(null);
        setHistoryDetailPopUp(false);
        setHistoryReadingDocuments([]);
        setHistoryReadingLoading(false);
        const itemWithMonths = item;
        // const itemWithMonths = withMrcNoOfMonths(item);
        setDialogRowData(itemWithMonths);
        // setMrcSegregationMonth(pickMrcSegregationMonth(itemWithMonths));
        setMrcDocuments([]);
        setMrcCp52Prepared(false);
        setMrcForcePrepareCp52(false);
        setMrcCp52Preparing(false);
        setMrcCp52PrepareDialogOpen(false);
        setMrcCp52PrepareResponse(null);
        setMrcCp52FormData(null);
        setMrcCp52OracleTrackingId('');
        setIsBillPosted(isMrcBillPostedOnRow(item));
        if (
            item.applicationProgressId === 1 ||
            item.applicationProgressId === 2 ||
            item.applicationProgressId === 3 ||
            item.applicationProgressId === 4 ||
            item.applicationProgressId === 5
        ) {
            await callAsyncGetMRCDocuments(item.applicationId);
        } else {
            // await callAsyncGetSInitialReading(item.applicationId, item.meterPhaseType);
        }
        if (item.applicationProgressId === 3) {
            // Site Survey uses getMRCDocuments table (readings + site images).
        }

        // Duration + Activity Log: load history as soon as dialog opens
        await callEfileAPI(item.applicationId, item);

        setOpen(true);
        setViewBackdrop(false);
    };

    useImperativeHandle(ref, () => ({
        handleRowClick,
    }));

    const handleChangeIsCheckedRejectApplication = (event) => {
        setIsCheckedRejectApplication(event.target.checked);
    };


    useEffect(() => {
        if (singlePhaseInitialReadings) {
            let untsToCorrect = parseInt(singlePhaseInitialReadings.currentReadingSinglePhase) - parseInt(singlePhaseInitialReadings.claimedReadingSinglePhase)
            setUnitsToCorrect(untsToCorrect)
        }
    }, [singlePhaseInitialReadings])

    useEffect(() => {
        if (netMeterInitialReadings) {
            let untsToCorrect = (parseInt(netMeterInitialReadings.currentOffpeakImport) - parseInt(netMeterInitialReadings.claimedOffpeakImport)) + (parseInt(netMeterInitialReadings.currentPeakImport) - parseInt(netMeterInitialReadings.claimedPeakImport))
            setUnitsToCorrect(untsToCorrect)
        }
    }, [netMeterInitialReadings])

    useEffect(() => {
        if (threePhaseInitialReadings) {
            let untsToCorrect = (parseInt(threePhaseInitialReadings.currentOffPeakThreePhase) - parseInt(threePhaseInitialReadings.claimedOffPeakThreePhase)) + (parseInt(threePhaseInitialReadings.currentPeakThreePhase) - parseInt(threePhaseInitialReadings.claimedPeakThreePhase))
            setUnitsToCorrect(untsToCorrect)
        }
    }, [threePhaseInitialReadings])

    useEffect(() => {
        if (threePhaseMDIInitialReadings) {
            let untsToCorrect = (parseInt(threePhaseMDIInitialReadings.currentOffPeakThreePhaseMdi) - parseInt(threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdi)) + (parseInt(threePhaseMDIInitialReadings.currentPeakThreePhaseMdi) - parseInt(threePhaseMDIInitialReadings.claimedPeakThreePhaseMdi))
            setUnitsToCorrect(untsToCorrect)
        }
    }, [threePhaseMDIInitialReadings])


    useEffect(() => {
        if (threePhaseMDINetMeterInitialReadings) {
            let untsToCorrect =
                (parseInt(threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiImport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImport)) + (parseInt(threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiImport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImport))
                +
                (parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiImport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiImport)) + (parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiImport) - parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiImport))
                +
                (parseInt(threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiExport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiExport)) + (parseInt(threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiExport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiExport))
                +
                (parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiExport) - parseInt(threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiExport)) + (parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiExport) - parseInt(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiExport))
            setUnitsToCorrect(untsToCorrect)
        }
    }, [threePhaseMDINetMeterInitialReadings])

    const errorCloses = () => {
        setError('')
        // setFieldSurveyError('')
    }

    const callEfileAPI = async (applicationId, application) => {
        try {
            setViewDropBackForEfile(true);

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const response = await fetch(`${cfpBaseUrl}mrc/getBasicMRCHistory`, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify({ applicationId }),
            });

            const result = await response.json();

            if (result.status === "200" && result.data) {
                const applicationHistory = (result.data.history || [])
                    .filter(Boolean)
                    .map(normalizeMrcHistoryItem);
                const applicationCurrentState = normalizeMrcHistoryItem(
                    result.data.currentStatus?.[0] || {},
                );

                // Keep API pattern: newest → oldest (top to bottom), prefer historyId
                const sortedApiOrder = [...applicationHistory].sort((a, b) => {
                    const idDiff = Number(b.historyId || 0) - Number(a.historyId || 0);
                    if (idDiff !== 0) return idDiff;
                    return (
                        new Date(b.lastModificationDate || 0) -
                        new Date(a.lastModificationDate || 0)
                    );
                });

                setEFileData(sortedApiOrder);
                setEFileCurrentStatus({
                    ...applicationCurrentState,
                    mRCProgStatusName: getMrcHistoryStepName(
                        applicationCurrentState,
                    ),
                    mrcProgStatusName: getMrcHistoryStepName(
                        applicationCurrentState,
                    ),
                    applicationProgressId:
                        application?.applicationProgressId ??
                        applicationCurrentState.applicationProgressId,
                });

                const dataforTable = sortedApiOrder.map((item) => {
                    return {
                        stepName: getMrcHistoryStepName(item) || '-',
                        processedBy:
                            item.lastModifiedBy ||
                            applicationCurrentState.createdBy ||
                            '-',
                        date: item.lastModificationDate
                            ? convertDatewithTime(item.lastModificationDate)
                            : '-',
                        remarks: item.remarks || '-',
                        historyId: item.historyId,
                        applicationProgressId: item.applicationProgressId,
                        historyProgressId: item.historyProgressId,
                        _raw: item,
                    };
                });

                const detailRows = buildMrcActivityLogDetailRows(
                    sortedApiOrder,
                    {
                        ...applicationCurrentState,
                        applicationProgressId:
                            application?.applicationProgressId ??
                            applicationCurrentState.applicationProgressId,
                    },
                    convertDatewithTime,
                );
                const totalRow = buildActivityLogDetailTotalRow(
                    detailRows,
                    convertDatewithTime,
                );
                setMrcTotalDuration(totalRow?.durationLabel || '-');

                setTableDataProcessingSummary(dataforTable);
                return dataforTable;
            }

            setEFileData([]);
            setTableDataProcessingSummary([]);
            setMrcTotalDuration('-');
            return [];
        } catch (error) {
            setEFileData([]);
            setTableDataProcessingSummary([]);
            setMrcTotalDuration('-');
            return [];
        } finally {
            setViewDropBackForEfile(false);
        }
    };

    const onPressViewActivityLog = async () => {
        if (!dialogRowData?.applicationId) return;
        await callEfileAPI(dialogRowData.applicationId, dialogRowData);
    };

    const openDetailsPopUp = async (rowOrStep) => {
        const historyRow =
            rowOrStep && typeof rowOrStep === "object"
                ? rowOrStep._raw || rowOrStep
                : null;

        if (historyRow?.historyId == null) {
            return;
        }

        // Open the history dialog immediately with one in-dialog loader.
        // Do not use the page Backdrop or refresh live mrcDocuments — that
        // was showing two eOps loaders on Forward for Billing.
        setHistoryData(normalizeMrcHistoryItem(historyRow));
        setHistoryReadingDocuments([]);
        setHistoryReadingLoading(false);
        setHistoryDetailPopUp(true);

        try {
            const applicationId = dialogRowData.applicationId;
            const historyPayload = await fetchMrcHistoryDetail(
                applicationId,
                historyRow.historyId,
            );

            const detail = historyPayload.detail;
            if (!detail) return;

            const merged = normalizeMrcHistoryItem({
                ...historyRow,
                ...detail,
                historyId: historyRow.historyId ?? detail.historyId,
                historyProgressId:
                    historyRow.historyProgressId ?? detail.historyProgressId,
                applicationProgressId:
                    historyRow.applicationProgressId ??
                    detail.applicationProgressId,
                mRCProgStatusName:
                    getMrcHistoryStepName(historyRow) ||
                    getMrcHistoryStepName(detail),
                remarks: detail.remarks ?? historyRow.remarks,
                remarksDetail:
                    detail.remarksDetail ?? historyRow.remarksDetail,
                lastModifiedBy:
                    detail.lastModifiedBy ?? historyRow.lastModifiedBy,
                lastModificationDate:
                    detail.lastModificationDate ??
                    historyRow.lastModificationDate,
                submittedThrough:
                    detail.submittedThrough ??
                    historyRow.submittedThrough ??
                    dialogRowData?.submittedThrough ??
                    null,
            });

            setHistoryData(merged);

            // History reading table hidden for now — skip document/meter snapshot fetch.
            // const [historyPayload, historyDocs] = await Promise.all([
            //     fetchMrcHistoryDetail(applicationId, historyRow.historyId),
            //     callAsyncGetMRCDocuments(applicationId, {
            //         historyId: historyRow.historyId,
            //         updateState: false,
            //     }),
            // ]);
            // ... resolveMrcHistoryReadingDocuments(...)
        } catch (error) {
            // ignore
        }
    };

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submitted'
        }
        else if (x === 1) {
            return 'Document Verification'
        }
        else if (x === 2) {
            return 'Authority Verification'
        }
        else if (x === 3) {
            return 'Site Survey'
        }
        else if (x === 4) {
            return 'Forward for Billing'
        }
        else if (x === 5) {
            return 'Post for Billing'
        }
        else if (x === 6) {
            return 'Completed'
        }
    };

    const SinglePhaseSurveyReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'singlePhaseSurveyReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setSinglePhaseSurveyReadingImage, setSinglePhaseSurveyReadingImageError, setSinglePhaseSurveyReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseSurveyOffPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseSurveyOffPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseSurveyOffPeakReadingImage, setThreePhaseSurveyOffPeakReadingImageError, setThreePhaseSurveyOffPeakReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseSurveyPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseSurveyPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseSurveyPeakReadingImage, setThreePhaseSurveyPeakReadingImageError, setThreePhaseSurveyPeakReadingImageThumbnail, newFileName);
        }
    };

    //Net Meter

    const NetMeterSurveyOffPeakImportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'netMeterSurveyOffPeakImportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setNetMeterSurveyOffPeakImportReadingImage, setNetMeterSurveyOffPeakImportReadingImageError, setNetMeterSurveyOffPeakImportReadingImageThumbnail, newFileName);
        }
    };

    const NetMeterSurveyPeakImportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'netMeterSurveyPeakImportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setNetMeterSurveyPeakImportReadingImage, setNetMeterSurveyPeakImportReadingImageError, setNetMeterSurveyPeakImportReadingImageThumbnail, newFileName);
        }
    };

    const NetMeterSurveyOffPeakExportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'netMeterSurveyOffPeakExportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setNetMeterSurveyOffPeakExportReadingImage, setNetMeterSurveyOffPeakExportReadingImageError, setNetMeterSurveyOffPeakExportReadingImageThumbnail, newFileName);
        }
    };

    const NetMeterSurveyPeakExportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'netMeterSurveyPeakExportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setNetMeterSurveyPeakExportReadingImage, setNetMeterSurveyPeakExportReadingImageError, setNetMeterSurveyPeakExportReadingImageThumbnail, newFileName);
        }
    };

    // Three Phase MDI Meter
    const ThreePhaseMDISurveyOffPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDISurveyOffPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDISurveyOffPeakReadingImage, setThreePhaseMDISurveyOffPeakReadingImageError, setThreePhaseMDISurveyOffPeakReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDISurveyPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDISurveyPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDISurveyPeakReadingImage, setThreePhaseMDISurveyPeakReadingImageError, setThreePhaseMDISurveyPeakReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDISurveykVArhOffPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDISurveykVArhOffPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDISurveykVArhOffPeakReadingImage, setThreePhaseMDISurveykVArhOffPeakReadingImageError, setThreePhaseMDISurveykVArhOffPeakReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDISurveykVArhPeakReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDISurveykVArhPeakReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDISurveykVArhPeakReadingImage, setThreePhaseMDISurveykVArhPeakReadingImageError, setThreePhaseMDISurveykVArhPeakReadingImageThumbnail, newFileName);
        }
    };

    // Three Phase MDI Net Meter
    const ThreePhaseMDINetMeterSurveyOffPeakImportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDINetMeterSurveyOffPeakImportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImage, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImageError, setThreePhaseMDINetMeterSurveyOffPeakImportReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDINetMeterSurveyPeakImportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDINetMeterSurveyPeakImportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDINetMeterSurveyPeakImportReadingImage, setThreePhaseMDINetMeterSurveyPeakImportReadingImageError, setThreePhaseMDINetMeterSurveyPeakImportReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDINetMeterSurveyOffPeakExportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDINetMeterSurveyOffPeakExportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImage, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImageError, setThreePhaseMDINetMeterSurveyOffPeakExportReadingImageThumbnail, newFileName);
        }
    };

    const ThreePhaseMDINetMeterSurveyPeakExportReadingImage = (event) => {
        if (event.target.files) {
            const newFileName = 'threePhaseMDINetMeterSurveyPeakExportReadingImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, meterReaderFieldSurveyFormik.handleChange, setThreePhaseMDINetMeterSurveyPeakExportReadingImage, setThreePhaseMDINetMeterSurveyPeakExportReadingImageError, setThreePhaseMDINetMeterSurveyPeakExportReadingImageThumbnail, newFileName);
        }
    };


    //#endregion
    const handleProgressIdFilterNormal = (value) => {
        if (value || value === 0) {
            dispatch(firstPage())
            dispatch(filterProgressIdNormal(value))
        }
    }
    const handleResetProgressIdFilterNormal = () => {
        dispatch(firstPage())
        dispatch(resetProgressIdFilterNormal())
    }
    //#region formiks

    const applicationVerificationWithNewReadingsFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_approval_remarks: Yup.string().required('Enter remarks for approval!'),
            //Single Phase Meter
            iv_approvedReadingSinglePhase: Yup.number().when('dialogRowData.meterPhaseType', {
                is: () => (dialogRowData.meterPhaseType == '1 phase meter'),
                then: Yup.number().required('Enter Reading.').min(singlePhaseInitialReadings.previousReadingSinglePhase, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

            //Three Phase Meter
            iv_approvedOffPeakThreePhase: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseInitialReadings.previousOffPeakThreePhase, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakThreePhase: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseInitialReadings.previousPeakThreePhase, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

            //Three Phase Net meter
            iv_approvedOffPeakImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousOffpeakImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousPeakImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedOffPeakExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousOffpeakExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousPeakExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

            // Three Phase MDI Meter
            iv_approvedOffPeakThreePhaseMdi: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previousOffPeakThreePhaseMdi, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakThreePhaseMdi: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previousPeakThreePhaseMdi, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhOffPeakThreePhaseMdi: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previouskVArhOffPeakThreePhaseMdi, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhPeakThreePhaseMdi: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previouskVArhPeakThreePhaseMdi, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

            //Three Phase MDI Net Meter
            iv_approvedOffPeakThreePhaseMdiImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakThreePhaseMdiImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhOffPeakThreePhaseMdiImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhPeakThreePhaseMdiImport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiImport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedOffPeakThreePhaseMdiExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedPeakThreePhaseMdiExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhOffPeakThreePhaseMdiExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_approvedkVArhPeakThreePhaseMdiExport: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiExport, `Approved reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            await callAsyncInsertApprovedReadings(
                dialogRowData.applicationId,
                dialogRowData.meterPhaseType,
                values.iv_approval_remarks,
                //Single Phase
                values.iv_approvedReadingSinglePhase,
                //Three Phase
                values.iv_approvedOffPeakThreePhase,
                values.iv_approvedPeakThreePhase,
                //Net Meter
                values.iv_approvedOffPeakImport,
                values.iv_approvedPeakImport,
                values.iv_approvedOffPeakExport,
                values.iv_approvedPeakExport,
                //Three Phase MDI
                values.iv_approvedOffPeakThreePhaseMdi,
                values.iv_approvedPeakThreePhaseMdi,
                values.iv_approvedkVArhOffPeakThreePhaseMdi,
                values.iv_approvedkVArhPeakThreePhaseMdi,
                //Three Phase MDI Net Meter
                values.iv_approvedOffPeakThreePhaseMdiImport,
                values.iv_approvedPeakThreePhaseMdiImport,
                values.iv_approvedkVArhOffPeakThreePhaseMdiImport,
                values.iv_approvedkVArhPeakThreePhaseMdiImport,
                values.iv_approvedOffPeakThreePhaseMdiExport,
                values.iv_approvedPeakThreePhaseMdiExport,
                values.iv_approvedkVArhOffPeakThreePhaseMdiExport,
                values.iv_approvedkVArhPeakThreePhaseMdiExport
            )
            setViewBackdrop(false)
        }
    });

    const meterReaderFieldSurveyFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({

            // Single Phase Meter
            iv_singlePhaseSurveyReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '1 phase meter',
                then: Yup.number().required('Enter Reading.').min(singlePhaseInitialReadings.previousReadingSinglePhase, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_singlePhaseSurveyReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '1 phase meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),

            //Three Phase Meter
            iv_threePhaseSurveyOffPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseInitialReadings.previousOffPeakThreePhase, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseSurveyOffPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseSurveyPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseInitialReadings.previousPeakThreePhase, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseSurveyPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),

            // Net Meter
            iv_netMeterSurveyOffPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousOffpeakImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_netMeterSurveyOffPeakImportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_netMeterSurveyPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousPeakImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_netMeterSurveyPeakImportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_netMeterSurveyOffPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousOffpeakExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_netMeterSurveyOffPeakExportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_netMeterSurveyPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.number().required('Enter Reading.').min(netMeterInitialReadings.previousPeakExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_netMeterSurveyPeakExportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == 'net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),

            // THree Phase MDI Meter 
            iv_threePhaseMDISurveyOffPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previousOffPeakThreePhaseMdi, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDISurveyOffPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDISurveyPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previousPeakThreePhaseMdi, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDISurveyPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDISurveykVArhOffPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previouskVArhOffPeakThreePhaseMdi, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDISurveykVArhOffPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDISurveykVArhPeakReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDIInitialReadings.previouskVArhPeakThreePhaseMdi, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDISurveykVArhPeakReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),

            // Three Phase MDI Net Meter
            iv_threePhaseMDINetMeterSurveyOffPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveyOffPeakImportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDINetMeterSurveyPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveyPeakImportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDINetMeterSurveykVArhOffPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveykVArhPeakImportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiImport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            // Export
            iv_threePhaseMDINetMeterSurveyOffPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveyOffPeakExportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDINetMeterSurveyPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveyPeakExportReadingImage: Yup.string().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.string().required('Upload Image.'),
                otherwise: Yup.string().optional()
            }),
            iv_threePhaseMDINetMeterSurveykVArhOffPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),
            iv_threePhaseMDINetMeterSurveykVArhPeakExportReading: Yup.number().when('connectionType', {
                is: () => dialogRowData.meterPhaseType == '3 phase mdi net meter',
                then: Yup.number().required('Enter Reading.').min(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiExport, `Survey reading can't be less than last month!`),
                otherwise: Yup.number().optional()
            }),

        }),

        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const raw = JSON.stringify({
                applicationId: dialogRowData.applicationId,
                meterPhaseType: dialogRowData.meterPhaseType,
                applicationProgressId: 3,
                objectionStatus: 0,
                lastModifiedBy: userId,
                remarks: "Site Surveyed.",

                //Single Phase
                fieldSurveyReadingSinglePhase: dialogRowData.meterPhaseType == "1 phase meter" ? values.iv_singlePhaseSurveyReading : "",
                fieldSurveyReadingSinglePhaseImage: dialogRowData.meterPhaseType == "1 phase meter" ? singlePhaseSurveyReadingImageThumbnail : "",

                //Three Phase
                fieldSurveyOffPeakThreePhase: dialogRowData.meterPhaseType == "3 phase meter" ? values.iv_threePhaseSurveyOffPeakReading : "",
                fieldSurveyOffPeakThreePhaseImage: dialogRowData.meterPhaseType == "3 phase meter" ? threePhaseSurveyOffPeakReadingImageThumbnail : "",
                fieldSurveyPeakThreePhase: dialogRowData.meterPhaseType == "3 phase meter" ? values.iv_threePhaseSurveyPeakReading : "",
                fieldSurveyPeakThreePhaseImage: dialogRowData.meterPhaseType == "3 phase meter" ? threePhaseSurveyPeakReadingImageThumbnail : "",

                //Net Meter
                fieldSurveyOffPeakImport: dialogRowData.meterPhaseType == "net meter" ? values.iv_netMeterSurveyOffPeakImportReading : "",
                fieldSurveyOffPeakImportImage: dialogRowData.meterPhaseType == "net meter" ? netMeterSurveyOffPeakImportReadingImageThumbnail : "",
                fieldSurveyPeakImport: dialogRowData.meterPhaseType == "net meter" ? values.iv_netMeterSurveyPeakImportReading : "",
                fieldSurveyPeakImportImage: dialogRowData.meterPhaseType == "net meter" ? netMeterSurveyPeakImportReadingImageThumbnail : "",
                fieldSurveyOffPeakExport: dialogRowData.meterPhaseType == "net meter" ? values.iv_netMeterSurveyOffPeakExportReading : "",
                fieldSurveyOffPeakExportImage: dialogRowData.meterPhaseType == "net meter" ? netMeterSurveyOffPeakExportReadingImageThumbnail : "",
                fieldSurveyPeakExport: dialogRowData.meterPhaseType == "net meter" ? values.iv_netMeterSurveyPeakExportReading : "",
                fieldSurveyPeakExportImage: dialogRowData.meterPhaseType == "net meter" ? netMeterSurveyPeakExportReadingImageThumbnail : "",

                //Three Phase MDI
                fieldSurveyOffPeakThreePhaseMdi: dialogRowData.meterPhaseType == "3 phase mdi meter" ? values.iv_threePhaseMDISurveyOffPeakReading : "",
                fieldSurveyOffPeakThreePhaseMdiImage: dialogRowData.meterPhaseType == "3 phase mdi meter" ? threePhaseMDISurveyOffPeakReadingImageThumbnail : "",
                fieldSurveyPeakThreePhaseMdi: dialogRowData.meterPhaseType == "3 phase mdi meter" ? values.iv_threePhaseMDISurveyPeakReading : "",
                fieldSurveyPeakThreePhaseMdiImage: dialogRowData.meterPhaseType == "3 phase mdi meter" ? threePhaseMDISurveyPeakReadingImageThumbnail : "",
                fieldSurveykVArhOffPeakThreePhaseMdi: dialogRowData.meterPhaseType == "3 phase mdi meter" ? values.iv_threePhaseMDISurveykVArhOffPeakReading : "",
                fieldSurveykVArhOffPeakThreePhaseMdiImage: dialogRowData.meterPhaseType == "3 phase mdi meter" ? threePhaseMDISurveykVArhOffPeakReadingImageThumbnail : "",
                fieldSurveykVArhPeakThreePhaseMdi: dialogRowData.meterPhaseType == "3 phase mdi meter" ? values.iv_threePhaseMDISurveykVArhPeakReading : "",
                fieldSurveykVArhPeakThreePhaseMdiImage: dialogRowData.meterPhaseType == "3 phase mdi meter" ? threePhaseMDISurveykVArhPeakReadingImageThumbnail : "",

                //Three Phase MDI Net meter
                // Import
                fieldSurveyOffPeakThreePhaseMdiImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveyOffPeakImportReading : "",
                fieldSurveyOffPeakThreePhaseMdiImageImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? threePhaseMDINetMeterSurveyOffPeakImportReadingImageThumbnail : "",
                fieldSurveyPeakThreePhaseMdiImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveyPeakImportReading : "",
                fieldSurveyPeakThreePhaseMdiImageImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? threePhaseMDINetMeterSurveyPeakImportReadingImageThumbnail : "",
                fieldSurveykVArhOffPeakThreePhaseMdiImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveykVArhOffPeakImportReading : "",
                fieldSurveykVArhOffPeakThreePhaseMdiImageImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? "" : "",
                fieldSurveykVArhPeakThreePhaseMdiImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveykVArhPeakImportReading : "",
                fieldSurveykVArhPeakThreePhaseMdiImageImport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? "" : "",
                //Export
                fieldSurveyOffPeakThreePhaseMdiExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveyOffPeakExportReading : "",
                fieldSurveyOffPeakThreePhaseMdiImageExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? threePhaseMDINetMeterSurveyOffPeakExportReadingImageThumbnail : "",
                fieldSurveyPeakThreePhaseMdiExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveyPeakExportReading : "",
                fieldSurveyPeakThreePhaseMdiImageExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? threePhaseMDINetMeterSurveyPeakExportReadingImageThumbnail : "",
                fieldSurveykVArhOffPeakThreePhaseMdiExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveykVArhOffPeakExportReading : "",
                fieldSurveykVArhOffPeakThreePhaseMdiImageExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? '' : "",
                fieldSurveykVArhPeakThreePhaseMdiExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? values.iv_threePhaseMDINetMeterSurveykVArhPeakExportReading : "",
                fieldSurveykVArhPeakThreePhaseMdiImageExport: dialogRowData.meterPhaseType == "3 phase mdi net meter" ? '' : "",
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "MRC/insertFieldSurveyReadings", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status == "200" || result.status === 200) {
                        resetForm()
                        showMrcSuccessPopup('siteSurveySubmitted')
                    } else {
                        showMrcFailedPopup(result.error || result.message || "Unable to submit site survey readings.")
                    }
                })
                .catch(() => {
                    showMrcFailedPopup("Unable to submit site survey readings.");
                });
            setViewBackdrop(false);
        }
    });

    const objectionFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_reason_for_objection: Yup.string().required('Select reason for objection.')
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                await callChangeObjectionStatus(values.iv_reason_for_objection, 1, dialogRowData.applicationId, '-')
            }
            catch (e) {
            }
        }
    });

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (mrcComplaints) {
            apiToDataGridConversion()
        }
    }, [mrcComplaints, mrcLocalCp52CreatedIds]);

    useEffect(() => {
        if (mrcComplaintsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [mrcComplaintsOverdue, mrcLocalCp52CreatedIds]);

    useEffect(() => {
        if (!(props.showTable && currentPath === "/meter-reading-correction-table")) return;
        if (foundId && foundId !== '') {
            setFoundInMRC(foundId)
        }
    }, [foundId, props.showTable, currentPath])

    useEffect(() => {
        if (!(props.showTable && currentPath === "/meter-reading-correction-table")) return;
        if (foundInMRC) {
            handleRowClick(foundInMRC)
        }
    }, [foundInMRC, props.showTable, currentPath])

    useLayoutEffect(() => {
        if (!(props.showTable && currentPath === "/meter-reading-correction-table")) return;
        if (mrcComplaints.length >= 1) {
            if (foundInMRC && foundInMRC !== '') {
                handleRowClick(foundInMRC)
            }
        }
    }, [mrcComplaints, props.showTable, currentPath])

    //#endregion

    const tblColumns = [
        {
            field: "applicationId",
            headerName: 'Application Id',
            align: 'left',
            sortable: false,
            filterable: false,
            showFullApplicationId: true,
            preserveColumnWidth: true,
            headerStyle: {
                ...tableStyle.headerStyle,
                width: '25%',
                minWidth: '210px',
                maxWidth: '240px',
            },
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
        },
        // {
        //     field: "creationDate",
        //     type: 'dateTime',
        //     headerName: 'Submission Date',
        //     align: 'left',
        //     sortable: false,
        //     filterable: false,
        //     preserveColumnWidth: true,
        //     headerStyle: {
        //         ...tableStyle.headerStyle,
        //         width: '12%',
        //         minWidth: '110px',
        //         maxWidth: '130px',
        //     },
        //     headerCellStyle: tableStyle.headerCellStyle,
        //     rowCellStyle: tableStyle.rowCellStyle,
        // },
        {
            field: "referenceNo",
            headerName: 'Reference No.',
            align: 'left',
            sortable: false,
            filterable: false,
            preserveColumnWidth: true,
            headerStyle: {
                ...tableStyle.headerStyle,
                width: '17%',
                minWidth: '140px',
                maxWidth: '175px',
            },
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
        },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "applicantPhone", headerName: 'Applicant Phone', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicationProgressId", type: 'singleSelect', sortable: false, filterable: true, valueOptions: ['Application Submission', 'Document Verification', 'Authority Verification', 'Site Survey', 'Forward for Billing', 'Post for Billing', 'Completed'], headerName: 'Description', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '12px' } },
        {
            headerName: 'Docs.',
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            flex: 1,
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: {
                ...tableStyle.rowCellStyle,
                fontSize: '15px',
                overflow: 'visible',
            },
            field: 'downloads',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <ActionsCell data={params} serviceKind="mrc" />
            ),
        },
    ]

    const tblColumnsOverDue = [
        {
            field: "applicationId",
            headerName: 'Application Id',
            align: 'left',
            sortable: false,
            filterable: false,
            showFullApplicationId: true,
            preserveColumnWidth: true,
            headerStyle: {
                ...tableStyleOverDue.headerStyle,
                width: '25%',
                minWidth: '210px',
                maxWidth: '240px',
            },
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
        },
        // {
        //     field: "creationDate",
        //     type: 'dateTime',
        //     headerName: 'Submission Date',
        //     align: 'left',
        //     sortable: false,
        //     filterable: false,
        //     preserveColumnWidth: true,
        //     headerStyle: {
        //         ...tableStyleOverDue.headerStyle,
        //         width: '12%',
        //         minWidth: '110px',
        //         maxWidth: '130px',
        //     },
        //     headerCellStyle: tableStyleOverDue.headerCellStyle,
        //     rowCellStyle: tableStyleOverDue.rowCellStyle,
        // },
        {
            field: "referenceNo",
            headerName: 'Reference No.',
            align: 'left',
            sortable: false,
            filterable: false,
            preserveColumnWidth: true,
            headerStyle: {
                ...tableStyleOverDue.headerStyle,
                width: '17%',
                minWidth: '140px',
                maxWidth: '175px',
            },
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
        },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        // { field: "applicantPhone", headerName: 'Applicant Phone', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "applicationProgressId", type: 'singleSelect', sortable: false, filterable: true, valueOptions: ['Application Submission', 'Document Verification', 'Authority Verification', 'Site Survey', 'Forward for Billing', 'Post for Billing', 'Completed'], headerName: 'Description', align: 'left', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '12px' } },
        {
            headerName: 'Docs.',
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            flex: 1,
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: {
                ...tableStyleOverDue.rowCellStyle,
                fontSize: '15px',
                overflow: 'visible',
            },
            field: 'downloads',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <ActionsCell data={params} theme="overdue" serviceKind="mrc" />
            ),
        },
    ]

    const mrcValidationSnackbar = (
        <Snackbar
            open={Boolean(error)}
            autoHideDuration={8000}
            onClose={(_, reason) => {
                if (reason === "clickaway") return;
                errorCloses();
            }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
        >
            <div className="mrc-validation-toast" role="alert" aria-live="assertive">
                <div className="mrc-validation-toast__icon-wrap" aria-hidden="true">
                    <WarningRoundedIcon className="mrc-validation-toast__icon" />
                </div>
                <span className="mrc-validation-toast__divider" aria-hidden="true" />
                <div className="mrc-validation-toast__body">
                    <p className="mrc-validation-toast__eyebrow">Error</p>
                    <p className="mrc-validation-toast__message">
                        {error}
                    </p>
                </div>
                <IconButton
                    size="small"
                    aria-label="Dismiss validation message"
                    className="mrc-validation-toast__close"
                    onClick={errorCloses}
                    sx={{ position: "absolute", top: 6, right: 6 }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>
        </Snackbar>
    );

    const handleCloseResultPopup = () => {
        if (resultPopup) {
            setResultPopup(null);
            setResultPopupTrackingId('');
            resultPopupBillContextRef.current = null;
            return;
        }
        setApiPopup({ open: false, type: '', message: '' });
    };

    const mrcResultDialogConfig = {
        verified: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Verified Successfully',
            message: 'Meter Reading Correction documents verified successfully.',
        },
        docsRejected: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Documents Rejected',
            message: 'Meter Reading Correction documents have been rejected.',
        },
        authorityApproved: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Approved Successfully',
            message: 'Authority verification completed successfully.',
        },
        authorityRejected: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Rejected Successfully',
            message: 'Application has been rejected by Authority.',
        },
        referredToSiteSurvey: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Referred Successfully',
            message: 'Application has been referred to Site Survey.',
        },
        siteSurveySubmitted: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Submitted Successfully',
            message: 'Site Survey submitted successfully.',
        },
        forwardedToBilling: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Approved Successfully',
            message: 'Application forwarded for Billing successfully.',
        },
        returnedToSiteSurvey: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Returned to Site Survey',
            message: 'Application has been returned to Site Survey.',
        },
        returnedToForwardForBilling: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Returned Successfully',
            message: 'Application has been returned to Forward for Billing.',
        },
        returnedToAuthorityVerification: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Returned Successfully',
            message: 'Application has been returned to Authority Verification.',
        },
        completed: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Completed Successfully',
            message: 'Meter Reading Correction request completed successfully.',
        },
        postedForBilling: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Posted Successfully',
            message: 'Application has been posted for billing successfully.',
            showBill: true,
        },
        error: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Request Failed',
        },
    };

    const isRejectResultPopup = apiPopup.type === 'error';

    const activeMrcResultDialog = resultPopup
        ? mrcResultDialogConfig[resultPopup]
        : apiPopup.open && apiPopup.type
            ? mrcResultDialogConfig[apiPopup.type]
            : null;

    const activeResultMessage = resultPopup
        ? mrcResultDialogConfig[resultPopup]?.message
        : apiPopup.message;

    const activeResultTrackingId = resultPopup ? resultPopupTrackingId : '';

    return (
        <>
            <ServiceDashboardTables
                enabled={props.showTable && currentPath === "/meter-reading-correction-table"}
                isLoadingNormal={isLoading}
                isLoadingOverdue={isLoadingOverdue}
                normalTitle={`Meter Reading Correction ( ${numberFormatting(totalRecords) ? numberFormatting(totalRecords) : "-"} )`}
                overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={mrcComplaintsToDataGrid}
                overdueData={mrcComplaintsOverdueToDataGrid}
                onRowClick={handleRowClick}
                mobileFields={["applicationId", "applicantName", "applicationProgressId"]}
                showCompanyFilter={officeCode == 10}
                selectedOfficeCode={selectedOfficeCode}
                onOfficeCodeChange={setSelectedOfficeCode}
                normalTableProps={{
                    firstPage: handleFirstPage,
                    lastPage: handleLastPage,
                    totalPages: totalPages,
                    totalRecords: totalRecords,
                    currentPage: currentPage,
                    handleFilterDateFrom: handleDateFromFilterNormal,
                    handleFilterDateTo: handleDateToFilterNormal,
                    resetDateFilter: handleResetDateFilterNormal,
                    handleFilterProgressId: handleProgressIdFilterNormal,
                    resetProgressIdFilter: handleResetProgressIdFilterNormal,
                    nextPage: handleNextPage,
                    previousPage: handlePreviousPage,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    handleFilterDateFrom: handleDateFromFilterOverdue,
                    handleFilterDateTo: handleDateToFilterOverdue,
                    resetDateFilter: handleResetDateFilterOverdue,
                    resetProgressIdFilter: handleResetProgressIdFilterOverdue,
                    handleFilterProgressId: handleProgressIdFilterOverdue,
                    totalPages: totalPagesOverdue,
                    totalRecords: totalRecordsOverdue,
                    currentPage: currentPageOverdue,
                }}
            />

            {/* Main Popup */}
            {/* <MrcSegregationMonthContext.Provider
                value={{
                    value: mrcSegregationMonth,
                    onChange: handleMrcSegregationMonthChange,
                    disabled: mrcCp52Preparing,
                }}
            > */}
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth
                {...workflowDialogShellProps(isWorkflowMobile)}
                className={workflowDialogClassName(
                    "main-dialog rco-workflow-dialog mrc-workflow-dialog",
                    isWorkflowMobile,
                )}
                PaperProps={{
                    className: "rco-workflow-dialog-paper mrc-workflow-dialog-paper",
                }}
            >
                <DialogTitle className="dialog-title">
                    <div className="rco-dialog-header">
                        <Typography className="applicationTitleText">
                            Meter Reading Correction -
                            <span style={{ color: "white" }}>
                                {dialogRowData.applicationProgressId === 0 &&
                                    " Application Submission"}
                                {dialogRowData.applicationProgressId === 1 &&
                                    dialogRowData.objectionStatus !== 1 &&
                                    " Document Verification"}
                                {dialogRowData.applicationProgressId === 1 &&
                                    dialogRowData.objectionStatus === 1 &&
                                    " Document Verification (Objection)"}
                                {dialogRowData.applicationProgressId === 2 &&
                                    dialogRowData.objectionStatus !== 1 &&
                                    " Authority Verification"}
                                {dialogRowData.applicationProgressId === 2 &&
                                    dialogRowData.objectionStatus === 1 &&
                                    " Authority Verification (Rejected)"}
                                {dialogRowData.applicationProgressId === 3 &&
                                    dialogRowData.objectionStatus !== 1 &&
                                    " Site Survey"}
                                {dialogRowData.applicationProgressId === 3 &&
                                    dialogRowData.objectionStatus === 1 &&
                                    " Site Survey (Rejected)"}
                                {dialogRowData.applicationProgressId === 4 &&
                                    " Forward for Billing"}
                                {dialogRowData.applicationProgressId === 5 &&
                                    " Post for Billing"}
                                {dialogRowData.applicationProgressId === 6 &&
                                    " Completed"}
                                </span>
                            </Typography>
                        <button
                            type="button"
                            className="closeIcon"
                            onClick={handleClose}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" sx={{ color: "white" }} />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText component="div" className="dialog-content">
                        <Grid container className="headercontainer">
                            <Grid item lg={12} className="status-bar">
                                <StepProgressBar
                                    array={mRCStatusBarArray}
                                    applicationProgressId={dialogRowData.applicationProgressId}
                                    openDetailsPopUp={openDetailsPopUp}
                                    objection={dialogRowData.objectionStatus}
                                    skippedSteps={getMrcSkippedSteps(dialogRowData)}
                                    submittedStepComplete={Number(dialogRowData.applicationProgressId) >= 6}
                                    pageName={"Meter Reading Correction"}
                                />
                            </Grid>
                            <Grid item xs={12} className="application-details">
                                <div className="rco-application-details-body">
                                    <div className="rco-details-grid rco-details-grid--mrc">
                                        <div className="first-row-item">
                                            <p className="prop-title">Complaint Id</p>
                                            <p className="prop-detail">
                                                {dialogRowData.applicationId || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Applicant Name</p>
                                            <p className="prop-detail">
                                                {dialogRowData.consumerName ||
                                                    dialogRowData.applicantName ||
                                                    "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Applicant Phone</p>
                                            <p className="prop-detail">
                                                {dialogRowData.applicantMobile ||
                                                    dialogRowData.applicantPhoneNo ||
                                                    "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Reference No.</p>
                                            <p className="prop-detail">
                                                {dialogRowData.referenceNo || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Customer ID</p>
                                            <p className="prop-detail">
                                                {dialogRowData.customerId || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Tariff</p>
                                            <p className="prop-detail">
                                                {resolveMrcTariffDisplay(
                                                    dialogRowData.tariffCode ||
                                                        dialogRowData.tariff ||
                                                        dialogRowData.TARIFF_ACTIVE ||
                                                        "",
                                                    allTariffList,
                                                ) || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Billing Month</p>
                                            <p className="prop-detail">
                                                {/* {formatCp52BillingMonth(dialogRowData.billingMonth) ||
                                                    dialogRowData.billingMonth ||
                                                    "-"} */}
                                                    {
                                                        dialogRowData.billingMonth
                                                    }
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Due Date</p>
                                            <p className="prop-detail">
                                                {dialogRowData.dueDate || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Reading Date</p>
                                            <p className="prop-detail">
                                                {dialogRowData.readingDate || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Sanctioned Load</p>
                                            <p className="prop-detail">
                                                {dialogRowData.sanctionedLoad != null &&
                                                    dialogRowData.sanctionedLoad !== ""
                                                    ? dialogRowData.sanctionedLoad
                                                    : "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Subdivision</p>
                                            <p className="prop-detail">
                                                {subdivisionName(
                                                    dialogRowData.subDivisionCode,
                                                    subDivisions,
                                                ) || "-"}
                                            </p>
                                        </div>
                                        {/* <div className="first-row-item">
                                            <p className="prop-title">CNIC</p>
                                            <p className="prop-detail">
                                                {dialogRowData.consumerCNIC || "-"}
                                            </p>
                                        </div> */}
                                        <div className="first-row-item">
                                            <p className="prop-title">Amount Payable</p>
                                            <p className="prop-detail">
                                                {dialogRowData.payableWithinDueDate != null
                                                    ? numberFormatting(
                                                        dialogRowData.payableWithinDueDate,
                                                    )
                                                    : "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">LPS</p>
                                            <p className="prop-detail">
                                                {dialogRowData.lps != null
                                                    ? numberFormatting(dialogRowData.lps)
                                                    : "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">LPS 5P</p>
                                            <p className="prop-detail">
                                                {dialogRowData.lps5P != null
                                                    ? numberFormatting(dialogRowData.lps5P)
                                                    : dialogRowData.lps5p != null
                                                        ? numberFormatting(dialogRowData.lps5p)
                                                        : "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item">
                                            <p className="prop-title">Duration</p>
                                            <p className="prop-detail">
                                                {mrcTotalDuration || "-"}
                                            </p>
                                        </div>
                                        <div className="first-row-item rco-details-grid__address">
                                            <p className="prop-title">Address</p>
                                            <p className="prop-detail">
                                                {dialogRowData.consumerAddress || "-"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                    </Grid>
                            <Grid item xs={12} className="rco-workflow-panels-wrap">
                                <div
                                    className={`rco-workflow-panels${
                                        activityLogCollapsed
                                            ? ' rco-workflow-panels--activity-collapsed'
                                            : ''
                                    }`}
                                >
                                    <div
                                        className={`processing-summary${
                                            activityLogCollapsed
                                                ? ' processing-summary--collapsed'
                                                : ''
                                        }`}
                                    >
                                        <div className="rco-activity-log-head">
                                            <button
                                                type="button"
                                                className="rco-activity-collapse-btn"
                                                onClick={() =>
                                                    setActivityLogCollapsed((prev) => !prev)
                                                }
                                                aria-expanded={!activityLogCollapsed}
                                                aria-label={
                                                    activityLogCollapsed
                                                        ? 'Expand Activity Log'
                                                        : 'Collapse Activity Log'
                                                }
                                                title={
                                                    activityLogCollapsed
                                                        ? 'Expand Activity Log'
                                                        : 'Collapse Activity Log'
                                                }
                                            >
                                                {activityLogCollapsed ? (
                                                    <ChevronRightIcon fontSize="small" />
                                                ) : (
                                                    <ChevronLeftIcon fontSize="small" />
                                                )}
                                            </button>
                                            <p className="title">Activity Log</p>
                                            {!activityLogCollapsed &&
                                            eFileData &&
                                            eFileData.length > 0 ? (
                                                <button
                                                    type="button"
                                                    className="rco-activity-view-detail-btn"
                                                    onClick={() => setActivityLogDetailOpen(true)}
                                                >
                                                    <VisibilityOutlinedIcon />
                                                    Timeline
                                                </button>
                                            ) : null}
                                        </div>
                                        {!activityLogCollapsed ? (
                                        <div className="rco-activity-log-body">
                                            {viewDropBackForEfile ? (
                                                <div className="rco-load-activity-wrap rco-load-activity-wrap--loading">
                                                    <AppLoader size={30} />
                                                </div>
                                            ) : eFileData && eFileData.length > 0 ? (
                                                <ProcessingSummaryTableForCoa
                                                    key={tableDataProcessingSummary.length}
                                                    data={tableDataProcessingSummary}
                                                    columns={tableColumnsProcessingSummary}
                                                    openDetailsPopUp={(fullRow) => {
                                                        openDetailsPopUp(fullRow._raw || fullRow);
                                                    }}
                                                />
                                            ) : (
                                                <div className="rco-load-activity-wrap">
                                                    <button
                                                        onClick={onPressViewActivityLog}
                                                        type="button"
                                                        className="rco-load-activity-btn"
                                                    >
                                                        Load Activity Log
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        ) : null}
                                    </div>
                                    <div className="action-form">
                                <div className='fields'>
                                    {
                                        dialogRowData.applicationProgressId === 0 ?
                                            <>
                                                <div className="step-title step-title--with-action">
                                                    <h4>Documents Pending</h4>
                                                    <Box className="step-title__actions">
                                                        <MrcStepWhoHint progressId={0} stepName="Application Submission" />
                                                    </Box>
                                                </div>
                                                <div className='description-box'>
                                                    {
                                                        hasMrcBasicUpdatePermission ?
                                                            <p className='group-description'>To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button.</p> :
                                                            <p className='group-description'>To process application, some documents are yet to be provided by the customer.</p>
                                                    }
                                                </div>
                                            </> :
                                            dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                <>
                                                    {
                                                                hasMrcDocumentVerificationPermission ?
                                                                    <>
                                                                        <div className="step-title step-title--with-action">
                                                                            <h4>Document Verification</h4>
                                                                            <Box className="step-title__actions">
                                                                                <MrcStepWhoHint progressId={1} stepName="Document Verification" />
                                                                            </Box>
                                                                        </div>
                                                                <Grid container className='field-survey-container'>
                                                                    <Grid item lg={12} className='group-title-item' >
                                                                        <p className='group-title'>Reading Information</p>
                                                                    </Grid>
                                                                </Grid>
                                                                        <MrcDocumentsReadingTable
                                                                            documents={mrcDocuments}
                                                                            meterPhaseType={dialogRowData.meterPhaseType}
                                                                            loading={mrcDocumentsLoading}
                                                                                                    applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                    objectionStatus={dialogRowData.objectionStatus}
                                                                            onUpdateImageFlag={updateMrcDocumentImageFlag}
                                                                        />


                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className="step-title step-title--with-action">
                                                                            <h4>Document Verification</h4>
                                                                            <Box className="step-title__actions">
                                                                                <MrcStepWhoHint progressId={1} stepName="Document Verification" />
                                                                            </Box>
                                                                        </div>

                                                                        <div className="description-box description-box--error">
                                                                            <p className="group-description">
                                                                                <InfoIcon className="icon" />
                                                                                Document Verification is in process by the sanctioned
                                                                                authority (CSL / CSM).
                                                                            </p>
                                                                                    </div>
                                                            </>
                                                    }
                                                </> :
                                                dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 1) ?
                                                    <>
                                                        {
                                                                    hasMrcDocumentVerificationPermission ?
                                                                <>
                                                                            <div className="step-title step-title--with-action">
                                                                            <h4>Document Verification</h4>
                                                                            <Box className="step-title__actions">
                                                                                <MrcStepWhoHint progressId={1} stepName="Document Verification" />
                                                                            </Box>
                                                                        </div>
                                                                    <Grid container className='field-survey-container'>
                                                                        <Grid item lg={12} className='group-title-item' >
                                                                            <p className='group-title'>Reading Information</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                            <MrcDocumentsReadingTable
                                                                                documents={mrcDocuments}
                                                                                meterPhaseType={dialogRowData.meterPhaseType}
                                                                                loading={mrcDocumentsLoading}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                onUpdateImageFlag={updateMrcDocumentImageFlag}
                                                                            />

                                                                    <Grid container spacing={1} className='document-verification-container'>
                                                                        {
                                                                            dialogRowData.meterPhaseType == "1 phase meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(singlePhaseInitialReadings.claimedReadingSinglePhaseImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={singlePhaseInitialReadings.claimedReadingSinglePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={singlePhaseInitialReadings.claimedReadingSinglePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }
                                                                        {
                                                                            dialogRowData.meterPhaseType == "3 phase meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseInitialReadings.claimedOffPeakThreePhaseImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={threePhaseInitialReadings.claimedOffPeakThreePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseInitialReadings.claimedOffPeakThreePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseInitialReadings.claimedPeakThreePhaseImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={threePhaseInitialReadings.claimedPeakThreePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseInitialReadings.claimedPeakThreePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }

                                                                        {
                                                                            dialogRowData.meterPhaseType == "3 phase mdi meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kWh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kWh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakExportImgFlag) : getDocumentBackGroundColor(flag_offPeakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kVArh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakExpVerifyPopUp) { setOffPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    offPeakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakExportImgPopUp}
                                                                                                        documentName="Off Peak Export"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={dialogRowData.offPeakExportImg}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.peakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.peakExportImgFlag) : getDocumentBackGroundColor(flag_peakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kVArh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakExpVerifyPopUp) { setPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    peakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakExportImgPopUp}
                                                                                                        documentName="Peak Export"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="peakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }

                                                                        {
                                                                            dialogRowData.meterPhaseType == "net meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedOffpeakImportImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={netMeterInitialReadings.claimedOffpeakImportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedOffpeakImportImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedPeakImportImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={netMeterInitialReadings.claimedPeakImportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedPeakImportImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakExportImgFlag) : getDocumentBackGroundColor(flag_offPeakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakExpVerifyPopUp) { setOffPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedOffpeakExportImage)}
                                                                                                {
                                                                                                    offPeakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakExportImgPopUp}
                                                                                                        documentName="Off Peak Export"
                                                                                                        documentImage={netMeterInitialReadings.claimedOffpeakExportImage}
                                                                                                        width={'100%'}
                                                                                                        document={dialogRowData.offPeakExportImg}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.peakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.peakExportImgFlag) : getDocumentBackGroundColor(flag_peakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakExpVerifyPopUp) { setPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedPeakExportImage)}
                                                                                                {
                                                                                                    peakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakExportImgPopUp}
                                                                                                        documentName="Peak Export"
                                                                                                        documentImage={netMeterInitialReadings.claimedPeakExportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedPeakExportImage}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="peakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </>
                                                                :
                                                                hasMrcBasicUpdatePermission ? (
                                                                <>
                                                                            <div className="step-title step-title--with-action">
                                                                            <h4>Document Verification</h4>
                                                                            <Box className="step-title__actions">
                                                                                <MrcStepWhoHint progressId={1} stepName="Re-Upload Document" />
                                                                            </Box>
                                                                        </div>
                                                                    <Grid container className='field-survey-container'>
                                                                        <Grid item lg={12} className='group-title-item' >
                                                                            <p className='group-title'>Reading Information</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                            <MrcDocumentsReadingTable
                                                                                documents={mrcDocuments}
                                                                                meterPhaseType={dialogRowData.meterPhaseType}
                                                                                loading={mrcDocumentsLoading}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                readOnly
                                                                                evidenceRemarksMode="reupload"
                                                                            />
                                                                </>
                                                                ) :
                                                                <>
                                                                            <div className="step-title step-title--with-action">
                                                                            <h4>Document Verification</h4>
                                                                            <Box className="step-title__actions">
                                                                                <MrcStepWhoHint progressId={1} stepName="Document Verification" />
                                                                            </Box>
                                                                        </div>

                                                                            <div className="description-box description-box--error">
                                                                                <p className="group-description">
                                                                                    <InfoIcon className="icon" />
                                                                                    Document Objection Removal is in process by the sanctioned
                                                                                    authority (CSL / CSM).
                                                                                </p>
                                                                                        </div>
                                                                        </>

                                                        }
                                                    </> :
                                                    dialogRowData.applicationProgressId === 2 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                        <>

                                                                    <div className="step-title step-title--with-action">
                                                                        <h4>Authority Verification</h4>
                                                                        <Box className="step-title__actions">
                                                                            <MrcApprovalAmountHint
                                                                                whoMessage={getMrcStepDesignationTooltip(2, 'Authority Verification')}
                                                                            />
                                                                                    </Box>
                                                                    </div>
                                                                    {
                                                                        canPerformMrcAuthorityVerification(
                                                                            getMrcAmountPayable(dialogRowData),
                                                                        ) ?

                                                                            <>
                                                                                <Grid container className='field-survey-container authority-verification-container'>
                                                                                    {/* Decision — always mounted to avoid layout jump */}
                                                                                    <Grid item lg={6} md={6} sm={12} xs={12} className='authority-radio-col'>
                                                                                        <Typography className='fieldLabel'>Decision</Typography>
                                                                                        <FormControl className='authority-radio-panel'>
                                                                                            <RadioGroup
                                                                                                row
                                                                                                className='authority-radio-group'
                                                                                                value={authorityDecision}
                                                                                                onChange={(e) => {
                                                                                                    setAuthorityDecision(e.target.value);
                                                                                                    setReferToSiteSurvey('');
                                                                                                }}
                                                                                            >
                                                                                                <FormControlLabel
                                                                                                    value="accept"
                                                                                                    className='authority-radio-option authority-radio-option--accept'
                                                                                                    control={<Radio />}
                                                                                                    label="Accept"
                                                                                                />
                                                                                                <FormControlLabel
                                                                                                    value="reject"
                                                                                                    className='authority-radio-option authority-radio-option--reject'
                                                                                                    control={<Radio />}
                                                                                                    label="Reject"
                                                                                                />
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                </Grid>

                                                                                    {/* Site Survey — space reserved; hidden when not Accept */}
                                                                                    <Grid
                                                                                        item
                                                                                        lg={6}
                                                                                        md={6}
                                                                                        sm={12}
                                                                                        xs={12}
                                                                                        className={`authority-radio-col authority-radio-col--survey${authorityDecision === 'accept' ? '' : ' is-placeholder'}`}
                                                                                    >
                                                                                        <Typography className='fieldLabel'>Refer to Site Survey?</Typography>
                                                                                        <FormControl className='authority-radio-panel' disabled={authorityDecision !== 'accept'}>
                                                                                            <RadioGroup
                                                                                                row
                                                                                                className='authority-radio-group'
                                                                                                value={referToSiteSurvey}
                                                                                                onChange={(e) => {
                                                                                                    setReferToSiteSurvey(e.target.value);
                                                                                                    if (e.target.value === 'no') {
                                                                                                        setMrcSelectedStaffId('');
                                                                                                        callAsyncGetMRCDocuments(dialogRowData.applicationId);
                                                                                                    }
                                                                                                    if (e.target.value === 'yes') {
                                                                                                        setMrcSelectedStaffId('');
                                                                                                        fetchMrcFieldStaff();
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <FormControlLabel
                                                                                                    value="yes"
                                                                                                    className='authority-radio-option'
                                                                                                    control={<Radio />}
                                                                                                    label="Yes"
                                                                                                />
                                                                                                <FormControlLabel
                                                                                                    value="no"
                                                                                                    className='authority-radio-option'
                                                                                                    control={<Radio />}
                                                                                                    label="No"
                                                                                                />
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                </Grid>

                                                                                    <Grid item lg={12} className='authority-verification-body'>
                                                                                        {authorityDecision === 'accept' && referToSiteSurvey === 'yes' && (
                                                                                            <>
                                                                                                <div className='group-title-item'>
                                                                                                    <h5 className='group-title'>Assign To Field Staff</h5>
                                                                                                </div>
                                                                                                {mrcWorkForceLoading ? (
                                                                                                    <div className='authority-loading'>
                                                                                                        <AppLoader />
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="mrc-field-staff-table-wrap">
                                                                                                        <table className="mrc-field-staff-table">
                                                                                                            <thead>
                                                                                                                <tr>
                                                                                                                    <th style={{ width: 48 }}></th>
                                                                                                                    <th style={{ width: 48 }}>Sr.</th>
                                                                                                                    <th>Name</th>
                                                                                                                    <th>Designation</th>
                                                                                                                    <th>Mobile No.</th>
                                                                                                                </tr>
                                                                                                            </thead>
                                                                                                            <tbody>
                                                                                                                {mrcWorkForceData.length ? (
                                                                                                                    mrcWorkForceData.map((item, index) => (
                                                                                                                        <tr key={item.userId || index}>
                                                                                                                            <td>
                                                                                                                                <input
                                                                                                                                    type="radio"
                                                                                                                                    className="mrc-field-staff-radio"
                                                                                                                                    name="mrcFieldStaff"
                                                                                                                                    value={item.userId}
                                                                                                                                    checked={String(mrcSelectedStaffId) === String(item.userId)}
                                                                                                                                    onChange={() => setMrcSelectedStaffId(item.userId)}
                                                                                                                                />
                                                                                                                            </td>
                                                                                                                            <td>{index + 1}</td>
                                                                                                                            <td>{item.name}</td>
                                                                                                                            <td>
                                                                                                                                {mrcFieldStaffDesignations.find(
                                                                                                                                    (itm) => itm.employeeDesignationId == item.designation
                                                                                                                                )?.employeeDesignationName || "N/A"}
                                                                                                                            </td>
                                                                                                                            <td>{item.phoneNo}</td>
                                                                                                                        </tr>
                                                                                                                    ))
                                                                                                                ) : (
                                                                                                                    <tr>
                                                                                                                        <td colSpan={5} className="mrc-field-staff-empty">
                                                                                                                            No field staff found for this office.
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                )}
                                                                                                            </tbody>
                                                                                                        </table>
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                        {authorityDecision === 'accept' && referToSiteSurvey === 'no' && (
                                                                                            <>
                                                                                                <div className='group-title-item'>
                                                                                                    <h5 className='group-title'>Reading Information</h5>
                                                                                                    </div>
                                                                                                {mrcDocumentsLoading ? (
                                                                                                    <div className='authority-loading'>
                                                                                                        <AppLoader />
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <MrcDocumentsReadingTable
                                                                                                        ref={authorityReadingTableRef}
                                                                                                        documents={mrcDocuments}
                                                                                                        meterPhaseType={dialogRowData.meterPhaseType}
                                                                                                        loading={mrcDocumentsLoading}
                                                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                                        onUpdateImageFlag={updateMrcDocumentImageFlag}
                                                                                                        onValidationError={setError}
                                                                                                        showAuthorityClaimed
                                                                                                    />
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </>
                                                                            :
                                                                            <>
                                                                                <div className="description-box description-box--error">
                                                                                    <p className="group-description">
                                                                                        <InfoIcon className="icon" />
                                                                                        {getMrcInProcessByAmountMessage('Authority Verification')}
                                                                                    </p>
                                                                                                    </div>
                                                                            </>
                                                                    }
                                                                </> :
                                                                dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                                                                    <>
                                                                        <h3 className='step-title'>Application Rejected</h3>
                                                                        <Grid container className='field-survey-container' sx={{ marginTop: '-15px' }}>
                                                                            <Grid item lg={12} className='group-title-item'>
                                                                                <h5 className='group-title'>Remarks</h5>
                                                                                        </Grid>
                                                                                    <Error
                                                                                error={dialogRowData.remarks || 'Rejected by Authority'}
                                                                                        backgroundColor="#FFC0CB"
                                                                                        textColor="#bb0303"
                                                                                        iconColor="#bb0303"
                                                                                    />
                                                                                                </Grid>
                                                                        <Grid container className='field-survey-container'>
                                                                            <Grid item lg={12} className='group-title-item'>
                                                                                <p className='group-title'>Reading Information</p>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                        {mrcDocumentsLoading ? (
                                                                            <div className='authority-loading'>
                                                                                <AppLoader />
                                                                                                    </div>
                                                                        ) : (
                                                                            <MrcDocumentsReadingTable
                                                                                documents={mrcDocuments}
                                                                                meterPhaseType={dialogRowData.meterPhaseType}
                                                                                loading={mrcDocumentsLoading}
                                                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                            />
                                                                        )}
                                                                    </> :
                                                                    dialogRowData.applicationProgressId === 3 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                        <>
                                                                            <div className="step-title step-title--with-action">
                                                                                <h4>Site Survey</h4>
                                                                                <Box className="step-title__actions">
                                                                                    <MrcStepWhoHint progressId={3} stepName="Site Survey" />
                                                                                </Box>
                                                                            </div>

                                                                            {
                                                                                canPerformMrcSiteSurvey(dialogRowData) ?
                                                                                    <>
                                                                                        <Grid container className='field-survey-container'>
                                                                                            <Grid item lg={12} className='group-title-item'>
                                                                                                <h5 className='group-title'>Reading Information</h5>
                                                                                                </Grid>
                                                                                                </Grid>
                                                                                        {mrcDocumentsLoading ? (
                                                                                            <div className='authority-loading'>
                                                                                                <AppLoader />
                                                                                                    </div>
                                                                                        ) : (
                                                                                            <MrcDocumentsReadingTable
                                                                                                ref={siteSurveyReadingTableRef}
                                                                                                documents={mrcDocuments}
                                                                                                meterPhaseType={dialogRowData.meterPhaseType}
                                                                                                loading={mrcDocumentsLoading}
                                                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                                onValidationError={setError}
                                                                                                showSiteSurvey
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <div className="description-box description-box--error">
                                                                                            <p className="group-description">
                                                                                                <InfoIcon className="icon" />
                                                                                                Site Survey is in process by the sanctioned authority.
                                                                                            </p>
                                                                            </div>
                                                                        </>
                                                                }

                                                            </> :
                                                            dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 1 ?
                                                                <>
                                                                    <h3 className='step-title'>Application Rejected</h3>
                                                                    <Grid container className='field-survey-container' sx={{ marginTop: '-15px' }}>
                                                                        <Grid item lg={12} className='group-title-item'>
                                                                            <h5 className='group-title'>Remarks</h5>
                                                                        </Grid>
                                                                        <Error
                                                                            error={dialogRowData.remarks}
                                                                            backgroundColor="#FFC0CB"
                                                                            textColor="#bb0303"
                                                                            iconColor="#bb0303"
                                                                        />
                                                                    </Grid>
                                                                    <Grid container className='field-survey-container'>
                                                                        <Grid item lg={12} className='group-title-item' >
                                                                            <p className='group-title'>Reason</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container className='sco-container'>
                                                                        <Grid item lg={12} className='item'>
                                                                            <Typography className='title'>{dialogRowData.reason ? dialogRowData.reason : '-'}</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container className='field-survey-container'>
                                                                        <Grid item lg={12} className='group-title-item' >
                                                                            <p className='group-title'>Reading Information</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        dialogRowData.meterPhaseType == "1 phase meter" &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Reading</Typography>
                                                                                <Typography className='value'>{singlePhaseInitialReadings.previousReadingSinglePhase ? numberFormatting(singlePhaseInitialReadings.previousReadingSinglePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Reading</Typography>
                                                                                <Typography className='value'>{singlePhaseInitialReadings.currentReadingSinglePhase ? numberFormatting(singlePhaseInitialReadings.currentReadingSinglePhase) : '-'}</Typography>
                                                                            </Grid>

                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Reading</Typography>
                                                                                <Typography className='value'>{singlePhaseInitialReadings.claimedReadingSinglePhase ? numberFormatting(singlePhaseInitialReadings.claimedReadingSinglePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }
                                                                    {
                                                                        dialogRowData.meterPhaseType == "3 phase meter" &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Off Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.previousOffPeakThreePhase ? numberFormatting(threePhaseInitialReadings.previousOffPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.previousPeakThreePhase ? numberFormatting(threePhaseInitialReadings.previousPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Off Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.currentOffPeakThreePhase ? numberFormatting(threePhaseInitialReadings.currentOffPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.currentPeakThreePhase ? numberFormatting(threePhaseInitialReadings.currentPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Off Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.claimedOffPeakThreePhase ? numberFormatting(threePhaseInitialReadings.claimedOffPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseInitialReadings.claimedPeakThreePhase ? numberFormatting(threePhaseInitialReadings.claimedPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }
                                                                    {
                                                                        (dialogRowData.meterPhaseType == "net meter") &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Off Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.previousOffpeakImport ? numberFormatting(netMeterInitialReadings.previousOffpeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.previousPeakImport ? numberFormatting(netMeterInitialReadings.previousPeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Off Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.previousOffpeakExport ? numberFormatting(netMeterInitialReadings.previousOffpeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.previousPeakExport ? numberFormatting(netMeterInitialReadings.previousPeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Off Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.currentOffpeakImport ? numberFormatting(netMeterInitialReadings.currentOffpeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.currentPeakImport ? numberFormatting(netMeterInitialReadings.currentPeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Off Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.currentOffpeakExport ? numberFormatting(netMeterInitialReadings.currentOffpeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.currentPeakExport ? numberFormatting(netMeterInitialReadings.currentPeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Off Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.claimedOffpeakImport ? numberFormatting(netMeterInitialReadings.claimedOffpeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.claimedPeakImport ? numberFormatting(netMeterInitialReadings.claimedPeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Off Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.claimedOffpeakExport ? numberFormatting(netMeterInitialReadings.claimedOffpeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterInitialReadings.claimedPeakExport ? numberFormatting(netMeterInitialReadings.claimedPeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }
                                                                    {
                                                                        (dialogRowData.meterPhaseType == "3 phase mdi meter") &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Off Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.previousOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.previousOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.previousPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.previousPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Off Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.previouskVArhOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.previouskVArhOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Previous Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.previouskVArhPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.previouskVArhPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Off Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.currentOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.currentOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.currentPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.currentPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Off Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.currentkVArhOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.currentkVArhOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Current Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.currentkVArhPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.currentkVArhPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Off Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.claimedPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.claimedPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Off Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Claimed Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdi ? numberFormatting(threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }

                                                                    {
                                                                        (dialogRowData.meterPhaseType == "3 phase mdi net meter") &&
                                                                        <>
                                                                            <Grid container className='sco-container'>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Off Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Off Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Peak kVArh Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Off Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Off Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Off Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Off Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedkVArhPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedkVArhPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>


                                                                            </Grid>
                                                                            <Grid container className='sco-container'>

                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Off Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previousOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previousPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Off Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previouskVArhOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Previous Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.previouskVArhPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Off Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Off Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentkVArhOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Current Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.currentkVArhPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Off Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Off Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedkVArhOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Claimed Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterInitialReadings.claimedkVArhPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterInitialReadings.claimedkVArhPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </>
                                                                    }

                                                                    <Grid container spacing={1} className='document-verification-container'>
                                                                        {
                                                                            dialogRowData.meterPhaseType == "1 phase meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(singlePhaseInitialReadings.claimedReadingSinglePhaseImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={singlePhaseInitialReadings.claimedReadingSinglePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={singlePhaseInitialReadings.claimedReadingSinglePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }
                                                                        {
                                                                            dialogRowData.meterPhaseType == "3 phase meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseInitialReadings.claimedOffPeakThreePhaseImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={threePhaseInitialReadings.claimedOffPeakThreePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseInitialReadings.claimedOffPeakThreePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseInitialReadings.claimedPeakThreePhaseImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={threePhaseInitialReadings.claimedPeakThreePhaseImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseInitialReadings.claimedPeakThreePhaseImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }

                                                                        {
                                                                            dialogRowData.meterPhaseType == "net meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedOffpeakImportImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={netMeterInitialReadings.claimedOffpeakImportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedOffpeakImportImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedPeakImportImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={netMeterInitialReadings.claimedPeakImportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedPeakImportImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakExportImgFlag) : getDocumentBackGroundColor(flag_offPeakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakExpVerifyPopUp) { setOffPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedOffpeakExportImage)}
                                                                                                {
                                                                                                    offPeakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakExportImgPopUp}
                                                                                                        documentName="Off Peak Export"
                                                                                                        documentImage={netMeterInitialReadings.claimedOffpeakExportImage}
                                                                                                        width={'100%'}
                                                                                                        document={dialogRowData.offPeakExportImg}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.peakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.peakExportImgFlag) : getDocumentBackGroundColor(flag_peakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakExpVerifyPopUp) { setPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(netMeterInitialReadings.claimedPeakExportImage)}
                                                                                                {
                                                                                                    peakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakExportImgPopUp}
                                                                                                        documentName="Peak Export"
                                                                                                        documentImage={netMeterInitialReadings.claimedPeakExportImage}
                                                                                                        width={'100%'}
                                                                                                        document={netMeterInitialReadings.claimedPeakExportImage}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="peakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }

                                                                        {
                                                                            dialogRowData.meterPhaseType == "3 phase mdi meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kWh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="Off Peak Import"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedOffPeakThreePhaseMdiImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kWh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedPeakThreePhaseMdiImage}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakExportImgFlag) : getDocumentBackGroundColor(flag_offPeakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kVArh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakExpVerifyPopUp) { setOffPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    offPeakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakExportImgPopUp}
                                                                                                        documentName="Off Peak Export"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedkVArhOffPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={dialogRowData.offPeakExportImg}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.peakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.peakExportImgFlag) : getDocumentBackGroundColor(flag_peakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kVArh Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakExpVerifyPopUp) { setPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage)}
                                                                                                {
                                                                                                    peakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakExportImgPopUp}
                                                                                                        documentName="Peak Export"
                                                                                                        documentImage={threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDIInitialReadings.claimedkVArhPeakThreePhaseMdiImage}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="peakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }

                                                                        {
                                                                            dialogRowData.meterPhaseType == "3 phase mdi net meter" &&
                                                                            <>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kWh Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakImportImgVerifyPopUp) { setOffPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImageImport)}
                                                                                                {
                                                                                                    (offPeakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakImportImgPopUp}
                                                                                                        documentName="kWh Off Peak Import"
                                                                                                        documentImage={threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImageImport}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImageImport}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakImportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakImportImgFlag) : getDocumentBackGroundColor(flag_offPeakImportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kWh Import Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakImportImgVerifyPopUp) { setPeakImportImgVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageImport)}
                                                                                                {
                                                                                                    (peakImportImgVerifyPopUp) &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakImportImgVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakImportImgPopUp}
                                                                                                        documentName="Peak Import"
                                                                                                        documentImage={threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageImport}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageImport}
                                                                                                        documentFlag={'2'}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakImport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.offPeakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.offPeakExportImgFlag) : getDocumentBackGroundColor(flag_offPeakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Off Peak kWh Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!offPeakExpVerifyPopUp) { setOffPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImageExport)}
                                                                                                {
                                                                                                    offPeakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={offPeakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hideOffPeakExportImgPopUp}
                                                                                                        documentName="Off Peak Export"
                                                                                                        documentImage={threePhaseMDINetMeterInitialReadings.claimedOffPeakThreePhaseMdiImageExport}
                                                                                                        width={'100%'}
                                                                                                        document={dialogRowData.claimedOffPeakThreePhaseMdiImageExport}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="offPeakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item lg={2}>
                                                                                    <Grid container sx={{ backgroundColor: dialogRowData.peakExportImgFlag ? getDocumentBackGroundColor(dialogRowData.peakExportImgFlag) : getDocumentBackGroundColor(flag_peakExportImg), borderRadius: "10px", minHeight: '175px', height: 'auto' }}>
                                                                                        <Grid item lg={12} className="tittlegrid" >
                                                                                            <p className='docTitle'>Claimed Peak kWh Export Reading Image</p>
                                                                                        </Grid>
                                                                                        <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                                                            <div onClick={() => { if (!peakExpVerifyPopUp) { setPeakExpVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                                                {renderMrcDocThumbnail(threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageExport)}
                                                                                                {
                                                                                                    peakExpVerifyPopUp &&
                                                                                                    <OpenBase64ImageInPopup
                                                                                                        docVerifyPopUp={peakExpVerifyPopUp}
                                                                                                        hideDocVerifyPopup={hidePeakExportImgPopUp}
                                                                                                        documentName="Peak Export"
                                                                                                        documentImage={threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageExport}
                                                                                                        width={'100%'}
                                                                                                        document={threePhaseMDINetMeterInitialReadings.claimedPeakThreePhaseMdiImageExport}
                                                                                                        documentFlag={"2"}
                                                                                                        applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                        objectionStatus={dialogRowData.objectionStatus}
                                                                                                        updateDocFlag={updateDocFlag}
                                                                                                        titleToUpdateFlag="peakExport"
                                                                                                        flag_document={''}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        }


                                                                    </Grid>

                                                                    <Grid container className='field-survey-container'>
                                                                        <Grid item lg={12} className='group-title-item' >
                                                                            <p className='group-title'>Survey Readings</p>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        dialogRowData.meterPhaseType == "1 phase meter" &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Reading</Typography>
                                                                                <Typography className='value'>{singlePhaseFieldSurveyReadings.fieldSurveyReadingSinglePhase ? numberFormatting(singlePhaseFieldSurveyReadings.fieldSurveyReadingSinglePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }

                                                                    {

                                                                        dialogRowData.meterPhaseType == "3 phase meter" &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Off Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseFieldSurveyReadings.fieldSurveyOffPeakThreePhase ? numberFormatting(threePhaseFieldSurveyReadings.fieldSurveyOffPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Peak Reading</Typography>
                                                                                <Typography className='value'>{threePhaseFieldSurveyReadings.fieldSurveyPeakThreePhase ? numberFormatting(threePhaseFieldSurveyReadings.fieldSurveyPeakThreePhase) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }

                                                                    {
                                                                        (dialogRowData.meterPhaseType == "net meter") &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Off Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterFieldSurveyReadings.fieldSurveyOffpeakImport ? numberFormatting(netMeterFieldSurveyReadings.fieldSurveyOffpeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Peak Import Reading</Typography>
                                                                                <Typography className='value'>{netMeterFieldSurveyReadings.fieldSurveyPeakImport ? numberFormatting(netMeterFieldSurveyReadings.fieldSurveyPeakImport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Off Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterFieldSurveyReadings.fieldSurveyOffpeakExport ? numberFormatting(netMeterFieldSurveyReadings.fieldSurveyOffpeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Peak Export Reading</Typography>
                                                                                <Typography className='value'>{netMeterFieldSurveyReadings.fieldSurveyPeakExport ? numberFormatting(netMeterFieldSurveyReadings.fieldSurveyPeakExport) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }


                                                                    {
                                                                        (dialogRowData.meterPhaseType == "3 phase mdi meter") &&
                                                                        <Grid container className='sco-container'>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Off Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Peak kWh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIFieldSurveyReadings.fieldSurveyPeakThreePhaseMdi ? numberFormatting(threePhaseMDIFieldSurveyReadings.fieldSurveyPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Off Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdi ? numberFormatting(threePhaseMDIFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                            <Grid item lg={3} className='item'>
                                                                                <Typography className='title'>Peak kVArh Reading</Typography>
                                                                                <Typography className='value'>{threePhaseMDIFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdi ? numberFormatting(threePhaseMDIFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdi) : '-'}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }

                                                                    {
                                                                        (dialogRowData.meterPhaseType == "3 phase mdi net meter") &&
                                                                        <>

                                                                            <Grid container className='sco-container'>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Off Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Peak kWh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Off Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Peak kVArh Import Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdiImport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdiImport) : '-'}</Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <Grid container className='sco-container'>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Off Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Peak kWh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveyPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Off Peak Export kVArh Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhOffPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                                <Grid item lg={3} className='item'>
                                                                                    <Typography className='title'>Peak kVArh Export Reading</Typography>
                                                                                    <Typography className='value'>{threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdiExport ? numberFormatting(threePhaseMDINetMeterFieldSurveyReadings.fieldSurveykVArhPeakThreePhaseMdiExport) : '-'}</Typography>
                                                                                </Grid>
                                                                            </Grid>

                                                                        </>
                                                                    }
                                                                </> :
                                                                dialogRowData.applicationProgressId === 4 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                    <>
                                                                        {
                                                                            isBillPosted ?
                                                                                <>
                                                                                                <div className="step-title step-title--with-action">
                                                                                                    <h4>Print Bill</h4>
                                                                                                    <Box className="step-title__actions">
                                                                                                        <Button
                                                                                                            className="rco-bill-btn"
                                                                                                            variant="outlined"
                                                                                                            onClick={() => openBill(dialogRowData)}
                                                                                                        >
                                                                                                            <PrintIcon /> Bill
                                                                                                        </Button>
                                                                                                    </Box>
                                                                                    </div>
                                                                                    <Grid container className='sco-container'>
                                                                                        <Grid item lg={12} className='item'>
                                                                                            <Typography className='title'>Print the bill from above print button.</Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </> :
                                                                                            canPerformMrcForwardForBilling(dialogRowData) ? (
                                                                                            wasMrcSiteSurveySkipped(dialogRowData) ?
                                                                                                <>
                                                                                                    <div className="step-title step-title--with-action">
                                                                                                        <h4>Forward for Billing</h4>
                                                                                                        <Box className="step-title__actions">
                                                                                                            <MrcApprovalAmountHint
                                                                                                                whoMessage={getMrcStepDesignationTooltip(4, 'Forward for Billing')}
                                                                                                            />
                                                                                                        </Box>
                                                                                                    </div>
                                                                                                    <Grid container className='field-survey-container'>
                                                                                                        <Grid item lg={12} className='group-title-item'>
                                                                                                            <h5 className='group-title'>Reading Information</h5>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                                    {mrcDocumentsLoading ? (
                                                                                                        <div className='authority-loading'>
                                                                                                            <AppLoader />
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <MrcDocumentsReadingTable
                                                                                                            ref={authorityReadingTableRef}
                                                                                                            documents={mrcDocuments}
                                                                                                            meterPhaseType={dialogRowData.meterPhaseType}
                                                                                                            loading={mrcDocumentsLoading}
                                                                                                            applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                            objectionStatus={dialogRowData.objectionStatus}
                                                                                                            showAuthorityClaimed
                                                                                                            readOnly
                                                                                                        />
                                                                                                    )}
                                                                                                </> :
                                                                                                <>
                                                                                                    <div className="step-title step-title--with-action">
                                                                                                        <h4>Forward for Billing</h4>
                                                                                                        <Box className="step-title__actions">
                                                                                                            <MrcApprovalAmountHint
                                                                                                                whoMessage={getMrcStepDesignationTooltip(4, 'Forward for Billing')}
                                                                                                            />
                                                                                                        </Box>
                                                                                                    </div>
                                                                                                    <Grid container className='field-survey-container'>
                                                                                                        <Grid item lg={12} className='group-title-item'>
                                                                                                            <h5 className='group-title'>Reading Information</h5>
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                    {mrcDocumentsLoading ? (
                                                                                                        <div className='authority-loading'>
                                                                                                            <AppLoader />
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <MrcDocumentsReadingTable
                                                                                                            ref={authorityReadingTableRef}
                                                                                                            documents={mrcDocuments}
                                                                                                            meterPhaseType={dialogRowData.meterPhaseType}
                                                                                                            loading={mrcDocumentsLoading}
                                                                                                            applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                            objectionStatus={dialogRowData.objectionStatus}
                                                                                                            onValidationError={setError}
                                                                                                            showSiteSurvey
                                                                                                            showAuthorityClaimed
                                                                                                        />
                                                                                                    )}
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div className="step-title step-title--with-action">
                                                                                                        <h4>Forward for Billing</h4>
                                                                                                        <Box className="step-title__actions">
                                                                                                            <MrcApprovalAmountHint
                                                                                                                whoMessage={getMrcStepDesignationTooltip(4, 'Forward for Billing')}
                                                                                                            />
                                                                                                        </Box>
                                                                                                    </div>
                                                                                                    <div className="description-box description-box--error">
                                                                                                        <p className="group-description">
                                                                                                            <InfoIcon className="icon" />
                                                                                                            {getMrcInProcessByAmountMessage('Forward for Billing')}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </>
                                                                                            )
                                                                                    }
                                                                                </> :
                                                                                dialogRowData.applicationProgressId === 5 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                                    canPerformMrcPostForBilling(dialogRowData) ? (
                                                                                    <>
                                                                                        <div className="step-title step-title--with-action">
                                                                                            <h4>Post for Billing</h4>
                                                                                            <Box className="step-title__actions">
                                                                                                <MrcStepWhoHint progressId={5} stepName="Post for Billing" />
                                                                                                {mrcCp52Prepared ? (
                                                                                                    <Button
                                                                                                        className="rco-bill-btn"
                                                                                                        variant="outlined"
                                                                                                        onClick={() => downloadCp52OfMrcPdf(dialogRowData.applicationId)}
                                                                                                    >
                                                                                                        View CP52 PDF
                                                                                                    </Button>
                                                                                                ) : null}
                                                                                            </Box>
                                                                                        </div>
                                                                                        <Grid container className='field-survey-container'>
                                                                                            <Grid item lg={12} className='group-title-item'>
                                                                                                <h5 className='group-title'>Reading Information</h5>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                        {mrcDocumentsLoading ? (
                                                                                            <div className='authority-loading'>
                                                                                                <AppLoader />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <MrcDocumentsReadingTable
                                                                                                documents={mrcDocuments}
                                                                                                meterPhaseType={dialogRowData.meterPhaseType}
                                                                                                loading={mrcDocumentsLoading}
                                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                                showAuthorityClaimed
                                                                                                showSiteSurvey={didMrcSiteSurveyHappen(dialogRowData)}
                                                                                                readOnly
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                    ) : (
                                                                                    <>
                                                                                        <div className="step-title step-title--with-action">
                                                                                            <h4>Post for Billing</h4>
                                                                                            <Box className="step-title__actions">
                                                                                                <MrcStepWhoHint progressId={5} stepName="Post for Billing" />
                                                                                            </Box>
                                                                                        </div>
                                                                                        <div className="description-box description-box--error">
                                                                                            <p className="group-description">
                                                                                                <InfoIcon className="icon" />
                                                                                                Post for Billing is in process by the sanctioned authority.
                                                                                            </p>
                                                                                        </div>
                                                                                    </>
                                                                                    ) : ''
                                            }
                                            {!isReleventToUser && (
                                                <div className="description-box description-box--error">
                                                    <p className="group-description">
                                                        <InfoIcon className="icon" />
                                                        Application doesn&apos;t belongs to your office.
                                                    </p>
                                                </div>
                                            )}
                                </div>
                                <div className='actions'>
                                            {isReleventToUser == true ? (
                                            <>
                                    {
                                        dialogRowData.applicationProgressId === 0 ?
                                            <>

                                            </>
                                            :
                                            dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                <>
                                                    {
                                                                hasMrcDocumentVerificationPermission &&
                                                                (() => {
                                                                    const { allActed, hasReject } = getMrcImageVerificationState(mrcDocuments);
                                                                    return (
                                                                        <button
                                                                            type="button"
                                                                            disabled={!allActed || mrcDocumentsLoading}
                                                                            onClick={updateMrcDocumentVerificationStatus}
                                                                            className="view-button"
                                                                            style={{
                                                                                backgroundColor: hasReject ? '#E11B3C' : '#003971',
                                                                                opacity: !allActed || mrcDocumentsLoading ? 0.55 : 1,
                                                                                cursor: !allActed || mrcDocumentsLoading ? 'not-allowed' : 'pointer',
                                                                            }}
                                                                        >
                                                                            {hasReject ? 'Reject' : 'Verify'}
                                                                        </button>
                                                                    );
                                                                })()
                                                    }
                                                </>
                                                :
                                                dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 1) ?
                                                    <>
                                                        {
                                                            hasMrcBasicUpdatePermission
                                                            &&
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                            if (typeof props.onCloseSearchResults === 'function') {
                                                                                props.onCloseSearchResults();
                                                                            }
                                                                            navigate('/meter-reading-update', { state: { dialogRowData } });
                                                                        }}
                                                                        className="view-button"
                                                                    >
                                                                        Re-Upload Document
                                                                    </button>
                                                        }
                                                    </>
                                                    :
                                                    dialogRowData.applicationProgressId === 2 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                canPerformMrcAuthorityVerification(
                                                                    getMrcAmountPayable(dialogRowData),
                                                                ) ? (
                                                                    <div className='authority-footer-actions'>
                                                                        {
                                                                            authorityDecision === 'reject' ? (
                                                                                <button
                                                                                    type='button'
                                                                                    onClick={openAuthorityRejectRemarksDialog}
                                                                                    className='view-button'
                                                                                    style={{ backgroundColor: '#E11B3C' }}
                                                                                >
                                                                                    Reject
                                                                                </button>
                                                                            ) : authorityDecision === 'accept' && referToSiteSurvey === 'yes' ? (
                                                                                <button
                                                                                    type='button'
                                                                                    onClick={submitAuthorityReferToSiteSurvey}
                                                                                    className='view-button'
                                                                                    disabled={!mrcSelectedStaffId || mrcWorkForceLoading}
                                                                                >
                                                                                    Refer to Site Survey
                                                                                </button>
                                                                            ) : authorityDecision === 'accept' && referToSiteSurvey === 'no' ? (
                                                                                <button
                                                                                    type='button'
                                                                                    onClick={submitAuthorityApproveWithoutSurvey}
                                                                                    className='view-button'
                                                                                >
                                                                                    Submit
                                                                                </button>
                                                                            ) : (
                                                                                <span className='authority-footer-spacer' aria-hidden="true" />
                                                                            )
                                                                        }
                                                                    </div>
                                                                ) : null
                                                                :
                                                                dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                                                                    null :
                                                        dialogRowData.applicationProgressId === 3 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                        canPerformMrcSiteSurvey(dialogRowData) ? (
                                                                        <div className='authority-footer-actions'>
                                                                            <button
                                                                                type='button'
                                                                                onClick={submitSiteSurvey}
                                                                                className='view-button'
                                                                            >
                                                                                Submit
                                                                            </button>
                                                                        </div>
                                                                        ) : null
                                                                        :
                                                                        dialogRowData.applicationProgressId === 4 &&
                                                                            (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) &&
                                                                            !isBillPosted ?
                                                                            canPerformMrcForwardForBilling(dialogRowData) ? (
                                                                            didMrcSiteSurveyHappen(dialogRowData) ? (
                                                                                <div className='authority-footer-actions authority-footer-actions--pair'>
                                                                                    <button
                                                                                        type='button'
                                                                                        onClick={() => openForwardBillingRemarksDialog('reject')}
                                                                                        className='reject-button'
                                                                                    >
                                                                                        Revert
                                                                                    </button>
                                                                                    <button
                                                                                        type='button'
                                                                                        onClick={() => openForwardBillingRemarksDialog('approve')}
                                                                                        className='view-button'
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div className='authority-footer-actions'>
                                                                                    <button
                                                                                        type='button'
                                                                                        onClick={() => openForwardBillingRemarksDialog('approve')}
                                                                                        className='view-button'
                                                                                    >
                                                                                        Approve
                                                                                    </button>
                                                                                </div>
                                                                            )
                                                                            ) : null
                                                                            :
                                                                            dialogRowData.applicationProgressId === 5 &&
                                                                                (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                                                canPerformMrcPostForBilling(dialogRowData) ? (
                                                                                <div className='authority-footer-actions'>
                                                                                    {!mrcCp52Prepared ? (
                                                                                        isMrcCp52AlreadyCreated(dialogRowData) &&
                                                                                        !mrcForcePrepareCp52 ? (
                                                                                            <div className='authority-footer-actions authority-footer-actions--pair'>
                                                                                                <button
                                                                                                    type='button'
                                                                                                    onClick={openPostBillingRejectRemarksDialog}
                                                                                                    className='reject-button'
                                                                                                >
                                                                                                    Reject
                                                                                                </button>
                                                                                                <button
                                                                                                    type='button'
                                                                                                    className='view-button'
                                                                                                    onClick={() => getCp52DataForPostBilling()}
                                                                                                    disabled={mrcDocumentsLoading || mrcCp52Preparing}
                                                                                                >
                                                                                                    {mrcCp52Preparing
                                                                                                        ? 'Loading…'
                                                                                                        : 'GET CP 52'}
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div className='authority-footer-actions authority-footer-actions--pair'>
                                                                                                <button
                                                                                                    type='button'
                                                                                                    onClick={openPostBillingRejectRemarksDialog}
                                                                                                    className='reject-button'
                                                                                                >
                                                                                                    Reject
                                                                                                </button>
                                                                                                <button
                                                                                                    type='button'
                                                                                                    className='view-button'
                                                                                                    onClick={openPostBillingApproveRemarksDialog}
                                                                                                    disabled={mrcDocumentsLoading || mrcCp52Preparing}
                                                                                                >
                                                                                                    {mrcCp52Preparing
                                                                                                        ? 'Preparing…'
                                                                                                        : 'Prepare CP 52'}
                                                                                                </button>
                                                                                            </div>
                                                                                        )
                                                                                    ) : (
                                                                                        <div className='authority-footer-actions authority-footer-actions--pair'>
                                                                                            <button
                                                                                                type='button'
                                                                                                onClick={openPostBillingRejectRemarksDialog}
                                                                                                className='reject-button'
                                                                                            >
                                                                                                Reject
                                                                                            </button>
                                                                                            <button
                                                                                                type='button'
                                                                                                className='view-button'
                                                                                                onClick={() => getCp52DataForPostBilling()}
                                                                                                disabled={mrcDocumentsLoading || mrcCp52Preparing}
                                                                                            >
                                                                                                {mrcCp52Preparing
                                                                                                    ? 'Loading…'
                                                                                                    : 'GET CP 52'}
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                ) : null
                                                            : null
                                    }
                                            </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog >

            <MrcCp52PrepareDialog
                open={mrcCp52PrepareDialogOpen}
                onClose={handleClose}
                onOpenBill={() => openMrcBill(dialogRowData)}
                confirming={mrcCp52Posting}
                onConfirmPrepared={async () => {
                    const row = { ...(dialogRowData || {}) };
                    const formData = mrcCp52FormData;
                    const oracleTrackingId =
                        mrcCp52OracleTrackingId ||
                        extractMrcOracleTrackingId(
                            row.oracleTrackingId,
                            row.OracleTrackingId,
                            row.billAdjTrackingId,
                            row.billADJTrackingId,
                            row.trackingId
                        );
                    const posted = await postCp52ForBilling(row);
                    if (!posted) return;
                    setMrcCp52Prepared(true);
                    setMrcCp52PrepareDialogOpen(false);
                    showMrcSuccessPopup('postedForBilling');
                    await openMrcBill(row, {
                        cp52FormData: formData,
                        oracleTrackingId:
                            extractMrcOracleTrackingId(
                                posted.result,
                                posted.payload?.i_tracking_id,
                                oracleTrackingId
                            ) || oracleTrackingId,
                    });
                }}
                pdfOptions={getMrcCp52PdfOptions(dialogRowData.applicationId)}
                documents={mrcDocuments}
            />

            <Dialog
                open={Boolean(billingRemarksDialog.open)}
                onClose={closeForwardBillingRemarksDialog}
                className={`rco-remarks-dialog${billingRemarksDialog.action === 'reject'
                    ? ' rco-remarks-dialog--reject'
                    : ''
                    }`}
                maxWidth="sm"
                fullWidth
                style={{ zIndex: 1500 }}
                PaperProps={{ className: 'rco-remarks-dialog__paper' }}
            >
                <DialogTitle className="rco-remarks-dialog__title">
                    <div className="rco-remarks-dialog__header">
                        <Typography className="rco-remarks-dialog__heading">
                            {billingRemarksDialog.context === 'authority'
                                ? 'Reject — Authority Verification'
                                : billingRemarksDialog.context === 'postBilling'
                                    ? billingRemarksDialog.action === 'reject'
                                        ? 'Reject — Post for Billing'
                                        : 'Prepare CP 52'
                                    : billingRemarksDialog.action === 'reject'
                                        ? 'Revert — Forward for Billing'
                                        : 'Approve — Forward for Billing'}
                        </Typography>
                        <button
                            type="button"
                            className="rco-remarks-dialog__close"
                            onClick={closeForwardBillingRemarksDialog}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="rco-remarks-dialog__content">
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        minRows={5}
                        maxRows={8}
                        variant="outlined"
                        className="rco-remarks-dialog__textarea"
                        placeholder="Enter your remarks here (min. 10 characters)..."
                        value={billingApproveRemarks}
                        onChange={(e) => {
                            const value = e.target.value;
                            setBillingApproveRemarks(value);
                            const trimmed = value.trim();
                            if (!trimmed) {
                                setBillingRemarksDialogError("");
                            } else if (trimmed.length < 10) {
                                setBillingRemarksDialogError("Remarks must be at least 10 characters.");
                            } else {
                                setBillingRemarksDialogError("");
                            }
                        }}
                        onBlur={() => {
                            const trimmed = String(billingApproveRemarks ?? "").trim();
                            if (!trimmed) {
                                setBillingRemarksDialogError("Remarks are required.");
                            } else if (trimmed.length < 10) {
                                setBillingRemarksDialogError("Remarks must be at least 10 characters.");
                            }
                        }}
                        inputProps={{ maxLength: 250 }}
                        error={Boolean(billingRemarksDialogError)}
                    />
                    {billingRemarksDialogError ? (
                        <p className="rco-remarks-dialog__error">
                            {billingRemarksDialogError}
                        </p>
                    ) : (
                        <p className="rco-remarks-dialog__hint" style={{ margin: '6px 0 0', fontSize: '0.8rem', color: '#64748b' }}>
                            {String(billingApproveRemarks ?? '').trim().length}/250 · Minimum 10 characters
                        </p>
                    )}
                </DialogContent>
                <DialogActions className="rco-remarks-dialog__actions">
                    <button
                        type="button"
                        className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
                        onClick={closeForwardBillingRemarksDialog}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
                        onClick={confirmForwardBillingRemarksDialog}
                    >
                        {billingRemarksDialog.action === 'reject'
                            ? billingRemarksDialog.context === 'authority' ||
                              billingRemarksDialog.context === 'postBilling'
                                ? 'Reject'
                                : 'Revert'
                            : billingRemarksDialog.context === 'postBilling'
                                ? 'Prepare CP 52'
                                : 'Approve'}
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={Boolean(activeMrcResultDialog)}
                onClose={handleCloseResultPopup}
                className={`dde-result-dialog${isRejectResultPopup ? ' dde-result-dialog--reject' : ''}`}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: 'dde-result-dialog__paper' }}
            >
                {activeMrcResultDialog ? (
                    <>
                        <DialogTitle className="dde-result-dialog__title">
                            <Box className="dde-result-dialog__icon-wrap">
                                <activeMrcResultDialog.Icon className={activeMrcResultDialog.iconClassName} />
                            </Box>
                            <Typography variant="h6" className="dde-result-dialog__heading">
                                {activeMrcResultDialog.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent className="dde-result-dialog__content">
                            <DialogContentText>
                                <p className="dde-result-dialog__message">{activeResultMessage}</p>
                                {activeResultTrackingId ? (
                                    <p className="dde-result-dialog__tracking">
                                        <span className="dde-result-dialog__tracking-label">
                                            Tracking ID
                                        </span>
                                        <span className="dde-result-dialog__tracking-value">
                                            {activeResultTrackingId}
                                        </span>
                                    </p>
                                ) : null}
                                {activeMrcResultDialog.showBill ? (
                                    <Box className="dde-result-dialog__actions">
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            className="dde-result-dialog__bill-btn"
                                            onClick={() => {
                                                const ctx = resultPopupBillContextRef.current;
                                                openMrcBill(ctx?.row || dialogRowData, {
                                                    cp52FormData: ctx?.cp52FormData,
                                                    oracleTrackingId: ctx?.oracleTrackingId,
                                                });
                                            }}
                                        >
                                            <DescriptionIcon className="dde-result-dialog__bill-icon" />
                                            Bill
                                        </Button>
                                    </Box>
                                ) : null}
                            </DialogContentText>
                        </DialogContent>
                    </>
                ) : null}
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

            <RcoActivityLogDialog
                open={historyDetailPopUp}
                onClose={() => {
                    setHistoryDetailPopUp(false);
                    setHistoryData(null);
                    setHistoryReadingDocuments([]);
                    setHistoryReadingLoading(false);
                }}
                title={
                    getMrcHistoryStepName(historyData) ||
                    stepName(historyData?.historyProgressId) ||
                    "Activity Details"
                }
                variant={
                    isMrcDocumentsReuploadedHistory(historyData)
                        ? "action"
                        : Number(historyData?.objectionStatus) === 1
                            ? "action"
                            : "submitted"
                }
                maxWidth="xl"
                footer={
                    historyData
                        ? `Processed by: ${historyData?.lastModifiedBy || "-"} on: ${historyData?.lastModificationDate
                            ? convertDatewithTime(
                                historyData.lastModificationDate,
                            )
                            : "-"
                        }`
                        : null
                }
            >
                <div className="wf-application-details-body mrc-history-popup-body">
                    {historyData ? (
                        <>
                            {isMrcDocumentsReuploadedHistory(historyData) ? (
                                <p className="rco-history-status-banner rco-history-status-banner--reupload">
                                    Documents have been re-uploaded.
                                </p>
                            ) : null}
                            <div className="rco-history-details-grid rco-history-details-grid--2col">
                                <RcoHistoryField
                                    label="Step"
                                    value={
                                        getMrcHistoryStepName(historyData) ||
                                        stepName(historyData?.historyProgressId) ||
                                        "-"
                                    }
                                />
                                <RcoHistoryField
                                    label="Status"
                                    value={
                                        Number(historyData?.objectionStatus) === 1
                                            ? "Objected / Rejected"
                                            : Number(historyData?.objectionStatus) === 2
                                                ? "Resolved"
                                                : "Processed"
                                    }
                                />
                                <RcoHistoryField
                                    label="Remarks"
                                    value={historyData?.remarks || "N/A"}
                                />
                                <RcoHistoryField
                                    label="Remarks Detail"
                                    value={historyData?.remarksDetail || "N/A"}
                                />
                                {(getMrcHistoryStepName(historyData) ===
                                    "Application Submitted" ||
                                    Number(historyData?.historyProgressId) === 0 ||
                                    getMrcHistoryStepProgressId(historyData) === 0) && (
                                    <RcoHistoryField
                                        label="Submitted through"
                                        value={
                                            historyData?.submittedThrough ||
                                            dialogRowData?.submittedThrough ||
                                            "N/A"
                                        }
                                        span="full"
                                    />
                                )}
                            </div>

                            {/* History reading table hidden for now
                            <div className="mrc-history-reading-section">
                                <p className="wf-section-label">Reading Information</p>
                                {historyReadingLoading ? (
                                    <div className="authority-loading">
                                        <AppLoader onLight />
                                    </div>
                                ) : (() => {
                                    const isReuploadHistory =
                                        isMrcDocumentsReuploadedHistory(
                                            historyData,
                                        );
                                    const tableFlags =
                                        getMrcHistoryReadingTableFlags(
                                        historyData,
                                        {
                                            siteSurveyHappened:
                                                didMrcSiteSurveyHappenAtHistory(
                                                    eFileData,
                                                    historyData?.historyId,
                                                ) ||
                                                Number(
                                                    getMrcHistoryStepProgressId(
                                                        historyData,
                                                    ),
                                                ) === 3,
                                        },
                                    );
                                    const historyStepId =
                                        getMrcHistoryStepProgressId(historyData);
                                    const isApplicationSubmittedHistory =
                                        Number(historyStepId) === 0 ||
                                        getMrcHistoryStepName(historyData) ===
                                            "Application Submitted";
                                    const reuploadedDocs =
                                        isReuploadHistory
                                            ? historyReadingDocuments.filter(
                                                  (doc) =>
                                                      parseMrcIsDocumentReuploaded(
                                                          doc?.isDocumentReuploaded ??
                                                              doc?.IsDocumentReuploaded,
                                                      ),
                                              )
                                            : [];
                                    const isVerifyHistory =
                                        !isReuploadHistory &&
                                        !isApplicationSubmittedHistory &&
                                        Number(historyStepId) === 1;
                                    const isRejectHistory =
                                        Number(historyData?.objectionStatus) === 1 ||
                                        /reject/i.test(
                                            String(historyData?.remarks || "")
                                        );
                                    const tableDocuments =
                                        isReuploadHistory &&
                                        reuploadedDocs.length > 0
                                            ? reuploadedDocs
                                            : historyReadingDocuments;
                                    return (
                                        <MrcDocumentsReadingTable
                                            key={historyData?.historyId}
                                            documents={tableDocuments}
                                            meterPhaseType={
                                                dialogRowData?.meterPhaseType
                                            }
                                            applicationProgressId={
                                                historyData?.historyProgressId ??
                                                historyData?.applicationProgressId
                                            }
                                            objectionStatus={
                                                historyData?.objectionStatus
                                            }
                                            showAuthorityClaimed={
                                                tableFlags.showAuthorityClaimed
                                            }
                                            showSiteSurvey={
                                                tableFlags.showSiteSurvey
                                            }
                                            hideEvidenceStatus={
                                                isApplicationSubmittedHistory ||
                                                isReuploadHistory
                                            }
                                            evidenceRemarksMode={
                                                isReuploadHistory
                                                    ? "reupload"
                                                    : isApplicationSubmittedHistory
                                                        ? "none"
                                                        : isVerifyHistory
                                                            ? isRejectHistory
                                                                ? "verify-history-reject"
                                                                : "verify-history-accept"
                                                            : "auto"
                                            }
                                            readOnly
                                        />
                                    );
                                })()}
                            </div>
                            */}
                        </>
                    ) : null}
                </div>
            </RcoActivityLogDialog>

            <RcoActivityLogDetailDialog
                open={activityLogDetailOpen}
                onClose={() => setActivityLogDetailOpen(false)}
                historyItems={eFileData}
                currentStatus={eFileCurrentStatus || {}}
                currentProgressId={dialogRowData?.applicationProgressId}
                buildDetailRows={buildMrcActivityLogDetailRows}
                applicationDetails={{
                    applicationId: dialogRowData?.applicationId || "",
                    name:
                        dialogRowData?.consumerName ||
                        dialogRowData?.applicantName ||
                        "",
                    sanctionedLoad: dialogRowData?.sanctionedLoad ?? "",
                    tariff: resolveMrcTariffDisplay(
                        dialogRowData?.tariffCode ||
                            dialogRowData?.tariff ||
                            dialogRowData?.TARIFF_ACTIVE ||
                            "",
                        allTariffList,
                    ),
                    companyCode:
                        dialogRowData?.companyCode ||
                        dialogRowData?.discoCode ||
                        "",
                }}
                formatDateFn={convertDatewithTime}
                onStepClick={openDetailsPopUp}
                timelineType={ACTIVITY_LOG_TIMELINE_TYPES.MRC}
            />
            {/* </MrcSegregationMonthContext.Provider> */}

            {mrcValidationSnackbar}
        </>
    )
})

export default MeterReadingCorrection;
